var Ii = Object.defineProperty;
var Ai = (e, t, n) => t in e ? Ii(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ve = (e, t, n) => Ai(e, typeof t != "symbol" ? t + "" : t, n);
import { defineComponent as U, ref as q, createElementBlock as I, openBlock as g, mergeProps as me, mergeModels as ie, useModel as fe, computed as k, createBlock as P, withKeys as gt, normalizeClass as F, createElementVNode as R, createCommentVNode as E, withModifiers as Xt, toDisplayString as Y, resolveDynamicComponent as We, withCtx as G, resolveComponent as Ei, useAttrs as Ft, toValue as W, isRef as Mi, getCurrentScope as go, onScopeDispose as yo, onMounted as gn, nextTick as zi, watch as le, getCurrentInstance as yn, hasInjectionContext as xo, inject as Fi, toRef as xn, readonly as Ni, customRef as $i, shallowRef as Ie, watchEffect as Oi, unref as A, Comment as Li, Text as Di, Fragment as tt, useSlots as Fe, renderSlot as H, createVNode as re, createTextVNode as Co, shallowReadonly as Oe, useTemplateRef as Pe, withDirectives as Ae, Transition as ko, normalizeStyle as Rn, useId as Ne, vModelCheckbox as To, vModelText as So, createSlots as Io, vShow as Ao, renderList as Zt, onBeforeUnmount as Ri, Teleport as Pi } from "vue";
const Vi = "groover", Hi = 1746441930, Bi = {
  charts: {
    body: '<path fill="currentColor" d="M14.968 7.08q0-.215.093-.413.094-.198.265-.35.173-.152.397-.235c.148-.054.307-.082.468-.082h5.587c.324 0 .635.114.864.316.23.203.358.478.358.764s-.129.562-.358.764c-.23.203-.54.317-.864.317H16.19c-.16 0-.32-.028-.468-.082a1.2 1.2 0 01-.397-.235c-.113-.1-.203-.22-.265-.35a1 1 0 01-.093-.414m6.81 7.563H12a1.3 1.3 0 00-.864.316c-.23.203-.358.478-.358.764s.129.562.358.764c.229.203.54.317.864.317h9.778c.324 0 .635-.114.864-.317.23-.202.358-.477.358-.764 0-.286-.129-.561-.358-.764a1.3 1.3 0 00-.864-.316m0-4.36H12a1.3 1.3 0 00-.864.316c-.23.203-.358.478-.358.764s.129.562.358.764c.229.203.54.317.864.317h9.778c.324 0 .635-.114.864-.317.23-.202.358-.477.358-.764 0-.286-.129-.561-.358-.764a1.3 1.3 0 00-.864-.316M10.603 8.16H7.635v6.907c0 .58-.194 1.147-.559 1.629a3.26 3.26 0 01-1.489 1.08 3.7 3.7 0 01-1.917.167 3.47 3.47 0 01-1.698-.803 2.85 2.85 0 01-.908-1.501 2.62 2.62 0 01.189-1.695 3.04 3.04 0 011.221-1.316 3.64 3.64 0 011.844-.494c.295.004.589.043.873.116V7.08c0-.287.128-.562.358-.765S6.089 6 6.413 6h4.19c.324 0 .635.114.864.316.23.203.358.478.358.764s-.129.562-.358.764c-.229.203-.54.317-.864.317"/>',
    width: 24,
    height: 24
  },
  "groover-plus": {
    body: '<g fill="currentColor"><path fill-opacity="15.5%" d="m11.395 23.685-9.771-8.802-1.265-1.265a1.227 1.227 0 010-1.735L11.873.36c.257-.257.615-.387.978-.354l10.035.913A1.226 1.226 0 0124 2.14v9.586c0 .316-.122.62-.34.848L13.1 23.62a1.225 1.225 0 01-1.705.064"/><path d="M19.323 5.881H21.6v1.473h-2.277v2.254h-1.445V7.354H15.6V5.881h2.278V3.603h1.445zM14.222 17.74l-.258-1.225h-.032c-.725 1.048-1.901 1.5-3.303 1.5-1.547 0-2.868-.532-3.802-1.532-1.064-1.129-1.595-2.677-1.595-4.467 0-3.402 2.159-6.014 5.72-6.014 3.012 0 4.913 1.564 5.284 4.128H12.98c-.177-.742-.87-1.355-1.9-1.355-1.612 0-2.434 1.355-2.434 3.241s.935 3.29 2.562 3.29c1.225 0 1.82-.661 2.03-1.435h-1.53v-2.387h4.752v6.257z"/></g>',
    width: 24,
    height: 24
  },
  "groover-plus-logo": {
    body: '<path fill="currentColor" d="M20.55 5.32h3.321v2.147H20.55v3.283h-2.108V7.467h-3.32V5.32h3.32V2h2.108zM13.11 22.6l-.375-1.785h-.047C11.63 22.342 9.915 23 7.87 23c-2.256 0-4.182-.775-5.545-2.232C.776 19.123 0 16.868 0 14.259c0-4.957 3.148-8.763 8.341-8.763 4.394 0 7.166 2.279 7.707 6.015h-4.746c-.259-1.081-1.27-1.974-2.773-1.974-2.35 0-3.548 1.973-3.548 4.722s1.363 4.794 3.736 4.794c1.786 0 2.655-.964 2.96-2.091H9.445v-3.478h6.932v9.117z"/>',
    width: 24,
    height: 24
  },
  logo: {
    body: '<path xmlns="http://www.w3.org/2000/svg" fill="currentColor" d="M101.447 30.545c0 13.948-6.004 25.907-14.596 31.045a3 3 0 01-1.539.41h-15.73a3.03 3.03 0 01-1.539-.41c-4.795-2.869-8.789-7.881-11.375-14.162a.35.35 0 00-.67.056c-1.407 5.836-3.529 10.54-6.08 13.472a3.05 3.05 0 01-2.299 1.04H40.04a3.03 3.03 0 01-2.309-1.05c-3.224-3.73-5.765-10.33-7.052-18.411-.066-.42-.658-.4-.703.02-.815 7.662-2.41 13.995-4.431 17.792-.538 1.008-1.574 1.65-2.704 1.65h-3.499a3.05 3.05 0 01-2.697-1.626c-1.803-3.366-3.266-8.725-4.136-15.234-.056-.43-.673-.41-.714.021-.552 6.235-1.443 11.392-2.552 14.782C8.837 61.18 7.66 62 6.362 62h-.264c-1.352 0-2.53-.82-2.936-2.07C1.266 54.14 0 43.155 0 30.545c-.01-11.9 1.11-22.341 2.826-28.352A3.05 3.05 0 015.752 0h.87a3.06 3.06 0 012.937 2.203c.956 3.366 1.726 8.116 2.222 13.717.031.431.659.442.714.021.78-5.835 2.035-10.75 3.585-14.127C16.597.708 17.675 0 18.874 0h4.424c1.2 0 2.278.697 2.784 1.793 1.772 3.875 3.159 9.756 3.904 16.74.045.42.638.431.704.021 1.165-7.341 3.377-13.475 6.181-17.328A3.01 3.01 0 0139.323 0h9.042c.967 0 1.879.441 2.45 1.23 2.147 2.945 3.96 7.24 5.19 12.378a.353.353 0 00.673.056c2.299-5.58 5.697-10.15 9.791-13.121A3 3 0 0168.22 0H86.7c.627 0 1.245.179 1.75.553 7.722 5.612 13.002 16.93 13.002 29.992"/>',
    width: 101.45,
    height: 62
  },
  "opportunity-advice": {
    body: '<g fill="currentColor"><path d="M25.386 25.526a2.49 2.49 0 002.489-2.489v-9.55a2.49 2.49 0 00-2.489-2.49H12.492a2.49 2.49 0 00-2.49 2.49v9.55a2.49 2.49 0 002.49 2.49h.375v3.262c0 .23.139.444.358.53a.57.57 0 00.63-.12l3.672-3.673zm-11.358-.577a.58.58 0 00-.578-.578h-.952c-.734 0-1.334-.6-1.334-1.334v-9.55c0-.734.6-1.335 1.334-1.335h12.894c.734 0 1.334.601 1.334 1.334v9.551c0 .734-.6 1.334-1.334 1.334h-8.095a.6.6 0 00-.22.046.6.6 0 00-.19.127l-2.853 2.853v-2.442z"/><path d="M33.505 18.643H29.21a.58.58 0 00-.578.577c0 .318.26.578.578.578h4.296c.733 0 1.334.6 1.334 1.334v9.55c0 .734-.6 1.335-1.334 1.335h-.953a.58.58 0 00-.577.577v2.443l-2.853-2.853a.55.55 0 00-.19-.127.6.6 0 00-.22-.046h-8.095c-.734 0-1.334-.6-1.334-1.334v-3.823a.58.58 0 00-.578-.577.58.58 0 00-.577.577v3.823a2.49 2.49 0 002.489 2.489h7.859l3.672 3.672a.581.581 0 00.988-.41v-3.262h.375A2.49 2.49 0 0036 30.677v-9.551a2.49 2.49 0 00-2.489-2.489z"/><path d="M32.553 27.715H21.09a.58.58 0 00-.577.577c0 .318.26.578.577.578h11.463a.58.58 0 00.577-.578.58.58 0 00-.578-.577m-3.343-1.235h3.343a.58.58 0 00.578-.578.58.58 0 00-.578-.578H29.21a.58.58 0 00-.577.578c0 .317.26.577.577.577m-.001-2.385h3.343a.58.58 0 00.578-.577.58.58 0 00-.578-.578H29.21a.58.58 0 00-.577.578c0 .317.26.577.577.577M12.273 9.549a.58.58 0 00.577-.578V6.39a.58.58 0 00-.577-.577.58.58 0 00-.578.577v2.58c0 .318.26.578.578.578M7.815 7.995a.575.575 0 10-.814.814l1.825 1.825a.59.59 0 00.82 0 .575.575 0 000-.814L7.82 7.995zm.155 4.701H5.39a.58.58 0 00-.578.577c0 .318.26.578.577.578h2.582a.58.58 0 00.577-.578.58.58 0 00-.577-.577m10.971 8.748 2.223 1.172a.6.6 0 00.272.064.578.578 0 00.572-.676l-.428-2.477 1.802-1.756a.58.58 0 00-.324-.987l-2.489-.364-1.114-2.252c-.196-.393-.843-.393-1.034 0l-1.114 2.252-2.489.364a.58.58 0 00-.468.393.58.58 0 00.145.594l1.801 1.756-.427 2.477a.58.58 0 00.231.566.59.59 0 00.606.046l2.224-1.172zm-2.795-3.684 1.629-.237a.56.56 0 00.433-.318l.727-1.478.728 1.478a.58.58 0 00.433.318l1.628.237-1.178 1.149a.58.58 0 00-.167.514l.277 1.622-1.455-.768a.59.59 0 00-.537 0l-1.455.768.277-1.622a.57.57 0 00-.167-.514l-1.178-1.15z"/></g>'
  },
  "opportunity-article": {
    body: '<g fill="currentColor"><path d="M33.848 5.839H8.155A3.156 3.156 0 005.004 8.99v24.202a3.156 3.156 0 003.152 3.151h25.692A3.156 3.156 0 0037 33.194V8.99a3.16 3.16 0 00-3.152-3.152M8.155 6.899h25.691c1.153 0 2.091.94 2.091 2.092v1.48H6.064v-1.48c0-1.154.938-2.092 2.09-2.092m25.693 28.387H8.155a2.093 2.093 0 01-2.092-2.092V11.531H35.94v21.662a2.094 2.094 0 01-2.091 2.093"/><path d="M8.677 9.423h1.862a.53.53 0 100-1.06H8.677a.53.53 0 100 1.06m4.535 0h1.861a.53.53 0 100-1.06h-1.86a.53.53 0 100 1.06m4.537 0h1.861a.53.53 0 100-1.06h-1.86a.53.53 0 100 1.06m15.791 4.025H8.46a.53.53 0 00-.53.53v5.77c0 .293.238.53.53.53h25.084a.53.53 0 00.53-.53V13.98a.53.53 0 00-.532-.531m-.528 5.77H8.99v-4.71h24.022zm.528 6.017h-7.165a.53.53 0 00-.53.53v7.164c0 .293.237.53.53.53h7.165a.53.53 0 00.53-.53l.001-7.164a.53.53 0 00-.531-.53m-.529 7.166H26.91v-6.105h6.105zm.529-9.984H8.46a.53.53 0 100 1.06h25.084a.53.53 0 10-.002-1.06M22.84 25.617H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06m0 3.203H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06m0 3.199H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06"/></g>'
  },
  "opportunity-audio-interview": {
    body: '<g fill="currentColor"><path d="M12.886 17.76a.66.66 0 00.065-.931 3.9 3.9 0 01-.953-2.567c0-.948.339-1.86.953-2.567a.66.66 0 10-.996-.865 5.23 5.23 0 00-1.275 3.432c0 1.267.452 2.485 1.275 3.432a.656.656 0 00.93.064zm17.203-6.93a.66.66 0 00-.995.866c.614.707.953 1.619.953 2.567s-.34 1.86-.953 2.567a.66.66 0 00.996.866 5.23 5.23 0 001.276-3.432 5.23 5.23 0 00-1.276-3.432z"/><path d="M32.094 9.114a.66.66 0 10-1.001.859 6.58 6.58 0 011.588 4.29 6.58 6.58 0 01-1.588 4.29.66.66 0 001.001.86 7.906 7.906 0 000-10.298M9.361 14.263c0-1.576.564-3.098 1.587-4.29a.66.66 0 00-1-.859 7.9 7.9 0 00-1.906 5.149c0 1.89.678 3.719 1.906 5.149a.659.659 0 101-.86 6.58 6.58 0 01-1.587-4.29zm19.571 6.952a.66.66 0 00-.659.66 4.813 4.813 0 01-4.808 4.807H18.58a4.813 4.813 0 01-4.808-4.808.659.659 0 10-1.317 0A6.133 6.133 0 0018.579 28h1.784v2.637h-3.296a1.98 1.98 0 00-1.977 1.977 1.98 1.98 0 001.977 1.978h7.91a1.98 1.98 0 001.977-1.978 1.98 1.98 0 00-1.977-1.977h-3.296V28h1.783a6.133 6.133 0 006.127-6.126.66.66 0 00-.66-.659m-3.296 11.399a.66.66 0 01-.66.659h-7.91a.66.66 0 010-1.318h7.91a.66.66 0 01.66.659"/><path d="M18.579 25.363h4.886a3.493 3.493 0 003.489-3.49V10.397a3.493 3.493 0 00-3.489-3.489h-4.887a3.493 3.493 0 00-3.488 3.49v11.477a3.493 3.493 0 003.488 3.489m0-17.139h4.886c1.198 0 2.172.974 2.172 2.17v1.125h-1.978a.659.659 0 100 1.318h1.978v2.636h-1.978a.658.658 0 100 1.317h1.978v2.637h-1.978a.659.659 0 100 1.317h1.978v1.125a2.174 2.174 0 01-2.172 2.171h-4.887a2.173 2.173 0 01-2.17-2.171v-1.125h1.978a.66.66 0 000-1.317h-1.978V16.79h1.978a.66.66 0 000-1.317h-1.978v-2.636h1.978a.66.66 0 000-1.318h-1.978v-1.124c0-1.198.974-2.17 2.17-2.17"/></g>'
  },
  "opportunity-channel": {
    body: '<g fill="currentColor" stroke="currentColor" stroke-width=".1"><path d="M6.526 29.012H35.78l.003.004h.02c.56 0 1.011-.455 1.011-1.011V8.019c0-.56-.455-1.01-1.01-1.01H6.526c-.56 0-1.01.455-1.01 1.01v19.982c0 .56.454 1.011 1.01 1.011Zm29.12-20.84v19.677H6.68V8.172z"/><path d="M17.614 22.685h.05v-.005a.6.6 0 00.24-.076l7.094-4.094a.584.584 0 000-1.008l-7.093-4.094a.584.584 0 00-.873.504v8.192c0 .21.113.4.29.504h.001a.6.6 0 00.29.077Zm.581-7.769 5.349 3.09-5.349 3.09zm-4.763 19.549H36.23a.581.581 0 100-1.163H13.432a.581.581 0 100 1.163Zm-7.335 0h3.215a.581.581 0 100-1.163H6.097a.581.581 0 100 1.163Z"/><path d="M8.734 33.883a2.64 2.64 0 002.638 2.637 2.643 2.643 0 002.638-2.637 2.643 2.643 0 00-2.638-2.638 2.643 2.643 0 00-2.638 2.638Zm1.164-.004c0-.812.661-1.474 1.474-1.474s1.474.662 1.474 1.474c0 .813-.662 1.474-1.474 1.474a1.476 1.476 0 01-1.474-1.474Z"/></g>'
  },
  "opportunity-detailed-feedback": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="M33.011 24.616A1.397 1.397 0 0034.4 23.22v-7.905a1.396 1.396 0 00-1.388-1.397H19.573a1.397 1.397 0 00-1.388 1.397V25.96c.32-.043.961-.37 1.575-.682.662-.338 1.295-.66 1.64-.66zm-5.049-5.349-3.64-2.115v4.23zm.75-.261a.303.303 0 010 .522l-4.521 2.627a.3.3 0 01-.169.052.3.3 0 01-.3-.302v-5.276a.3.3 0 01.041-.15.3.3 0 01.41-.11zm-2.12 6.215v7.275A1.503 1.503 0 0125.1 34H10.67a1.505 1.505 0 01-1.494-1.504V7.384a1.503 1.503 0 011.494-1.503h14.429a1.505 1.505 0 011.494 1.504v5.927h6.418c.546 0 1.043.225 1.403.588.362.365.586.865.586 1.414v7.906c0 .549-.224 1.049-.584 1.412a1.98 1.98 0 01-1.405.59zm-.6-11.909V7.384a.9.9 0 00-.893-.898H10.67a.9.9 0 00-.893.899v25.111a.9.9 0 00.893.9h14.429a.9.9 0 00.893-.899V25.22H21.4c-.206 0-.776.29-1.372.594-.72.368-1.476.753-1.908.753-.337 0-.537-.15-.537-.516V15.314a2 2 0 01.584-1.412c.362-.365.86-.59 1.405-.59zM15.748 9.014a.302.302 0 010-.605h4.27a.302.302 0 010 .605z"/><path fill="currentColor" fill-rule="evenodd" d="M33.778 23.995c.199-.2.32-.474.32-.776v-7.905a1.096 1.096 0 00-1.087-1.097H19.573a1.1 1.1 0 00-1.088 1.097v10.241q.113-.045.253-.109c.27-.123.577-.28.885-.436l.008-.004c.326-.167.656-.335.949-.461.282-.122.579-.229.82-.229h11.611c.299 0 .57-.123.767-.32m-15.293 1.881a1.5 1.5 0 01-.3.082V15.315a1.397 1.397 0 011.388-1.397H33.01a1.396 1.396 0 011.388 1.397v7.906a1.397 1.397 0 01-1.388 1.396H21.4c-.345 0-.978.323-1.64.66h-.001c-.458.234-.931.476-1.275.6m7.244 7.256a.9.9 0 01-.63.263H10.67a.9.9 0 01-.893-.899V7.384a.9.9 0 01.893-.898h14.429a.9.9 0 01.893.899v5.927h-6.42c-.544 0-1.042.225-1.404.59a2 2 0 00-.584 1.412v10.738c0 .366.2.516.537.516.432 0 1.187-.385 1.907-.752h.001c.596-.304 1.166-.595 1.372-.595h4.59v7.275a.9.9 0 01-.262.636m-.038-7.61v6.974a.6.6 0 01-.592.6H10.67a.6.6 0 01-.593-.599V7.383a.6.6 0 01.593-.598h14.429a.6.6 0 01.593.599v5.627h-6.12c-.629 0-1.201.26-1.617.678a2.3 2.3 0 00-.671 1.624v10.738c0 .236.066.46.24.618.17.153.39.198.597.198.284 0 .631-.12.964-.263.342-.146.718-.337 1.074-.519l.007-.003c.299-.153.584-.298.82-.406a4 4 0 01.296-.122c.076-.027.11-.032.117-.034h4.292m-1.368-9.413c.088.051 4.703 2.763 4.758 2.857a.603.603 0 01-.219.821L24.35 22.41a.602.602 0 01-.927-.505v-5.282a.6.6 0 01.08-.294m.689 5.826 4.52-2.627a.303.303 0 000-.522l-4.538-2.638a.3.3 0 00-.41.11.3.3 0 00-.041.151v5.276a.302.302 0 00.469.25m.132-6.046a.6.6 0 00-.82.22ZM9.616 33.559a1.5 1.5 0 01-.44-1.063V7.384a1.503 1.503 0 011.494-1.503h14.429a1.505 1.505 0 011.494 1.504v5.927h6.418c.546 0 1.043.225 1.403.588.362.365.586.865.586 1.414v7.906c0 .549-.224 1.049-.584 1.412a1.98 1.98 0 01-1.405.59h-6.419v7.274A1.503 1.503 0 0125.1 34H10.67c-.41 0-.783-.169-1.054-.441m17.276-8.038v6.975c0 .496-.201.947-.525 1.273a1.8 1.8 0 01-1.268.531H10.67a1.806 1.806 0 01-1.794-1.804V7.384a1.803 1.803 0 011.794-1.803h14.429a1.806 1.806 0 011.794 1.804v5.627h6.118c.63 0 1.203.26 1.616.677.415.418.673.993.673 1.625v7.906a2.3 2.3 0 01-.671 1.623 2.28 2.28 0 01-1.618.678zm-2.57-8.369v4.23l3.64-2.115zm.3.521 2.743 1.594-2.742 1.593zM15.75 9.315a.602.602 0 010-1.205h4.27a.602.602 0 010 1.205zm-.3-.602c0 .167.135.302.3.302h4.27a.302.302 0 000-.605h-4.27c-.165 0-.3.136-.3.303" clip-rule="evenodd"/><path fill="currentColor" d="M19 31a1 1 0 11-2 0 1 1 0 012 0"/></g>'
  },
  "opportunity-dj-set": {
    body: '<g fill="currentColor"><path d="M18.616 13.769a7.23 7.23 0 107.23 7.23 7.243 7.243 0 00-7.23-7.23m0 13.184a5.954 5.954 0 115.953-5.954 5.96 5.96 0 01-5.953 5.954"/><path d="M18.616 18.447a2.553 2.553 0 100 5.105 2.553 2.553 0 000-5.105m0 3.829a1.276 1.276 0 110-2.553 1.276 1.276 0 010 2.553"/><path d="M34.92 7.478h-1.972a2.086 2.086 0 00-2.08 2.086v4.352a2.08 2.08 0 002.08 2.08h.344v1.06a2.73 2.73 0 01-1.276 2.22A13.438 13.438 0 1032.138 21v-.293l.638-.383a3.83 3.83 0 001.831-3.267v-1.06h.351A2.08 2.08 0 0037 13.916V9.564a2.087 2.087 0 00-2.08-2.086M18.616 33.245A12.245 12.245 0 1130.804 20.01l-1.276.779a2.074 2.074 0 10.65 1.097l.639-.395a12.25 12.25 0 01-12.201 11.754M28.96 22.339a.804.804 0 11-1.608 0 .804.804 0 011.608 0m6.764-8.423a.81.81 0 01-.804.804h-1.972a.804.804 0 01-.804-.804V9.564a.804.804 0 01.804-.81h1.972a.81.81 0 01.804.81z"/><path d="M21.213 12.149a.639.639 0 10-.364 1.225c.602.179 1.18.427 1.723.74a.64.64 0 00.32.083.64.64 0 00.555-.32.64.64 0 00-.236-.867 9.4 9.4 0 00-1.998-.861"/><path d="M13.339 12.48a.64.64 0 00.319-.083 9.93 9.93 0 019.91 0 .64.64 0 00.867-.236.64.64 0 00-.197-.867 11.3 11.3 0 00-8.462-1.143c-.964.257-1.891.639-2.756 1.136a.638.638 0 00.319 1.187zm5.277 17.74a.638.638 0 000-1.276 7.9 7.9 0 01-3.95-1.06.639.639 0 10-.638 1.104 9.17 9.17 0 004.588 1.232"/><path d="M23.6 29.601a9.93 9.93 0 01-9.91 0 .638.638 0 00-.639 1.104c.855.497 1.771.881 2.725 1.142a11.2 11.2 0 008.462-1.142.638.638 0 00-.639-1.104"/></g>'
  },
  "opportunity-live-events": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="M35.878 22.982a.32.32 0 00.322-.323V18.1a.32.32 0 00-.322-.323h-3.223l-.334-.718c-.072-.168-.263-.227-.43-.156a1.627 1.627 0 01-2.148-.801 1.64 1.64 0 01-.048-1.256c.155-.407.442-.718.836-.898a.28.28 0 00.167-.18.3.3 0 00-.012-.25L28.764 9.39a.31.31 0 00-.43-.155L23.048 11.7h-.012L5.383 19.907a.33.33 0 00-.155.431l1.91 4.127c.071.168.262.228.43.156a1.624 1.624 0 012.147.802c.18.394.203.837.06 1.244-.143.406-.441.73-.835.92a.33.33 0 00-.155.432l1.91 4.14c.035.07.095.143.178.167.036.011.072.023.108.023a.24.24 0 00.13-.035l1.875-.874h22.892a.32.32 0 00.322-.323V26.56a.32.32 0 00-.322-.323c-.895 0-1.611-.73-1.611-1.627s.727-1.627 1.61-1.627m-24.742 8.602L9.488 28.02a2.24 2.24 0 00.883-1.125 2.3 2.3 0 00-.072-1.735 2.25 2.25 0 00-2.697-1.22l-1.647-3.565 17.067-7.956.43.921c.06.12.167.192.287.192a.24.24 0 00.13-.036c.156-.072.228-.263.156-.431l-.43-.921 4.727-2.202 1.659 3.566a2.23 2.23 0 00-.883 1.1 2.25 2.25 0 00.071 1.759 2.284 2.284 0 002.697 1.22l1.66 3.566-4.727 2.2-.43-.92a.32.32 0 00-.43-.156c-.154.072-.226.263-.154.43l.43.922zm22.486-6.975a2.27 2.27 0 001.934 2.25v3.935H14.37l14.394-6.7h.012l.012-.011 5.3-2.465c.071-.036.143-.096.166-.18a.37.37 0 00-.011-.25l-1.29-2.764h2.602v3.936a2.27 2.27 0 00-1.933 2.249"/><path fill="currentColor" d="M24.695 14.5a.31.31 0 00-.43-.155.33.33 0 00-.155.43l.56 1.22c.06.12.168.192.287.192a.24.24 0 00.131-.036.33.33 0 00.156-.43zm1.23 2.656a.31.31 0 00-.43-.156.33.33 0 00-.155.43l.56 1.221c.06.12.168.192.287.192a.24.24 0 00.131-.036.33.33 0 00.155-.431zm1.215 2.643a.32.32 0 00-.429-.156.33.33 0 00-.155.43l.56 1.221c.06.12.168.191.287.191a.24.24 0 00.132-.035.33.33 0 00.155-.431zm-7.196 2.058 1.456-2.62a.31.31 0 00-.048-.37.31.31 0 00-.37-.072l-2.71 1.256-2.04-2.201a.31.31 0 00-.37-.072.306.306 0 00-.18.335l.359 2.979-2.71 1.268a.306.306 0 00-.178.335.304.304 0 00.262.275l2.936.574.358 2.98c.012.143.12.25.263.274h.06c.119 0 .226-.06.286-.167l1.456-2.62 2.936.574a.33.33 0 00.346-.155.31.31 0 00-.047-.371zM18.63 23.33a.33.33 0 00-.346.155l-1.086 1.962-.263-2.225a.305.305 0 00-.262-.275l-2.197-.43 2.03-.946a.306.306 0 00.178-.335l-.262-2.225 1.528 1.64c.095.107.25.13.37.07l2.029-.944-1.087 1.962a.31.31 0 00.048.37l1.516 1.64z"/><path fill="currentColor" fill-rule="evenodd" d="M31.891 16.904c.167-.071.358-.012.43.156l.334.718h3.223a.32.32 0 01.322.323v4.558a.32.32 0 01-.322.323c-.883 0-1.611.73-1.611 1.627s.716 1.627 1.61 1.627c.18 0 .323.144.323.323v4.558a.32.32 0 01-.322.323H12.986l-1.874.874a.24.24 0 01-.131.035.4.4 0 01-.108-.023c-.083-.024-.143-.096-.179-.168l-1.91-4.14a.33.33 0 01.156-.43 1.624 1.624 0 00.775-2.166 1.624 1.624 0 00-2.148-.801c-.167.072-.358.012-.43-.156l-1.91-4.127a.33.33 0 01.156-.43L23.035 11.7h.012l5.288-2.464a.31.31 0 01.43.155l1.92 4.128a.3.3 0 01.013.25.28.28 0 01-.167.18c-.394.18-.68.49-.836.898-.155.406-.131.861.048 1.256a1.627 1.627 0 002.148.801m-1.966-.885a1.43 1.43 0 001.883.703l.005-.002c.25-.108.567-.025.69.258l.28.6h3.095a.52.52 0 01.522.523v4.558c0 .29-.233.523-.522.523-.772 0-1.411.64-1.411 1.427 0 .788.628 1.427 1.41 1.427.29 0 .523.233.523.523v4.558c0 .29-.233.524-.522.524H13.03l-1.822.85a.45.45 0 01-.227.059.5.5 0 01-.165-.032l-.003-.001a.5.5 0 01-.298-.27l-.003-.005-1.911-4.144a.53.53 0 01.253-.691c.348-.17.608-.453.733-.807a1.46 1.46 0 00-.054-1.094 1.424 1.424 0 00-1.883-.703l-.004.002c-.251.108-.568.025-.691-.258l-1.911-4.13a.53.53 0 01.255-.692m24.625-3.706a1.44 1.44 0 01-.042-1.1c.137-.36.386-.63.73-.786a.48.48 0 00.274-.296.5.5 0 00-.016-.397l-1.923-4.131a.51.51 0 00-.699-.254L23.003 11.5h-.012L5.3 19.725m5.073 7.17a2.23 2.23 0 01-.883 1.124l1.647 3.565 17.08-7.956-.43-.921a.33.33 0 01.155-.43.32.32 0 01.43.155l.43.92 4.726-2.2-1.66-3.566a2.284 2.284 0 01-2.697-1.22 2.25 2.25 0 01-.072-1.759c.168-.454.478-.837.884-1.1l-1.66-3.566-4.726 2.202.43.921a.33.33 0 01-.155.43.24.24 0 01-.131.037.32.32 0 01-.287-.192l-.43-.921-17.067 7.956 1.647 3.565a2.25 2.25 0 012.697 1.22 2.3 2.3 0 01.072 1.735m-2.658-3.193a2.45 2.45 0 012.768 1.374 2.5 2.5 0 01.079 1.885c-.162.45-.447.842-.82 1.125l1.492 3.231L27.95 23.53l-.347-.745a.53.53 0 01.252-.69.52.52 0 01.698.25l.345.74 4.364-2.032-1.505-3.232a2.49 2.49 0 01-2.766-1.37l-.001-.001a2.45 2.45 0 01-.078-1.914c.162-.44.447-.819.818-1.098l-1.503-3.231-4.364 2.032.348.745a.53.53 0 01-.242.685.44.44 0 01-.229.061.52.52 0 01-.465-.302l-.002-.005-.345-.74L6.22 20.471zm21.062.393h-.012l-14.394 6.7h21.186v-3.937a2.27 2.27 0 01-1.934-2.249 2.27 2.27 0 011.934-2.25v-3.935h-2.602l1.289 2.763a.37.37 0 01.011.252c-.023.083-.095.143-.167.18l-5.299 2.464zm.129.154c-.022.01-.229.122-.229.122l-13.4 6.223h20.08v-3.568a2.47 2.47 0 01-1.934-2.417c0-1.188.834-2.177 1.934-2.417v-3.568h-2.088l1.159 2.484m.02.386a.5.5 0 01-.27.303l-.005.003-5.267 2.45m-4.795-9.475a.33.33 0 01.155-.43.31.31 0 01.43.155l.549 1.22a.33.33 0 01-.156.431.24.24 0 01-.13.036.32.32 0 01-.287-.191zm1.075 1.552a.44.44 0 01-.228.06.52.52 0 01-.465-.302l-.003-.005-.563-1.226a.53.53 0 01.252-.69.51.51 0 01.7.255l.55 1.223a.53.53 0 01-.243.685m.716 2.324-.561-1.22a.33.33 0 01.155-.43.31.31 0 01.43.155l.549 1.22a.33.33 0 01-.156.43.24.24 0 01-.13.037.32.32 0 01-.287-.192m.514.331a.53.53 0 00.242-.685l-.55-1.222a.51.51 0 00-.699-.256.53.53 0 00-.252.69l.563 1.226.003.006c.088.177.26.302.465.302a.44.44 0 00.228-.06m.907.733.001.001.55 1.224a.53.53 0 01-.242.685.44.44 0 01-.228.06.52.52 0 01-.465-.301l-.003-.006-.563-1.225a.53.53 0 01.252-.69.52.52 0 01.698.252m-.611-.072a.32.32 0 01.43.155l.549 1.22a.33.33 0 01-.155.431.24.24 0 01-.132.036.32.32 0 01-.286-.191l-.561-1.22a.33.33 0 01.155-.431m-5.729-.848a.31.31 0 01.37.071c.096.096.12.252.048.371l-1.456 2.62 2.065 2.202a.306.306 0 01.047.37.33.33 0 01-.346.156l-2.936-.574-1.456 2.62a.32.32 0 01-.286.168h-.06a.305.305 0 01-.263-.276l-.358-2.979-2.936-.574a.305.305 0 01-.262-.275.306.306 0 01.179-.335l2.709-1.268-.358-2.98a.306.306 0 01.179-.334.31.31 0 01.37.072l2.04 2.2zm-2.661 1.013-1.941-2.093a.51.51 0 00-.6-.12m2.54 2.213 2.58-1.196a.51.51 0 01.598.117.51.51 0 01.075.608l-1.383 2.49 1.962 2.092a.51.51 0 01.076.614.53.53 0 01-.55.25l-.006-.001-2.794-.547-1.385 2.493a.52.52 0 01-.461.27h-.077l-.016-.002a.505.505 0 01-.429-.452l-.34-2.83-2.79-.547a.505.505 0 01-.426-.447.506.506 0 01.294-.542l2.577-1.206-.34-2.831a.506.506 0 01.294-.546m2.89 5.537 1.598.305-1.1-1.19a.51.51 0 01-.077-.61l.787-1.42-1.47.685a.51.51 0 01-.604-.118l-1.11-1.19.19 1.614a.506.506 0 01-.293.544l-1.47.685 1.59.312a.505.505 0 01.425.452l.19 1.605.788-1.425a.53.53 0 01.55-.25zm-1.47 2.314-.263-2.225a.305.305 0 00-.262-.275l-2.197-.43 2.03-.946a.306.306 0 00.178-.335l-.262-2.225 1.528 1.64c.095.107.25.13.37.07l2.029-.944-1.087 1.962a.31.31 0 00.048.37l1.516 1.64-2.196-.419a.33.33 0 00-.346.155z" clip-rule="evenodd"/><path fill="currentColor" d="M34.204 21.818c.352-.198.293-.558.22-.714l-2.388.714-3.486 2.607c1.738-.786 5.303-2.41 5.654-2.607"/></g>'
  },
  "opportunity-management-deal": {
    body: '<g fill="currentColor"><path d="M14.14 35.264h-3.533a1.735 1.735 0 01-1.767-1.766V8.767C8.84 7.765 9.606 7 10.607 7h14.132c1 0 1.766.765 1.766 1.767V12.3c0 .353-.235.588-.589.588-.353 0-.588-.235-.588-.588V8.767c0-.354-.236-.59-.59-.59h-14.13c-.354 0-.59.236-.59.59v24.73c0 .354.236.59.59.59h3.533c.353 0 .588.235.588.588 0 .354-.235.59-.588.59"/><path d="M22.972 36.442a11.183 11.183 0 01-11.188-11.188 11.183 11.183 0 0111.188-11.188A11.183 11.183 0 0134.16 25.254a11.183 11.183 0 01-11.188 11.188m0-21.198a10 10 0 00-10.01 10.01c0 5.535 4.475 10.01 10.01 10.01s10.01-4.475 10.01-10.01-4.475-10.01-10.01-10.01m-2.709-4.711h-5.24c-.825 0-1.531-.53-1.708-1.354L12.785 7h9.775l-.53 2.179c-.236.824-.942 1.354-1.767 1.354m-5.947-2.355.177.706c.059.236.294.471.589.471h5.24c.295 0 .53-.176.59-.47l.117-.707z"/><path d="M19.145 33.203a2.916 2.916 0 01-2.945-2.944 2.916 2.916 0 012.945-2.945 2.916 2.916 0 012.944 2.945 2.916 2.916 0 01-2.944 2.944m0-4.71a1.735 1.735 0 00-1.767 1.766c0 1 .766 1.766 1.767 1.766a1.735 1.735 0 001.766-1.766 1.735 1.735 0 00-1.766-1.767m7.655 1.767a2.916 2.916 0 01-2.945-2.944A2.916 2.916 0 0126.8 24.37a2.916 2.916 0 012.945 2.944 2.916 2.916 0 01-2.945 2.944m0-4.71a1.735 1.735 0 00-1.767 1.766c0 1 .765 1.766 1.766 1.766a1.735 1.735 0 001.767-1.766 1.735 1.735 0 00-1.767-1.767"/><path d="M22.089 30.259H20.91v-9.245l8.833-2.767v9.068h-1.178v-7.42l-6.477 1.944z"/></g>'
  },
  "opportunity-permanent-social-media-share": {
    body: '<g fill="currentColor"><path d="M13.089 14.625a.62.62 0 00.62-.621v-1.76c0-.932.76-1.69 1.69-1.69h4.935a.62.62 0 00.622-.622.62.62 0 00-.622-.621h-4.968a2.915 2.915 0 00-2.897 2.897v1.76c.033.38.274.657.62.657m15.045 6.52a.62.62 0 00-.621.621v9.524H13.71v-2.38a.62.62 0 00-.62-.622.62.62 0 00-.622.621v5.14a2.915 2.915 0 002.897 2.898H25.82a2.915 2.915 0 002.898-2.897l.001-12.284c0-.345-.241-.621-.586-.621M25.856 35.74H15.368c-.931 0-1.69-.76-1.69-1.69v-1.553h13.835v1.553c0 .93-.76 1.69-1.657 1.69"/><path d="M21.924 33.496H19.3a.62.62 0 00-.621.621c0 .346.276.622.621.622h2.623a.62.62 0 00.621-.622.62.62 0 00-.621-.62M34.377 5.895h-9.522a2.62 2.62 0 00-2.623 2.623v7.314a2.63 2.63 0 002.553 2.623v2.38c0 .241.138.448.38.552a.6.6 0 00.241.035c.138 0 .31-.068.414-.172l3.037-2.83h5.52A2.62 2.62 0 0037 15.799v-7.28a2.62 2.62 0 00-2.623-2.623m1.415 9.937a1.4 1.4 0 01-1.415 1.415l-5.761-.001a.64.64 0 00-.414.172l-2.208 2.035v-1.587a.62.62 0 00-.621-.622h-.553a1.4 1.4 0 01-1.415-1.415l.002-7.311a1.4 1.4 0 011.415-1.415h9.523a1.4 1.4 0 011.415 1.415l-.002 7.314zM15.816 28.527a.7.7 0 00.241-.07.61.61 0 00.346-.552v-2.139a2.63 2.63 0 002.552-2.622v-4.59a2.62 2.62 0 00-2.623-2.622l-9.487.001a2.62 2.62 0 00-2.622 2.623v4.588a2.62 2.62 0 002.622 2.622h5.556l3.037 2.623c.102.103.24.138.378.138m-.587-3.348v1.449L13.02 24.73a.52.52 0 00-.38-.137l-5.796-.002c-.793-.033-1.415-.654-1.415-1.448v-4.59a1.4 1.4 0 011.415-1.415h9.524a1.4 1.4 0 011.415 1.415l-.001 4.59a1.4 1.4 0 01-1.416 1.415h-.552c-.31 0-.586.275-.586.62"/><path d="M32.825 8.862c-.931-.655-2.347-.553-3.243.276a2.47 2.47 0 00-1.966-.725c-.725.068-1.415.449-1.83 1.035-.654.931-.517 2.45.346 3.313l3.037 3.036a.64.64 0 00.413.173.64.64 0 00.414-.173l3.14-3.14a2.47 2.47 0 00.725-1.966c-.035-.726-.415-1.382-1.036-1.83m-.518 2.966-2.725 2.692-2.623-2.623c-.448-.45-.552-1.277-.207-1.725a1.4 1.4 0 01.966-.553h.104c.345 0 .655.137.931.38l.45.449a.64.64 0 00.413.172.57.57 0 00.414-.172l.38-.38c.449-.449 1.276-.553 1.725-.208.31.242.517.553.553.967 0 .346-.138.725-.38 1.001m-24.703 8.25h8.004a.62.62 0 00.621-.622.62.62 0 00-.621-.621H7.605a.62.62 0 00-.622.621c.035.345.277.622.622.622m8.591 2.173a.62.62 0 00-.622-.621l-7.97.001a.62.62 0 00-.62.622c0 .345.276.62.62.62h8.005c.31-.034.586-.31.586-.622"/></g>'
  },
  "opportunity-publishing-deal": {
    body: '<g fill="currentColor"><path d="M21.22 33.364a6.203 6.203 0 006.199-6.199 6.203 6.203 0 00-6.199-6.199 6.203 6.203 0 00-6.199 6.2 6.2 6.2 0 006.199 6.198m0-11.27a5.08 5.08 0 015.072 5.071 5.08 5.08 0 01-5.072 5.072 5.08 5.08 0 01-5.072-5.072 5.08 5.08 0 015.072-5.071"/><path d="M9.386 19.84v15.604L8 37.163c-.276.338-.327.8-.14 1.195.185.394.58.642 1.013.642H33.58a1.12 1.12 0 001.014-.637c.192-.394.14-.85-.13-1.189l-1.408-1.78V19.84c0-.93-.761-1.69-1.691-1.69H11.077c-.93 0-1.69.76-1.69 1.69m24.198 18.033H8.874l1.363-1.69h22l1.342 1.69zM31.928 19.84v15.215H10.513V19.84c0-.31.254-.564.564-.564h20.287c.31 0 .564.254.564.564"/><path d="M19.23 29.9a.56.56 0 00.553.022l4.508-2.254a.563.563 0 000-1.003l-4.508-2.255a.57.57 0 00-.547.023.56.56 0 00-.265.479v4.508c0 .197.102.378.265.48zm.863-4.075 2.682 1.341-2.682 1.341zm1.69-11.057V6.315l.677.901.901-.676-1.69-2.254c-.215-.282-.688-.282-.902 0l-1.69 2.254.901.676.676-.901v8.453zm4.582.327 3.601-7.016.192 1.11 1.11-.191-.474-2.779a.56.56 0 00-.298-.405.54.54 0 00-.502 0l-2.536 1.234.496 1.014 1.015-.496-3.601 7.016 1.003.513zm9.991-4.255-2.79.39.159 1.115 1.115-.158-3.595 3.579.795.8 3.595-3.579-.163 1.116 1.115.164.406-2.79a.56.56 0 00-.158-.479.58.58 0 00-.479-.163zM14.982 7.042l-2.536-1.234a.555.555 0 00-.8.406l-.474 2.778 1.11.191.192-1.11 3.6 7.016 1.004-.513-3.601-7.016 1.014.496.496-1.014zm-9.378 3.956a.56.56 0 00-.157.479l.405 2.79 1.116-.164-.163-1.116 3.595 3.579.795-.8-3.596-3.579 1.116.158.158-1.116-2.79-.389a.55.55 0 00-.479.164zm24.069 21.803H30.8v1.127h-1.127zm-2.254 0h1.127v1.127h-1.127zm-15.779 0h3.381v1.127H11.64z"/></g>'
  },
  "opportunity-radio-broadcast": {
    body: '<path fill="currentColor" fill-rule="evenodd" d="M8.518 31.872A1.73 1.73 0 017 30.152V19.089a14.43 14.43 0 014.237-10.214 14.48 14.48 0 0110.23-4.231h.066c3.837 0 7.517 1.521 10.23 4.231A14.43 14.43 0 0136 19.09v11.065c0 .882-.66 1.611-1.518 1.72v2.03a.58.58 0 01-.578.576h-2.033v2.03c0 .318-.26.577-.578.577h-4.066a1.734 1.734 0 01-1.735-1.734v-8.117c0-.958.776-1.734 1.735-1.734h4.066c.319 0 .578.259.578.577v2.03h2.033c.32 0 .578.258.578.58v2a.58.58 0 00.362-.535V19.089c0-3.524-1.403-6.904-3.9-9.398a13.33 13.33 0 00-9.411-3.893h-.066c-3.53 0-6.914 1.402-9.411 3.893a13.28 13.28 0 00-3.9 9.398v11.063c0 .243.15.45.362.537v-2c0-.322.259-.58.578-.58h2.033v-2.03c0-.318.26-.577.578-.577h4.066c.959 0 1.735.776 1.735 1.734v8.117c0 .958-.776 1.734-1.735 1.734h-4.066a.58.58 0 01-.578-.577v-2.03H9.096a.58.58 0 01-.578-.577zm23.353 1.452h1.454v-4.059H31.87zm-1.158 2.609v-9.274h-3.486c-.32 0-.58.258-.58.577v8.117c0 .321.26.58.58.58zM11.13 29.265H9.675v4.059h1.454zm1.158 4.638v2.03h3.486a.58.58 0 00.58-.58v-8.117a.58.58 0 00-.58-.577h-3.486zm8.635-11.7a5.784 5.784 0 01-5.209-5.75.578.578 0 011.158 0 4.63 4.63 0 004.629 4.624 4.63 4.63 0 004.63-4.623.578.578 0 011.157 0 5.784 5.784 0 01-5.209 5.75v1.377a7.3 7.3 0 012.412.604.577.577 0 11-.465 1.059c-1.584-.692-3.273-.699-5.07.009a.579.579 0 01-.425-1.077 8.7 8.7 0 012.392-.584zm4.527-10.646v4.899a3.944 3.944 0 01-3.948 3.942H21.5a3.944 3.944 0 01-3.948-3.942v-4.899a3.944 3.944 0 013.948-3.94h.002a3.944 3.944 0 013.948 3.94m-1.158 0a2.787 2.787 0 00-2.79-2.786H21.5a2.787 2.787 0 00-2.79 2.786v4.899a2.787 2.787 0 002.79 2.786h.002a2.787 2.787 0 002.79-2.786zm-3.949 5.169a.578.578 0 110-1.156h2.327a.578.578 0 110 1.156zm.02-2.753a.579.579 0 010-1.156h2.328a.578.578 0 010 1.156zm-.02-2.754a.578.578 0 110-1.154h2.327c.32 0 .58.258.58.577s-.26.577-.58.577z" clip-rule="evenodd"/>'
  },
  "opportunity-record-deal": {
    body: '<path fill="currentColor" fill-rule="evenodd" d="m15.09 23.218 9.334-2.075v6.583a3.501 3.501 0 00-5.833 2.608c0 1.931 1.567 3.5 3.5 3.5 1.931 0 3.5-1.569 3.5-3.5v-14a.584.584 0 00-.71-.57l-10.5 2.333a.584.584 0 00-.457.57v10.225A3.501 3.501 0 008.09 31.5a3.5 3.5 0 007 0zM13.924 31.5a2.334 2.334 0 10-4.669.002 2.334 2.334 0 004.669-.002m10.5-1.167a2.334 2.334 0 10-4.669.002 2.334 2.334 0 004.669-.002m0-10.384V17.06l-9.334 2.075v2.888zm.583-11.782a7.59 7.59 0 017.583 7.583.584.584 0 001.167 0c0-4.829-3.921-8.75-8.75-8.75a.584.584 0 000 1.167m0 2.916a4.67 4.67 0 014.667 4.667.583.583 0 001.166 0 5.835 5.835 0 00-5.833-5.833.584.584 0 000 1.166m0 2.917c.966 0 1.75.784 1.75 1.75a.583.583 0 001.167 0 2.92 2.92 0 00-2.917-2.917.584.584 0 000 1.167" clip-rule="evenodd"/>'
  },
  "opportunity-share-to-my-team": {
    body: '<path fill="currentColor" d="M35.218 21.003c-.642 0-1.263.227-1.76.64a2.85 2.85 0 00-.968 1.626h-4.743c.28-.993.31-2.042.089-3.05a6.2 6.2 0 00-1.354-2.723l3.369-5.388a4.1 4.1 0 003.06.175 4.2 4.2 0 002.353-2 4.32 4.32 0 00.377-3.097 4.25 4.25 0 00-1.803-2.523 4.1 4.1 0 00-3.01-.59 4.17 4.17 0 00-2.595 1.663 4.306 4.306 0 00.677 5.764l-3.247 5.197a6.02 6.02 0 00-4.071-1.352 6.04 6.04 0 00-3.94 1.71l-3.34-3.4a3.4 3.4 0 00.844-2.286 3.4 3.4 0 00-.899-2.265 3.266 3.266 0 00-4.46-.331 3.38 3.38 0 00-1.211 2.107c-.13.833.05 1.685.508 2.387a3.3 3.3 0 001.96 1.409 3.26 3.26 0 002.38-.313l3.484 3.547a6.3 6.3 0 00-1.18 3.636 6.3 6.3 0 001.136 3.65l-6.012 3.569a4.15 4.15 0 00-2.935-.958 4.17 4.17 0 00-2.788 1.34A4.32 4.32 0 004 32.063a4.32 4.32 0 001.124 2.922 4.17 4.17 0 002.78 1.355 4.15 4.15 0 002.941-.943 4.3 4.3 0 001.517-2.732 4.34 4.34 0 00-.724-3.05l5.978-3.55a6.1 6.1 0 002.016 1.309v4.964a1.7 1.7 0 00-1.123.049c-.36.142-.661.403-.86.74a1.79 1.79 0 00.258 2.15l1.725 1.816v.34c0 .15.059.295.163.401a.55.55 0 00.394.166h8.906c.147 0 .289-.06.393-.166a.57.57 0 00.163-.4v-9.632c0-.328-.093-.65-.269-.924a1.7 1.7 0 00-.72-.627 1.64 1.64 0 00-1.794.285 1.65 1.65 0 00-.838-.408 6.2 6.2 0 001.279-1.726h5.181a2.85 2.85 0 00.72 1.396c.364.387.83.66 1.34.788a2.74 2.74 0 001.548-.063c.5-.17.941-.48 1.275-.895a2.88 2.88 0 00.359-3.006 2.8 2.8 0 00-1.027-1.18 2.75 2.75 0 00-1.487-.439m-6.68-12.748c0-.616.18-1.219.516-1.731a3.07 3.07 0 011.374-1.148 3 3 0 011.769-.177c.594.12 1.14.417 1.567.853s.72.99.838 1.595a3.17 3.17 0 01-.174 1.8 3.1 3.1 0 01-1.128 1.4 3 3 0 01-1.7.524c-.812 0-1.59-.33-2.164-.913a3.15 3.15 0 01-.898-2.203M11.84 13.638a2.2 2.2 0 01-1.237-.382 2.26 2.26 0 01-.82-1.017 2.3 2.3 0 01-.127-1.31 2.3 2.3 0 01.61-1.16 2.2 2.2 0 011.14-.62 2.2 2.2 0 011.286.129c.407.171.754.462 1 .834a2.296 2.296 0 01-.278 2.862 2.2 2.2 0 01-1.574.664m-3.618 21.53a3 3 0 01-1.7-.526 3.1 3.1 0 01-1.128-1.399 3.17 3.17 0 01-.175-1.8c.118-.604.41-1.16.838-1.595a3.05 3.05 0 011.568-.853 3 3 0 011.768.177c.56.236 1.038.635 1.374 1.148a3.156 3.156 0 01-.381 3.934 3.04 3.04 0 01-2.164.913m18.09-7.366v1.7c0 .15.058.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7a.57.57 0 01.163-.4.55.55 0 01.787 0c.105.105.163.25.163.4v9.065h-7.792a.57.57 0 00-.157-.393l-1.887-1.99a.64.64 0 01-.006-.882.62.62 0 01.865-.04l.184.248a.56.56 0 00.621.194.56.56 0 00.275-.206.57.57 0 00.105-.33v-9.066a.56.56 0 01.062-.248l.588-.299c.128.02.245.087.33.188.084.1.132.227.133.36v5.099c0 .15.058.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7a.57.57 0 01.163-.4.55.55 0 01.787 0c.105.105.163.25.163.4v1.7c0 .15.059.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7c0-.15.06-.295.163-.4a.55.55 0 01.788 0 .57.57 0 01.163.4m-5.566-4.995V20.22l2.651 1.35-2.262 1.15a1.6 1.6 0 00-.39.087m3.228 3.379a1.66 1.66 0 00-1.002.013v-1.797a1.7 1.7 0 00-.431-1.13l2.35-1.192a.56.56 0 00.308-.508.57.57 0 00-.308-.507L20.438 18.8a.55.55 0 00-.734.23.6.6 0 00-.072.274v4.533q.002.105.042.2-.04.18-.042.366v1.737a5.07 5.07 0 01-2.322-2.41 5.2 5.2 0 01-.34-3.357 5.12 5.12 0 011.793-2.84 4.96 4.96 0 013.142-1.081 4.96 4.96 0 013.118 1.149 5.12 5.12 0 011.733 2.878 5.2 5.2 0 01-.41 3.35 5.06 5.06 0 01-2.372 2.358m11.244-.65c-.33 0-.654-.1-.928-.287a1.7 1.7 0 01-.615-.763 1.73 1.73 0 01.362-1.852 1.64 1.64 0 011.82-.368c.305.128.565.346.749.625a1.72 1.72 0 01-.208 2.147 1.66 1.66 0 01-1.18.497"/>'
  },
  "opportunity-spotify-playlist": {
    body: '<g fill="currentColor"><path d="M7.236 22.068a.6.6 0 01-.596-.545 5 5 0 01-.016-.42c0-6.516 5.3-11.816 11.816-11.816a.6.6 0 110 1.2c-5.852 0-10.616 4.76-10.616 10.617q-.002.154.008.308a.6.6 0 01-.54.652h-.056zM18.44 23.79a2.683 2.683 0 01-2.68-2.68 2.685 2.685 0 012.68-2.68 2.685 2.685 0 012.68 2.68 2.685 2.685 0 01-2.68 2.68m0-4.16c-.816 0-1.48.664-1.48 1.48s.664 1.48 1.48 1.48 1.48-.664 1.48-1.48-.664-1.48-1.48-1.48"/><path d="M18.446 27.374a6.276 6.276 0 01-6.268-6.268 6.276 6.276 0 016.268-6.268 6.276 6.276 0 016.268 6.268 6.276 6.276 0 01-6.268 6.268m0-11.332a5.075 5.075 0 00-5.068 5.068 5.07 5.07 0 005.068 5.068 5.07 5.07 0 005.068-5.068 5.07 5.07 0 00-5.068-5.068m7.31 18.12a.6.6 0 01-.268-1.136 13.85 13.85 0 006.604-9.588.6.6 0 01.692-.493.6.6 0 01.492.692 15.05 15.05 0 01-6.928 10.273c-.088.06-.204.132-.316.188a.6.6 0 01-.268.064z"/><path d="M18.447 36.157c-8.296 0-15.049-6.748-15.049-15.048S10.151 6.061 18.447 6.061c7.388 0 13.78 5.504 14.872 12.8a.603.603 0 01-.504.684.603.603 0 01-.684-.504c-1.004-6.716-6.888-11.78-13.684-11.78-7.636 0-13.849 6.212-13.849 13.848s6.213 13.848 13.849 13.848c1.008 0 1.992-.104 2.928-.312a.6.6 0 11.26 1.172c-1.02.228-2.096.34-3.188.34"/><path d="M26.03 34.43a.6.6 0 01-.6-.6V20.434c0-.28.196-.524.472-.584l11.976-2.64c.18-.04.364.004.504.12s.224.284.224.468v12.924a.6.6 0 11-1.2 0V18.546L26.63 20.922v12.912a.6.6 0 01-.6.6z"/><path d="M23.73 37.54c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9m0-4.6c-.936 0-1.7.764-1.7 1.7s.764 1.7 1.7 1.7 1.7-.764 1.7-1.7-.764-1.7-1.7-1.7m11.979 1.49c-1.6 0-2.9-1.301-2.9-2.901s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9m0-4.601c-.936 0-1.7.764-1.7 1.7s.764 1.7 1.7 1.7 1.7-.764 1.7-1.7-.764-1.7-1.7-1.7m-9.679-4.331a.6.6 0 01-.12-1.188l11.977-2.436a.6.6 0 01.24 1.176L26.15 25.485a.6.6 0 01-.12.012"/></g>'
  },
  "opportunity-springboard-selection": {
    body: '<g fill="currentColor"><path d="M16.468 32.811a2.461 2.461 0 01-1.74-4.197 2.459 2.459 0 111.74 4.197m0-3.851a1.39 1.39 0 00-.985 2.376 1.39 1.39 0 002.377-.985 1.394 1.394 0 00-1.392-1.391"/><path d="M18.393 30.885a.533.533 0 01-.533-.533v-8.298a.533.533 0 111.066 0v8.298a.533.533 0 01-.533.533m5.717-.45a2.458 2.458 0 110-4.916 2.458 2.458 0 010 4.916m0-3.85a1.392 1.392 0 100 2.783 1.392 1.392 0 000-2.783"/><path d="M26.035 28.51a.534.534 0 01-.534-.534v-8.298a.534.534 0 011.067 0v8.299a.533.533 0 01-.533.533"/><path d="M18.393 22.588a.534.534 0 01-.158-1.043l7.642-2.375a.534.534 0 11.316 1.018l-7.642 2.376a.5.5 0 01-.158.024m0 2.994a.532.532 0 01-.158-1.043l7.642-2.375a.533.533 0 11.316 1.018l-7.642 2.377a.6.6 0 01-.158.023m-6.104-12.049h-1.067a1.96 1.96 0 01-1.955-1.955V6.956A1.96 1.96 0 0111.222 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.955 1.955m-1.067-7.466a.89.89 0 00-.889.889v4.622a.89.89 0 00.89.889h1.066a.89.89 0 00.889-.89v-4.62a.89.89 0 00-.89-.89zm10.312 7.466h-1.067a1.96 1.96 0 01-1.956-1.955V6.956A1.96 1.96 0 0120.467 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.956 1.955m-1.067-7.466a.89.89 0 00-.89.889v4.622a.89.89 0 00.89.889h1.066a.89.89 0 00.89-.89v-4.62a.89.89 0 00-.89-.89zm10.312 7.466H29.71a1.96 1.96 0 01-1.956-1.955V6.956A1.96 1.96 0 0129.711 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.955 1.955M29.71 6.067a.89.89 0 00-.889.889v4.622a.89.89 0 00.889.889h1.067a.89.89 0 00.889-.89v-4.62a.89.89 0 00-.89-.89z"/><path d="M19.044 10.334h-5.333a.534.534 0 010-1.067h5.333a.533.533 0 010 1.067"/><path d="M35.044 37H6.956A1.96 1.96 0 015 35.045V11.223a1.96 1.96 0 011.956-1.956H9.8a.533.533 0 010 1.067H6.956a.89.89 0 00-.89.889v23.822a.89.89 0 00.89.889h28.088a.89.89 0 00.89-.89v-23.82a.89.89 0 00-.89-.89H32.2a.534.534 0 010-1.066h2.844A1.96 1.96 0 0137 11.223v23.822A1.96 1.96 0 0135.044 37"/><path d="M28.289 10.334h-5.334a.534.534 0 010-1.067h5.334a.533.533 0 010 1.067m8.178 6.222H5.533a.533.533 0 010-1.067h30.934a.533.533 0 010 1.067"/></g>'
  },
  "opportunity-sync-deal": {
    body: '<g fill="currentColor"><path d="M32.49 10.656H22.138l3.642-3.641a.594.594 0 10-.84-.84l-4.09 4.085-4.087-4.087a.594.594 0 10-.84.84l3.641 3.642H9.51c-2.95 0-5.349 2.4-5.349 5.349V32.15c0 2.95 2.4 5.35 5.35 5.35h22.98c2.95 0 5.35-2.4 5.35-5.35V16.005c0-2.95-2.4-5.35-5.35-5.35m4.161 21.495a4.165 4.165 0 01-4.16 4.16H9.509a4.165 4.165 0 01-4.16-4.16V16.005a4.165 4.165 0 014.16-4.16h22.982a4.165 4.165 0 014.16 4.16z"/><path d="M28.231 14.222H9.212c-.983 0-1.783.813-1.783 1.813v15.987c0 1 .8 1.813 1.783 1.813h19.019c.983 0 1.783-.813 1.783-1.813V16.035c0-1-.8-1.813-1.783-1.813m.594 17.8c0 .344-.266.624-.594.624H9.212c-.328 0-.594-.28-.594-.624V16.035c0-.344.266-.624.594-.624h19.019c.328 0 .594.28.594.624zm4.427-4.823c-1.148 0-2.08.933-2.08 2.08s.933 2.08 2.08 2.08 2.08-.933 2.08-2.08-.933-2.08-2.08-2.08m0 2.971a.892.892 0 11.001-1.784.892.892 0 01-.001 1.785m1.486-7.034h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.189m.001-2.774h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.189m.001-2.773h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.19"/><path d="M17.788 26.982a.604.604 0 01-.602-.602v-4.32a.601.601 0 01.952-.49l3.026 2.16a.603.603 0 010 .978l-3.026 2.162a.6.6 0 01-.35.113m.602-3.755v1.983l1.389-.99z"/></g>'
  },
  "opportunity-temporary-social-media-share": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="m24.369 20.283-4.474-3.217a.37.37 0 00-.378-.03.36.36 0 00-.2.319v6.433a.357.357 0 00.364.358q.116 0 .214-.069l4.474-3.216a.356.356 0 000-.578m-4.325 2.801V18.06l3.495 2.513z"/><path fill="currentColor" d="M27.853 7.19H14.147c-1.077 0-1.954.864-1.954 1.925v24.77c0 1.061.877 1.925 1.954 1.925h13.706c1.077 0 1.954-.864 1.954-1.925V9.115c0-1.061-.877-1.925-1.954-1.925m-14.934 4.324h16.162v17.914H12.919zm1.228-3.608h13.706a1.22 1.22 0 011.228 1.21v1.682H12.919V9.115c0-.667.551-1.21 1.228-1.21m13.706 27.188H14.147a1.22 1.22 0 01-1.228-1.21v-3.74h16.162v3.74a1.22 1.22 0 01-1.228 1.21"/><path fill="currentColor" d="M21 30.926c-.994 0-1.803.79-1.803 1.761s.809 1.761 1.803 1.761 1.803-.79 1.803-1.76c0-.972-.809-1.762-1.803-1.762m0 2.807c-.594 0-1.077-.47-1.077-1.046s.483-1.045 1.077-1.045 1.077.469 1.077 1.045c0 .577-.483 1.046-1.077 1.046m0-19.209c-3.397 0-6.16 2.723-6.16 6.07s2.763 6.07 6.16 6.07 6.162-2.723 6.162-6.07-2.764-6.07-6.162-6.07m0 11.425c-2.997 0-5.435-2.402-5.435-5.355 0-2.952 2.438-5.354 5.435-5.354s5.436 2.402 5.436 5.354S23.997 25.95 21 25.95"/><path fill="currentColor" fill-rule="evenodd" d="M19.517 17.036a.37.37 0 01.378.03l4.474 3.217a.356.356 0 010 .578l-4.474 3.216a.37.37 0 01-.378.03.36.36 0 01-.2-.319v-6.433a.36.36 0 01.2-.32m-.088 7.24a.55.55 0 01-.304-.488v-6.433c0-.206.117-.395.304-.489a.56.56 0 01.58.046l4.473 3.217m-4.473 4.102 4.473-3.217Zm-.58.046a.56.56 0 00.58-.046m.035-1.147 3.495-2.512-3.495-2.513zm.193-.374 2.974-2.138-2.974-2.139zM14.147 7h13.706C29.037 7 30 7.949 30 9.115v24.77C30 35.05 29.037 36 27.853 36H14.147C12.963 36 12 35.051 12 33.885V9.115C12 7.95 12.963 7 14.147 7m14.74 4.704H13.113v17.534h15.776zm-1.034-3.608H14.147c-.57 0-1.035.457-1.035 1.02v1.492h15.776V9.115a1.03 1.03 0 00-1.035-1.02M14.147 34.904h13.706c.57 0 1.035-.457 1.035-1.02v-3.55H13.112v3.55c0 .563.465 1.02 1.035 1.02m4.857-2.217c0-1.077.897-1.95 1.996-1.95 1.1 0 1.996.873 1.996 1.95 0 1.078-.897 1.951-1.996 1.951s-1.996-.873-1.996-1.95m1.112 0c0 .47.394.856.884.856s.884-.387.884-.856-.394-.855-.884-.855-.884.386-.884.855m-5.47-12.093c0-3.452 2.85-6.26 6.354-6.26s6.355 2.808 6.355 6.26-2.85 6.26-6.355 6.26c-3.504 0-6.354-2.808-6.354-6.26m1.112 0c0 2.848 2.352 5.165 5.242 5.165s5.243-2.317 5.243-5.165S23.89 15.43 21 15.43s-5.242 2.317-5.242 5.164M14.147 7.19h13.706c1.077 0 1.954.864 1.954 1.925v24.77c0 1.061-.877 1.925-1.954 1.925H14.147c-1.077 0-1.954-.864-1.954-1.925V9.115c0-1.061.877-1.925 1.954-1.925m-1.228 4.324v17.914h16.162V11.514zm14.934-3.608H14.147a1.22 1.22 0 00-1.228 1.21v1.682h16.162V9.115a1.22 1.22 0 00-1.228-1.21M14.147 35.094h13.706a1.22 1.22 0 001.228-1.21v-3.74H12.919v3.74c0 .668.551 1.21 1.228 1.21M21 30.926c-.994 0-1.803.79-1.803 1.761s.809 1.761 1.803 1.761 1.803-.79 1.803-1.76c0-.972-.809-1.762-1.803-1.762m0 2.807c-.594 0-1.077-.47-1.077-1.046s.483-1.045 1.077-1.045 1.077.469 1.077 1.045c0 .577-.483 1.046-1.077 1.046m-6.16-13.139c0-3.347 2.763-6.07 6.16-6.07s6.162 2.723 6.162 6.07-2.764 6.07-6.162 6.07c-3.397 0-6.16-2.723-6.16-6.07m.725 0c0 2.953 2.438 5.355 5.435 5.355s5.436-2.402 5.436-5.355c0-2.952-2.439-5.354-5.436-5.354s-5.435 2.402-5.435 5.354" clip-rule="evenodd"/><path fill="currentColor" d="M24.709 20.772c.18-.412-.299-.706-.478-.824-.18-.118-4.603 4.004-4.603 4.004l-.21.324.569-.03c1.415-1.03 4.423-2.973 4.722-3.474"/></g>'
  },
  "smile-meter-0": {
    body: '<path fill="currentColor" d="M12.813 15.89c-.391.352-.977.352-1.329-.038A1.97 1.97 0 0010 15.187c-.742 0-1.25.352-1.523.665-.352.39-.938.39-1.329.039-.39-.352-.39-.938-.039-1.328A3.94 3.94 0 0110 13.313c1.328 0 2.305.664 2.852 1.25.351.39.351.976-.04 1.328M5.625 9.876c0-.312.117-.625.352-.86l-1.211-.39c-.313-.117-.47-.469-.391-.82a.654.654 0 01.82-.39l3.75 1.25c.313.116.47.468.39.82-.116.312-.468.468-.82.39l-.39-.156v.156c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25m8.75 0c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25V9.72l-.43.156c-.351.078-.703-.078-.82-.39-.078-.352.078-.704.39-.82l3.75-1.25a.654.654 0 01.82.39c.08.351-.077.703-.39.82l-1.21.39c.234.196.39.547.39.86M0 10.5C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10 0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10m10 8.125c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625"/>',
    width: 20,
    height: 21
  },
  "smile-meter-1": {
    body: '<path fill="currentColor" d="M5.586 16.086c-.469-.156-.742-.703-.547-1.211C5.703 13 7.734 11.75 10 11.75c2.227 0 4.258 1.25 4.922 3.125.195.508-.078 1.055-.547 1.21-.508.196-1.055-.077-1.21-.546-.352-1.016-1.563-1.914-3.165-1.914-1.64 0-2.852.898-3.203 1.914-.156.469-.703.742-1.211.547m2.539-7.461c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m3.75 0c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  },
  "smile-meter-2": {
    body: '<path fill="currentColor" d="M5.625 8.625c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25m8.75 0c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m-1.562 4.688a.95.95 0 01.937.937c0 .547-.43.938-.937.938H7.187c-.546 0-.937-.391-.937-.938 0-.508.39-.937.938-.937zM20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10m-10 8.125c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625"/>',
    width: 20,
    height: 21
  },
  "smile-meter-3": {
    body: '<path fill="currentColor" d="M10 14.25c1.445 0 2.46-.664 3.047-1.29a.933.933 0 011.328-.077c.39.351.39.937.04 1.328A5.93 5.93 0 0110 16.125c-2.11 0-3.594-.977-4.453-1.914-.352-.39-.352-.977.039-1.328a.933.933 0 011.328.078C7.5 13.586 8.516 14.25 10 14.25M8.125 8.625c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m3.75 0c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  },
  "smile-meter-4": {
    body: '<path fill="currentColor" d="M13.633 12.57c.742-.195 1.406.47.976 1.094-.937 1.484-2.656 2.461-4.648 2.461-1.953 0-3.672-.977-4.648-2.46-.391-.626.273-1.29 1.015-1.095 1.133.274 2.344.39 3.633.39 1.328 0 2.539-.116 3.672-.39M8.477 9.445s0-.039-.04-.039q0-.058-.117-.117c-.078-.117-.234-.273-.39-.43-.352-.273-.742-.546-1.055-.546-.352 0-.742.273-1.094.546-.156.157-.312.313-.39.43q-.118.06-.118.117c-.039 0-.039.04-.039.04a.315.315 0 01-.351.117c-.117-.04-.195-.157-.195-.313 0-.664.234-1.367.625-1.875.39-.508.937-.937 1.562-.937.586 0 1.133.43 1.523.937.391.508.665 1.21.665 1.875a.34.34 0 01-.235.313.315.315 0 01-.351-.118m6.25 0s0-.039-.04-.039q0-.058-.117-.117c-.078-.117-.234-.273-.39-.43-.352-.273-.742-.546-1.055-.546-.352 0-.742.273-1.094.546-.156.157-.312.313-.39.43q-.118.06-.118.117c-.039 0-.039.04-.039.04a.315.315 0 01-.351.117c-.117-.04-.195-.157-.195-.313 0-.664.234-1.367.624-1.875.391-.508.938-.937 1.563-.937.586 0 1.133.43 1.523.937.391.508.665 1.21.665 1.875a.34.34 0 01-.235.313.315.315 0 01-.351-.118M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  }
}, ji = 42, Ui = 42, Wi = {
  prefix: Vi,
  lastModified: Hi,
  icons: Bi,
  width: ji,
  height: Ui
};
/**
* (c) Iconify
*
* For the full copyright and license information, please view the license.txt
* files at https://github.com/iconify/iconify
*
* Licensed under MIT.
*
* @license MIT
* @version 2.1.0
*/
const Eo = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), yt = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), at = Object.freeze({
  ...Eo,
  ...yt
}), Jt = Object.freeze({
  ...at,
  body: "",
  hidden: !1
}), Ki = Object.freeze({
  width: null,
  height: null
}), Mo = Object.freeze({
  // Dimensions
  ...Ki,
  // Transformations
  ...yt
});
function qi(e, t = 0) {
  const n = e.replace(/^-?[0-9.]*/, "");
  function o(i) {
    for (; i < 0; )
      i += 4;
    return i % 4;
  }
  if (n === "") {
    const i = parseInt(e);
    return isNaN(i) ? 0 : o(i);
  } else if (n !== e) {
    let i = 0;
    switch (n) {
      case "%":
        i = 25;
        break;
      case "deg":
        i = 90;
    }
    if (i) {
      let a = parseFloat(e.slice(0, e.length - n.length));
      return isNaN(a) ? 0 : (a = a / i, a % 1 === 0 ? o(a) : 0);
    }
  }
  return t;
}
const _i = /[\s,]+/;
function Gi(e, t) {
  t.split(_i).forEach((n) => {
    switch (n.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
const zo = {
  ...Mo,
  preserveAspectRatio: ""
};
function Pn(e) {
  const t = {
    ...zo
  }, n = (o, i) => e.getAttribute(o) || i;
  return t.width = n("width", null), t.height = n("height", null), t.rotate = qi(n("rotate", "")), Gi(t, n("flip", "")), t.preserveAspectRatio = n("preserveAspectRatio", n("preserveaspectratio", "")), t;
}
function Qi(e, t) {
  for (const n in zo)
    if (e[n] !== t[n])
      return !0;
  return !1;
}
const Ze = /^[a-z0-9]+(-[a-z0-9]+)*$/, lt = (e, t, n, o = "") => {
  const i = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (i.length < 2 || i.length > 3)
      return null;
    o = i.shift().slice(1);
  }
  if (i.length > 3 || !i.length)
    return null;
  if (i.length > 1) {
    const l = i.pop(), s = i.pop(), c = {
      // Allow provider without '@': "provider:prefix:name"
      provider: i.length > 0 ? i[0] : o,
      prefix: s,
      name: l
    };
    return t && !wt(c) ? null : c;
  }
  const a = i[0], r = a.split("-");
  if (r.length > 1) {
    const l = {
      provider: o,
      prefix: r.shift(),
      name: r.join("-")
    };
    return t && !wt(l) ? null : l;
  }
  if (n && o === "") {
    const l = {
      provider: o,
      prefix: "",
      name: a
    };
    return t && !wt(l, n) ? null : l;
  }
  return null;
}, wt = (e, t) => e ? !!((e.provider === "" || e.provider.match(Ze)) && (t && e.prefix === "" || e.prefix.match(Ze)) && e.name.match(Ze)) : !1;
function Yi(e, t) {
  const n = {};
  !e.hFlip != !t.hFlip && (n.hFlip = !0), !e.vFlip != !t.vFlip && (n.vFlip = !0);
  const o = ((e.rotate || 0) + (t.rotate || 0)) % 4;
  return o && (n.rotate = o), n;
}
function Vn(e, t) {
  const n = Yi(e, t);
  for (const o in Jt)
    o in yt ? o in e && !(o in n) && (n[o] = yt[o]) : o in t ? n[o] = t[o] : o in e && (n[o] = e[o]);
  return n;
}
function Xi(e, t) {
  const n = e.icons, o = e.aliases || /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null);
  function a(r) {
    if (n[r])
      return i[r] = [];
    if (!(r in i)) {
      i[r] = null;
      const l = o[r] && o[r].parent, s = l && a(l);
      s && (i[r] = [l].concat(s));
    }
    return i[r];
  }
  return Object.keys(n).concat(Object.keys(o)).forEach(a), i;
}
function Zi(e, t, n) {
  const o = e.icons, i = e.aliases || /* @__PURE__ */ Object.create(null);
  let a = {};
  function r(l) {
    a = Vn(
      o[l] || i[l],
      a
    );
  }
  return r(t), n.forEach(r), Vn(e, a);
}
function Fo(e, t) {
  const n = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return n;
  e.not_found instanceof Array && e.not_found.forEach((i) => {
    t(i, null), n.push(i);
  });
  const o = Xi(e);
  for (const i in o) {
    const a = o[i];
    a && (t(i, Zi(e, i, a)), n.push(i));
  }
  return n;
}
const Ji = {
  provider: "",
  aliases: {},
  not_found: {},
  ...Eo
};
function Bt(e, t) {
  for (const n in t)
    if (n in e && typeof e[n] != typeof t[n])
      return !1;
  return !0;
}
function No(e) {
  if (typeof e != "object" || e === null)
    return null;
  const t = e;
  if (typeof t.prefix != "string" || !e.icons || typeof e.icons != "object" || !Bt(e, Ji))
    return null;
  const n = t.icons;
  for (const i in n) {
    const a = n[i];
    if (!i.match(Ze) || typeof a.body != "string" || !Bt(
      a,
      Jt
    ))
      return null;
  }
  const o = t.aliases || /* @__PURE__ */ Object.create(null);
  for (const i in o) {
    const a = o[i], r = a.parent;
    if (!i.match(Ze) || typeof r != "string" || !n[r] && !o[r] || !Bt(
      a,
      Jt
    ))
      return null;
  }
  return t;
}
const xt = /* @__PURE__ */ Object.create(null);
function er(e, t) {
  return {
    provider: e,
    prefix: t,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function we(e, t) {
  const n = xt[e] || (xt[e] = /* @__PURE__ */ Object.create(null));
  return n[t] || (n[t] = er(e, t));
}
function Cn(e, t) {
  return No(t) ? Fo(t, (n, o) => {
    o ? e.icons[n] = o : e.missing.add(n);
  }) : [];
}
function tr(e, t, n) {
  try {
    if (typeof n.body == "string")
      return e.icons[t] = { ...n }, !0;
  } catch {
  }
  return !1;
}
function nr(e, t) {
  let n = [];
  return (typeof e == "string" ? [e] : Object.keys(xt)).forEach((i) => {
    (typeof i == "string" && typeof t == "string" ? [t] : Object.keys(xt[i] || {})).forEach((r) => {
      const l = we(i, r);
      n = n.concat(
        Object.keys(l.icons).map(
          (s) => (i !== "" ? "@" + i + ":" : "") + r + ":" + s
        )
      );
    });
  }), n;
}
let nt = !1;
function $o(e) {
  return typeof e == "boolean" && (nt = e), nt;
}
function ot(e) {
  const t = typeof e == "string" ? lt(e, !0, nt) : e;
  if (t) {
    const n = we(t.provider, t.prefix), o = t.name;
    return n.icons[o] || (n.missing.has(o) ? null : void 0);
  }
}
function Oo(e, t) {
  const n = lt(e, !0, nt);
  if (!n)
    return !1;
  const o = we(n.provider, n.prefix);
  return tr(o, n.name, t);
}
function Hn(e, t) {
  if (typeof e != "object")
    return !1;
  if (typeof t != "string" && (t = e.provider || ""), nt && !t && !e.prefix) {
    let i = !1;
    return No(e) && (e.prefix = "", Fo(e, (a, r) => {
      r && Oo(a, r) && (i = !0);
    })), i;
  }
  const n = e.prefix;
  if (!wt({
    provider: t,
    prefix: n,
    name: "a"
  }))
    return !1;
  const o = we(t, n);
  return !!Cn(o, e);
}
function Bn(e) {
  return !!ot(e);
}
function or(e) {
  const t = ot(e);
  return t ? {
    ...at,
    ...t
  } : null;
}
function ir(e) {
  const t = {
    loaded: [],
    missing: [],
    pending: []
  }, n = /* @__PURE__ */ Object.create(null);
  e.sort((i, a) => i.provider !== a.provider ? i.provider.localeCompare(a.provider) : i.prefix !== a.prefix ? i.prefix.localeCompare(a.prefix) : i.name.localeCompare(a.name));
  let o = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((i) => {
    if (o.name === i.name && o.prefix === i.prefix && o.provider === i.provider)
      return;
    o = i;
    const a = i.provider, r = i.prefix, l = i.name, s = n[a] || (n[a] = /* @__PURE__ */ Object.create(null)), c = s[r] || (s[r] = we(a, r));
    let u;
    l in c.icons ? u = t.loaded : r === "" || c.missing.has(l) ? u = t.missing : u = t.pending;
    const d = {
      provider: a,
      prefix: r,
      name: l
    };
    u.push(d);
  }), t;
}
function Lo(e, t) {
  e.forEach((n) => {
    const o = n.loaderCallbacks;
    o && (n.loaderCallbacks = o.filter((i) => i.id !== t));
  });
}
function rr(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const t = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!t.length)
      return;
    let n = !1;
    const o = e.provider, i = e.prefix;
    t.forEach((a) => {
      const r = a.icons, l = r.pending.length;
      r.pending = r.pending.filter((s) => {
        if (s.prefix !== i)
          return !0;
        const c = s.name;
        if (e.icons[c])
          r.loaded.push({
            provider: o,
            prefix: i,
            name: c
          });
        else if (e.missing.has(c))
          r.missing.push({
            provider: o,
            prefix: i,
            name: c
          });
        else
          return n = !0, !0;
        return !1;
      }), r.pending.length !== l && (n || Lo([e], a.id), a.callback(
        r.loaded.slice(0),
        r.missing.slice(0),
        r.pending.slice(0),
        a.abort
      ));
    });
  }));
}
let ar = 0;
function lr(e, t, n) {
  const o = ar++, i = Lo.bind(null, n, o);
  if (!t.pending.length)
    return i;
  const a = {
    id: o,
    icons: t,
    callback: e,
    abort: i
  };
  return n.forEach((r) => {
    (r.loaderCallbacks || (r.loaderCallbacks = [])).push(a);
  }), i;
}
const en = /* @__PURE__ */ Object.create(null);
function jn(e, t) {
  en[e] = t;
}
function tn(e) {
  return en[e] || en[""];
}
function sr(e, t = !0, n = !1) {
  const o = [];
  return e.forEach((i) => {
    const a = typeof i == "string" ? lt(i, t, n) : i;
    a && o.push(a);
  }), o;
}
var cr = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function ur(e, t, n, o) {
  const i = e.resources.length, a = e.random ? Math.floor(Math.random() * i) : e.index;
  let r;
  if (e.random) {
    let M = e.resources.slice(0);
    for (r = []; M.length > 1; ) {
      const z = Math.floor(Math.random() * M.length);
      r.push(M[z]), M = M.slice(0, z).concat(M.slice(z + 1));
    }
    r = r.concat(M);
  } else
    r = e.resources.slice(a).concat(e.resources.slice(0, a));
  const l = Date.now();
  let s = "pending", c = 0, u, d = null, f = [], h = [];
  typeof o == "function" && h.push(o);
  function v() {
    d && (clearTimeout(d), d = null);
  }
  function y() {
    s === "pending" && (s = "aborted"), v(), f.forEach((M) => {
      M.status === "pending" && (M.status = "aborted");
    }), f = [];
  }
  function b(M, z) {
    z && (h = []), typeof M == "function" && h.push(M);
  }
  function m() {
    return {
      startTime: l,
      payload: t,
      status: s,
      queriesSent: c,
      queriesPending: f.length,
      subscribe: b,
      abort: y
    };
  }
  function C() {
    s = "failed", h.forEach((M) => {
      M(void 0, u);
    });
  }
  function x() {
    f.forEach((M) => {
      M.status === "pending" && (M.status = "aborted");
    }), f = [];
  }
  function T(M, z, j) {
    const X = z !== "success";
    switch (f = f.filter((K) => K !== M), s) {
      case "pending":
        break;
      case "failed":
        if (X || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (z === "abort") {
      u = j, C();
      return;
    }
    if (X) {
      u = j, f.length || (r.length ? L() : C());
      return;
    }
    if (v(), x(), !e.random) {
      const K = e.resources.indexOf(M.resource);
      K !== -1 && K !== e.index && (e.index = K);
    }
    s = "completed", h.forEach((K) => {
      K(j);
    });
  }
  function L() {
    if (s !== "pending")
      return;
    v();
    const M = r.shift();
    if (M === void 0) {
      if (f.length) {
        d = setTimeout(() => {
          v(), s === "pending" && (x(), C());
        }, e.timeout);
        return;
      }
      C();
      return;
    }
    const z = {
      status: "pending",
      resource: M,
      callback: (j, X) => {
        T(z, j, X);
      }
    };
    f.push(z), c++, d = setTimeout(L, e.rotate), n(M, t, z.callback);
  }
  return setTimeout(L), m;
}
function Do(e) {
  const t = {
    ...cr,
    ...e
  };
  let n = [];
  function o() {
    n = n.filter((l) => l().status === "pending");
  }
  function i(l, s, c) {
    const u = ur(
      t,
      l,
      s,
      (d, f) => {
        o(), c && c(d, f);
      }
    );
    return n.push(u), u;
  }
  function a(l) {
    return n.find((s) => l(s)) || null;
  }
  return {
    query: i,
    find: a,
    setIndex: (l) => {
      t.index = l;
    },
    getIndex: () => t.index,
    cleanup: o
  };
}
function kn(e) {
  let t;
  if (typeof e.resources == "string")
    t = [e.resources];
  else if (t = e.resources, !(t instanceof Array) || !t.length)
    return null;
  return {
    // API hosts
    resources: t,
    // Root path
    path: e.path || "/",
    // URL length limit
    maxURL: e.maxURL || 500,
    // Timeout before next host is used.
    rotate: e.rotate || 750,
    // Timeout before failing query.
    timeout: e.timeout || 5e3,
    // Randomise default API end point.
    random: e.random === !0,
    // Start index
    index: e.index || 0,
    // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const Nt = /* @__PURE__ */ Object.create(null), Ge = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], bt = [];
for (; Ge.length > 0; )
  Ge.length === 1 || Math.random() > 0.5 ? bt.push(Ge.shift()) : bt.push(Ge.pop());
Nt[""] = kn({
  resources: ["https://api.iconify.design"].concat(bt)
});
function Un(e, t) {
  const n = kn(t);
  return n === null ? !1 : (Nt[e] = n, !0);
}
function $t(e) {
  return Nt[e];
}
function dr() {
  return Object.keys(Nt);
}
function Wn() {
}
const jt = /* @__PURE__ */ Object.create(null);
function fr(e) {
  if (!jt[e]) {
    const t = $t(e);
    if (!t)
      return;
    const n = Do(t), o = {
      config: t,
      redundancy: n
    };
    jt[e] = o;
  }
  return jt[e];
}
function Ro(e, t, n) {
  let o, i;
  if (typeof e == "string") {
    const a = tn(e);
    if (!a)
      return n(void 0, 424), Wn;
    i = a.send;
    const r = fr(e);
    r && (o = r.redundancy);
  } else {
    const a = kn(e);
    if (a) {
      o = Do(a);
      const r = e.resources ? e.resources[0] : "", l = tn(r);
      l && (i = l.send);
    }
  }
  return !o || !i ? (n(void 0, 424), Wn) : o.query(t, i, n)().abort;
}
const Kn = "iconify2", it = "iconify", Po = it + "-count", qn = it + "-version", Vo = 36e5, hr = 168, mr = 50;
function nn(e, t) {
  try {
    return e.getItem(t);
  } catch {
  }
}
function Tn(e, t, n) {
  try {
    return e.setItem(t, n), !0;
  } catch {
  }
}
function _n(e, t) {
  try {
    e.removeItem(t);
  } catch {
  }
}
function on(e, t) {
  return Tn(e, Po, t.toString());
}
function rn(e) {
  return parseInt(nn(e, Po)) || 0;
}
const ke = {
  local: !0,
  session: !0
}, Ho = {
  local: /* @__PURE__ */ new Set(),
  session: /* @__PURE__ */ new Set()
};
let Sn = !1;
function pr(e) {
  Sn = e;
}
let ut = typeof window > "u" ? {} : window;
function Bo(e) {
  const t = e + "Storage";
  try {
    if (ut && ut[t] && typeof ut[t].length == "number")
      return ut[t];
  } catch {
  }
  ke[e] = !1;
}
function jo(e, t) {
  const n = Bo(e);
  if (!n)
    return;
  const o = nn(n, qn);
  if (o !== Kn) {
    if (o) {
      const l = rn(n);
      for (let s = 0; s < l; s++)
        _n(n, it + s.toString());
    }
    Tn(n, qn, Kn), on(n, 0);
    return;
  }
  const i = Math.floor(Date.now() / Vo) - hr, a = (l) => {
    const s = it + l.toString(), c = nn(n, s);
    if (typeof c == "string") {
      try {
        const u = JSON.parse(c);
        if (typeof u == "object" && typeof u.cached == "number" && u.cached > i && typeof u.provider == "string" && typeof u.data == "object" && typeof u.data.prefix == "string" && // Valid item: run callback
        t(u, l))
          return !0;
      } catch {
      }
      _n(n, s);
    }
  };
  let r = rn(n);
  for (let l = r - 1; l >= 0; l--)
    a(l) || (l === r - 1 ? (r--, on(n, r)) : Ho[e].add(l));
}
function Uo() {
  if (!Sn) {
    pr(!0);
    for (const e in ke)
      jo(e, (t) => {
        const n = t.data, o = t.provider, i = n.prefix, a = we(
          o,
          i
        );
        if (!Cn(a, n).length)
          return !1;
        const r = n.lastModified || -1;
        return a.lastModifiedCached = a.lastModifiedCached ? Math.min(a.lastModifiedCached, r) : r, !0;
      });
  }
}
function vr(e, t) {
  const n = e.lastModifiedCached;
  if (
    // Matches or newer
    n && n >= t
  )
    return n === t;
  if (e.lastModifiedCached = t, n)
    for (const o in ke)
      jo(o, (i) => {
        const a = i.data;
        return i.provider !== e.provider || a.prefix !== e.prefix || a.lastModified === t;
      });
  return !0;
}
function wr(e, t) {
  Sn || Uo();
  function n(o) {
    let i;
    if (!ke[o] || !(i = Bo(o)))
      return;
    const a = Ho[o];
    let r;
    if (a.size)
      a.delete(r = Array.from(a).shift());
    else if (r = rn(i), r >= mr || !on(i, r + 1))
      return;
    const l = {
      cached: Math.floor(Date.now() / Vo),
      provider: e.provider,
      data: t
    };
    return Tn(
      i,
      it + r.toString(),
      JSON.stringify(l)
    );
  }
  t.lastModified && !vr(e, t.lastModified) || Object.keys(t.icons).length && (t.not_found && (t = Object.assign({}, t), delete t.not_found), n("local") || n("session"));
}
function Gn() {
}
function br(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, rr(e);
  }));
}
function gr(e, t) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(t).sort() : e.iconsToLoad = t, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: n, prefix: o } = e, i = e.iconsToLoad;
    delete e.iconsToLoad;
    let a;
    if (!i || !(a = tn(n)))
      return;
    a.prepare(n, o, i).forEach((l) => {
      Ro(n, l, (s) => {
        if (typeof s != "object")
          l.icons.forEach((c) => {
            e.missing.add(c);
          });
        else
          try {
            const c = Cn(
              e,
              s
            );
            if (!c.length)
              return;
            const u = e.pendingIcons;
            u && c.forEach((d) => {
              u.delete(d);
            }), wr(e, s);
          } catch (c) {
            console.error(c);
          }
        br(e);
      });
    });
  }));
}
const In = (e, t) => {
  const n = sr(e, !0, $o()), o = ir(n);
  if (!o.pending.length) {
    let s = !0;
    return t && setTimeout(() => {
      s && t(
        o.loaded,
        o.missing,
        o.pending,
        Gn
      );
    }), () => {
      s = !1;
    };
  }
  const i = /* @__PURE__ */ Object.create(null), a = [];
  let r, l;
  return o.pending.forEach((s) => {
    const { provider: c, prefix: u } = s;
    if (u === l && c === r)
      return;
    r = c, l = u, a.push(we(c, u));
    const d = i[c] || (i[c] = /* @__PURE__ */ Object.create(null));
    d[u] || (d[u] = []);
  }), o.pending.forEach((s) => {
    const { provider: c, prefix: u, name: d } = s, f = we(c, u), h = f.pendingIcons || (f.pendingIcons = /* @__PURE__ */ new Set());
    h.has(d) || (h.add(d), i[c][u].push(d));
  }), a.forEach((s) => {
    const { provider: c, prefix: u } = s;
    i[c][u].length && gr(s, i[c][u]);
  }), t ? lr(t, o, a) : Gn;
}, yr = (e) => new Promise((t, n) => {
  const o = typeof e == "string" ? lt(e, !0) : e;
  if (!o) {
    n(e);
    return;
  }
  In([o || e], (i) => {
    if (i.length && o) {
      const a = ot(o);
      if (a) {
        t({
          ...at,
          ...a
        });
        return;
      }
    }
    n(e);
  });
});
function xr(e) {
  try {
    const t = typeof e == "string" ? JSON.parse(e) : e;
    if (typeof t.body == "string")
      return {
        ...t
      };
  } catch {
  }
}
function Cr(e, t) {
  const n = typeof e == "string" ? lt(e, !0, !0) : null;
  if (!n) {
    const a = xr(e);
    return {
      value: e,
      data: a
    };
  }
  const o = ot(n);
  if (o !== void 0 || !n.prefix)
    return {
      value: e,
      name: n,
      data: o
      // could be 'null' -> icon is missing
    };
  const i = In([n], () => t(e, n, ot(n)));
  return {
    value: e,
    name: n,
    loading: i
  };
}
let Wo = !1;
try {
  Wo = navigator.vendor.indexOf("Apple") === 0;
} catch {
}
function kr(e, t) {
  switch (t) {
    case "svg":
    case "bg":
    case "mask":
      return t;
  }
  return t !== "style" && (Wo || e.indexOf("<a") === -1) ? "svg" : e.indexOf("currentColor") === -1 ? "bg" : "mask";
}
const Tr = /(-?[0-9.]*[0-9]+[0-9.]*)/g, Sr = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function an(e, t, n) {
  if (t === 1)
    return e;
  if (n = n || 100, typeof e == "number")
    return Math.ceil(e * t * n) / n;
  if (typeof e != "string")
    return e;
  const o = e.split(Tr);
  if (o === null || !o.length)
    return e;
  const i = [];
  let a = o.shift(), r = Sr.test(a);
  for (; ; ) {
    if (r) {
      const l = parseFloat(a);
      isNaN(l) ? i.push(a) : i.push(Math.ceil(l * t * n) / n);
    } else
      i.push(a);
    if (a = o.shift(), a === void 0)
      return i.join("");
    r = !r;
  }
}
function Ir(e, t = "defs") {
  let n = "";
  const o = e.indexOf("<" + t);
  for (; o >= 0; ) {
    const i = e.indexOf(">", o), a = e.indexOf("</" + t);
    if (i === -1 || a === -1)
      break;
    const r = e.indexOf(">", a);
    if (r === -1)
      break;
    n += e.slice(i + 1, a).trim(), e = e.slice(0, o).trim() + e.slice(r + 1);
  }
  return {
    defs: n,
    content: e
  };
}
function Ar(e, t) {
  return e ? "<defs>" + e + "</defs>" + t : t;
}
function Er(e, t, n) {
  const o = Ir(e);
  return Ar(o.defs, t + o.content + n);
}
const Mr = (e) => e === "unset" || e === "undefined" || e === "none";
function Ko(e, t) {
  const n = {
    ...at,
    ...e
  }, o = {
    ...Mo,
    ...t
  }, i = {
    left: n.left,
    top: n.top,
    width: n.width,
    height: n.height
  };
  let a = n.body;
  [n, o].forEach((y) => {
    const b = [], m = y.hFlip, C = y.vFlip;
    let x = y.rotate;
    m ? C ? x += 2 : (b.push(
      "translate(" + (i.width + i.left).toString() + " " + (0 - i.top).toString() + ")"
    ), b.push("scale(-1 1)"), i.top = i.left = 0) : C && (b.push(
      "translate(" + (0 - i.left).toString() + " " + (i.height + i.top).toString() + ")"
    ), b.push("scale(1 -1)"), i.top = i.left = 0);
    let T;
    switch (x < 0 && (x -= Math.floor(x / 4) * 4), x = x % 4, x) {
      case 1:
        T = i.height / 2 + i.top, b.unshift(
          "rotate(90 " + T.toString() + " " + T.toString() + ")"
        );
        break;
      case 2:
        b.unshift(
          "rotate(180 " + (i.width / 2 + i.left).toString() + " " + (i.height / 2 + i.top).toString() + ")"
        );
        break;
      case 3:
        T = i.width / 2 + i.left, b.unshift(
          "rotate(-90 " + T.toString() + " " + T.toString() + ")"
        );
        break;
    }
    x % 2 === 1 && (i.left !== i.top && (T = i.left, i.left = i.top, i.top = T), i.width !== i.height && (T = i.width, i.width = i.height, i.height = T)), b.length && (a = Er(
      a,
      '<g transform="' + b.join(" ") + '">',
      "</g>"
    ));
  });
  const r = o.width, l = o.height, s = i.width, c = i.height;
  let u, d;
  r === null ? (d = l === null ? "1em" : l === "auto" ? c : l, u = an(d, s / c)) : (u = r === "auto" ? s : r, d = l === null ? an(u, c / s) : l === "auto" ? c : l);
  const f = {}, h = (y, b) => {
    Mr(b) || (f[y] = b.toString());
  };
  h("width", u), h("height", d);
  const v = [i.left, i.top, s, c];
  return f.viewBox = v.join(" "), {
    attributes: f,
    viewBox: v,
    body: a
  };
}
function An(e, t) {
  let n = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const o in t)
    n += " " + o + '="' + t[o] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + n + ">" + e + "</svg>";
}
function zr(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function Fr(e) {
  return "data:image/svg+xml," + zr(e);
}
function qo(e) {
  return 'url("' + Fr(e) + '")';
}
const Nr = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
};
let Ct = Nr();
function $r(e) {
  Ct = e;
}
function Or() {
  return Ct;
}
function Lr(e, t) {
  const n = $t(e);
  if (!n)
    return 0;
  let o;
  if (!n.maxURL)
    o = 0;
  else {
    let i = 0;
    n.resources.forEach((r) => {
      i = Math.max(i, r.length);
    });
    const a = t + ".json?icons=";
    o = n.maxURL - i - n.path.length - a.length;
  }
  return o;
}
function Dr(e) {
  return e === 404;
}
const Rr = (e, t, n) => {
  const o = [], i = Lr(e, t), a = "icons";
  let r = {
    type: a,
    provider: e,
    prefix: t,
    icons: []
  }, l = 0;
  return n.forEach((s, c) => {
    l += s.length + 1, l >= i && c > 0 && (o.push(r), r = {
      type: a,
      provider: e,
      prefix: t,
      icons: []
    }, l = s.length), r.icons.push(s);
  }), o.push(r), o;
};
function Pr(e) {
  if (typeof e == "string") {
    const t = $t(e);
    if (t)
      return t.path;
  }
  return "/";
}
const Vr = (e, t, n) => {
  if (!Ct) {
    n("abort", 424);
    return;
  }
  let o = Pr(t.provider);
  switch (t.type) {
    case "icons": {
      const a = t.prefix, l = t.icons.join(","), s = new URLSearchParams({
        icons: l
      });
      o += a + ".json?" + s.toString();
      break;
    }
    case "custom": {
      const a = t.uri;
      o += a.slice(0, 1) === "/" ? a.slice(1) : a;
      break;
    }
    default:
      n("abort", 400);
      return;
  }
  let i = 503;
  Ct(e + o).then((a) => {
    const r = a.status;
    if (r !== 200) {
      setTimeout(() => {
        n(Dr(r) ? "abort" : "next", r);
      });
      return;
    }
    return i = 501, a.json();
  }).then((a) => {
    if (typeof a != "object" || a === null) {
      setTimeout(() => {
        a === 404 ? n("abort", a) : n("next", i);
      });
      return;
    }
    setTimeout(() => {
      n("success", a);
    });
  }).catch(() => {
    n("next", i);
  });
}, Hr = {
  prepare: Rr,
  send: Vr
};
function Qn(e, t) {
  switch (e) {
    case "local":
    case "session":
      ke[e] = t;
      break;
    case "all":
      for (const n in ke)
        ke[n] = t;
      break;
  }
}
const Ut = "data-style";
let _o = "";
function Go(e) {
  _o = e;
}
function Yn(e, t) {
  let n = Array.from(e.childNodes).find((o) => o.hasAttribute && o.hasAttribute(Ut));
  n || (n = document.createElement("style"), n.setAttribute(Ut, Ut), e.appendChild(n)), n.textContent = ":host{display:inline-block;vertical-align:" + (t ? "-0.125em" : "0") + "}span,svg{display:block}" + _o;
}
function Qo() {
  jn("", Hr), $o(!0);
  let e;
  try {
    e = window;
  } catch {
  }
  if (e) {
    if (Uo(), e.IconifyPreload !== void 0) {
      const n = e.IconifyPreload, o = "Invalid IconifyPreload syntax.";
      typeof n == "object" && n !== null && (n instanceof Array ? n : [n]).forEach((i) => {
        try {
          // Check if item is an object and not null/array
          (typeof i != "object" || i === null || i instanceof Array || // Check for 'icons' and 'prefix'
          typeof i.icons != "object" || typeof i.prefix != "string" || // Add icon set
          !Hn(i)) && console.error(o);
        } catch {
          console.error(o);
        }
      });
    }
    if (e.IconifyProviders !== void 0) {
      const n = e.IconifyProviders;
      if (typeof n == "object" && n !== null)
        for (const o in n) {
          const i = "IconifyProviders[" + o + "] is invalid.";
          try {
            const a = n[o];
            if (typeof a != "object" || !a || a.resources === void 0)
              continue;
            Un(o, a) || console.error(i);
          } catch {
            console.error(i);
          }
        }
    }
  }
  return {
    enableCache: (n) => Qn(n, !0),
    disableCache: (n) => Qn(n, !1),
    iconLoaded: Bn,
    iconExists: Bn,
    // deprecated, kept to avoid breaking changes
    getIcon: or,
    listIcons: nr,
    addIcon: Oo,
    addCollection: Hn,
    calculateSize: an,
    buildIcon: Ko,
    iconToHTML: An,
    svgToURL: qo,
    loadIcons: In,
    loadIcon: yr,
    addAPIProvider: Un,
    appendCustomStyle: Go,
    _api: {
      getAPIConfig: $t,
      setAPIModule: jn,
      sendAPIQuery: Ro,
      setFetch: $r,
      getFetch: Or,
      listAPIProviders: dr
    }
  };
}
const ln = {
  "background-color": "currentColor"
}, Yo = {
  "background-color": "transparent"
}, Xn = {
  image: "var(--svg)",
  repeat: "no-repeat",
  size: "100% 100%"
}, Zn = {
  "-webkit-mask": ln,
  mask: ln,
  background: Yo
};
for (const e in Zn) {
  const t = Zn[e];
  for (const n in Xn)
    t[e + "-" + n] = Xn[n];
}
function Jn(e) {
  return e ? e + (e.match(/^[-0-9.]+$/) ? "px" : "") : "inherit";
}
function Br(e, t, n) {
  const o = document.createElement("span");
  let i = e.body;
  i.indexOf("<a") !== -1 && (i += "<!-- " + Date.now() + " -->");
  const a = e.attributes, r = An(i, {
    ...a,
    width: t.width + "",
    height: t.height + ""
  }), l = qo(r), s = o.style, c = {
    "--svg": l,
    width: Jn(a.width),
    height: Jn(a.height),
    ...n ? ln : Yo
  };
  for (const u in c)
    s.setProperty(u, c[u]);
  return o;
}
let Je;
function jr() {
  try {
    Je = window.trustedTypes.createPolicy("iconify", {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      createHTML: (e) => e
    });
  } catch {
    Je = null;
  }
}
function Ur(e) {
  return Je === void 0 && jr(), Je ? Je.createHTML(e) : e;
}
function Wr(e) {
  const t = document.createElement("span"), n = e.attributes;
  let o = "";
  n.width || (o = "width: inherit;"), n.height || (o += "height: inherit;"), o && (n.style = o);
  const i = An(e.body, n);
  return t.innerHTML = Ur(i), t.firstChild;
}
function sn(e) {
  return Array.from(e.childNodes).find((t) => {
    const n = t.tagName && t.tagName.toUpperCase();
    return n === "SPAN" || n === "SVG";
  });
}
function eo(e, t) {
  const n = t.icon.data, o = t.customisations, i = Ko(n, o);
  o.preserveAspectRatio && (i.attributes.preserveAspectRatio = o.preserveAspectRatio);
  const a = t.renderedMode;
  let r;
  switch (a) {
    case "svg":
      r = Wr(i);
      break;
    default:
      r = Br(i, {
        ...at,
        ...n
      }, a === "mask");
  }
  const l = sn(e);
  l ? r.tagName === "SPAN" && l.tagName === r.tagName ? l.setAttribute("style", r.getAttribute("style")) : e.replaceChild(r, l) : e.appendChild(r);
}
function to(e, t, n) {
  const o = n && (n.rendered ? n : n.lastRender);
  return {
    rendered: !1,
    inline: t,
    icon: e,
    lastRender: o
  };
}
function Kr(e = "iconify-icon") {
  let t, n;
  try {
    t = window.customElements, n = window.HTMLElement;
  } catch {
    return;
  }
  if (!t || !n)
    return;
  const o = t.get(e);
  if (o)
    return o;
  const i = [
    // Icon
    "icon",
    // Mode
    "mode",
    "inline",
    "noobserver",
    // Customisations
    "width",
    "height",
    "rotate",
    "flip"
  ], a = class extends n {
    /**
     * Constructor
     */
    constructor() {
      super();
      // Root
      ve(this, "_shadowRoot");
      // Initialised
      ve(this, "_initialised", !1);
      // Icon state
      ve(this, "_state");
      // Attributes check queued
      ve(this, "_checkQueued", !1);
      // Connected
      ve(this, "_connected", !1);
      // Observer
      ve(this, "_observer", null);
      ve(this, "_visible", !0);
      const s = this._shadowRoot = this.attachShadow({
        mode: "open"
      }), c = this.hasAttribute("inline");
      Yn(s, c), this._state = to({
        value: ""
      }, c), this._queueCheck();
    }
    /**
     * Connected to DOM
     */
    connectedCallback() {
      this._connected = !0, this.startObserver();
    }
    /**
     * Disconnected from DOM
     */
    disconnectedCallback() {
      this._connected = !1, this.stopObserver();
    }
    /**
     * Observed attributes
     */
    static get observedAttributes() {
      return i.slice(0);
    }
    /**
     * Observed properties that are different from attributes
     *
     * Experimental! Need to test with various frameworks that support it
     */
    /*
    static get properties() {
        return {
            inline: {
                type: Boolean,
                reflect: true,
            },
            // Not listing other attributes because they are strings or combination
            // of string and another type. Cannot have multiple types
        };
    }
    */
    /**
     * Attribute has changed
     */
    attributeChangedCallback(s) {
      switch (s) {
        case "inline": {
          const c = this.hasAttribute("inline"), u = this._state;
          c !== u.inline && (u.inline = c, Yn(this._shadowRoot, c));
          break;
        }
        case "noobserver": {
          this.hasAttribute("noobserver") ? this.startObserver() : this.stopObserver();
          break;
        }
        default:
          this._queueCheck();
      }
    }
    /**
     * Get/set icon
     */
    get icon() {
      const s = this.getAttribute("icon");
      if (s && s.slice(0, 1) === "{")
        try {
          return JSON.parse(s);
        } catch {
        }
      return s;
    }
    set icon(s) {
      typeof s == "object" && (s = JSON.stringify(s)), this.setAttribute("icon", s);
    }
    /**
     * Get/set inline
     */
    get inline() {
      return this.hasAttribute("inline");
    }
    set inline(s) {
      s ? this.setAttribute("inline", "true") : this.removeAttribute("inline");
    }
    /**
     * Get/set observer
     */
    get observer() {
      return this.hasAttribute("observer");
    }
    set observer(s) {
      s ? this.setAttribute("observer", "true") : this.removeAttribute("observer");
    }
    /**
     * Restart animation
     */
    restartAnimation() {
      const s = this._state;
      if (s.rendered) {
        const c = this._shadowRoot;
        if (s.renderedMode === "svg")
          try {
            c.lastChild.setCurrentTime(0);
            return;
          } catch {
          }
        eo(c, s);
      }
    }
    /**
     * Get status
     */
    get status() {
      const s = this._state;
      return s.rendered ? "rendered" : s.icon.data === null ? "failed" : "loading";
    }
    /**
     * Queue attributes re-check
     */
    _queueCheck() {
      this._checkQueued || (this._checkQueued = !0, setTimeout(() => {
        this._check();
      }));
    }
    /**
     * Check for changes
     */
    _check() {
      if (!this._checkQueued)
        return;
      this._checkQueued = !1;
      const s = this._state, c = this.getAttribute("icon");
      if (c !== s.icon.value) {
        this._iconChanged(c);
        return;
      }
      if (!s.rendered || !this._visible)
        return;
      const u = this.getAttribute("mode"), d = Pn(this);
      (s.attrMode !== u || Qi(s.customisations, d) || !sn(this._shadowRoot)) && this._renderIcon(s.icon, d, u);
    }
    /**
     * Icon value has changed
     */
    _iconChanged(s) {
      const c = Cr(s, (u, d, f) => {
        const h = this._state;
        if (h.rendered || this.getAttribute("icon") !== u)
          return;
        const v = {
          value: u,
          name: d,
          data: f
        };
        v.data ? this._gotIconData(v) : h.icon = v;
      });
      c.data ? this._gotIconData(c) : this._state = to(c, this._state.inline, this._state);
    }
    /**
     * Force render icon on state change
     */
    _forceRender() {
      if (!this._visible) {
        const s = sn(this._shadowRoot);
        s && this._shadowRoot.removeChild(s);
        return;
      }
      this._queueCheck();
    }
    /**
     * Got new icon data, icon is ready to (re)render
     */
    _gotIconData(s) {
      this._checkQueued = !1, this._renderIcon(s, Pn(this), this.getAttribute("mode"));
    }
    /**
     * Re-render based on icon data
     */
    _renderIcon(s, c, u) {
      const d = kr(s.data.body, u), f = this._state.inline;
      eo(this._shadowRoot, this._state = {
        rendered: !0,
        icon: s,
        inline: f,
        customisations: c,
        attrMode: u,
        renderedMode: d
      });
    }
    /**
     * Start observer
     */
    startObserver() {
      if (!this._observer && !this.hasAttribute("noobserver"))
        try {
          this._observer = new IntersectionObserver((s) => {
            const c = s.some((u) => u.isIntersecting);
            c !== this._visible && (this._visible = c, this._forceRender());
          }), this._observer.observe(this);
        } catch {
          if (this._observer) {
            try {
              this._observer.disconnect();
            } catch {
            }
            this._observer = null;
          }
        }
    }
    /**
     * Stop observer
     */
    stopObserver() {
      this._observer && (this._observer.disconnect(), this._observer = null, this._visible = !0, this._connected && this._forceRender());
    }
  };
  i.forEach((l) => {
    l in a.prototype || Object.defineProperty(a.prototype, l, {
      get: function() {
        return this.getAttribute(l);
      },
      set: function(s) {
        s !== null ? this.setAttribute(l, s) : this.removeAttribute(l);
      }
    });
  });
  const r = Qo();
  for (const l in r)
    a[l] = a.prototype[l] = r[l];
  return t.define(e, a), a;
}
const Xo = Kr() || Qo(), {
  enableCache: qr,
  disableCache: _r,
  iconLoaded: Gr,
  iconExists: Qr,
  // deprecated, kept to avoid breaking changes
  getIcon: Yr,
  listIcons: Xr,
  addIcon: Zr,
  addCollection: Zo,
  calculateSize: Jr,
  buildIcon: ea,
  iconToHTML: ta,
  svgToURL: na,
  loadIcons: oa,
  loadIcon: ia,
  addAPIProvider: ra,
  _api: aa
} = Xo, x0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconifyIconComponent: Xo,
  _api: aa,
  addAPIProvider: ra,
  addCollection: Zo,
  addIcon: Zr,
  appendCustomStyle: Go,
  buildIcon: ea,
  calculateSize: Jr,
  disableCache: _r,
  enableCache: qr,
  getIcon: Yr,
  iconExists: Qr,
  iconLoaded: Gr,
  iconToHTML: ta,
  listIcons: Xr,
  loadIcon: ia,
  loadIcons: oa,
  svgToURL: na
}, Symbol.toStringTag, { value: "Module" }));
function la(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Jo = {}, ei = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  function t(o, i) {
    return {
      handler: o,
      config: i
    };
  }
  t.withOptions = function(o, i = () => ({})) {
    const a = function(r) {
      return {
        __options: r,
        handler: o(r),
        config: i(r)
      };
    };
    return a.__isOptionsFunction = !0, a.__pluginFunction = o, a.__configFunction = i, a;
  };
  const n = t;
})(ei);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return o;
    }
  });
  const t = /* @__PURE__ */ n(ei);
  function n(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  const o = t.default;
})(Jo);
let Wt = Jo;
var sa = (Wt.__esModule ? Wt : { default: Wt }).default;
const ca = /* @__PURE__ */ la(sa), ee = {
  white: "#FFFFFF",
  lin: "#F7F6F0",
  charcoal: "#2B2B2B",
  black: "#131313"
}, ne = {
  700: "#BA5225",
  600: "#CD4D16",
  500: "#EB512F",
  // Corale
  450: "#F9885E",
  400: "#F5B1A2",
  300: "#FCE2DD",
  200: "#FDEFEC",
  100: "#FEF7F5"
}, Q = {
  750: "#1D1D1D",
  700: "#404040",
  600: "#525252",
  500: "#737373",
  400: "#A3A3A3",
  300: "#D4D4D4",
  200: "#E5E5E5",
  150: "#EEEEEE",
  100: "#F5F5F5"
}, Ve = {
  500: "#1C6BB8",
  // Lapis-lazuli
  450: "#528BDD",
  300: "#71B9FF",
  100: "#EAEFF8"
}, dt = {
  700: "#247A5E",
  200: "#EBF8F3"
}, ft = {
  600: "#C83844",
  500: "#EB4452",
  200: "#F8EFF0"
}, ht = {
  800: "#95672B",
  500: "#FBBA66",
  200: "#FFF8F0"
}, ue = {
  500: "#9C3BC9",
  400: "#BF8FE4",
  300: "#D3ADEF",
  100: "#F0DBFF",
  50: "#F8F1FC"
}, oe = {
  "orange-600-25": "#CD4D1640",
  "neutral-800-15": "#17171726",
  "neutral-800-25": "#17171740",
  "lin-25": "#F7F6F040",
  "lavender-300-25": "#D3ADEF40",
  transparent: "#00000000"
}, Kt = {
  DEFAULT: Ve[450],
  focus: Ve[450],
  "focus-inverse": Ve[300]
}, cn = [
  "Circular",
  '"system-ui"',
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  "Roboto",
  '"Helvetica Neue"',
  "Arial",
  '"Noto Sans"',
  "sans-serif",
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
  '"Noto Color Emoji"'
], ua = ["neue-haas-display", ...cn], mt = {
  background: {
    default: Q[150],
    surface: ee.white,
    "surface-hover": Q[100],
    "surface-neutral": Q[100],
    fill: ee.lin,
    "fill-accent": ue[300],
    "fill-accent-discrete": ue[100],
    "fill-accent-discrete2": ue[50],
    "fill-accent-hover": ue[400],
    "fill-accent-disabled": oe["lavender-300-25"],
    "fill-alt": ee.charcoal,
    "fill-alt-hover": Q[750],
    "fill-brand": ne[100],
    "fill-hover": Q[150],
    "fill-hover-primary": ne[200],
    "fill-alt-disabled": oe["neutral-800-15"],
    "fill-primary": ne[600],
    "fill-primary-disabled": oe["orange-600-25"],
    "fill-primary-hover": ne[700],
    "fill-tip": Ve[100],
    "fill-error": ft[200],
    "fill-success": dt[200],
    "fill-caution": ht[200],
    "fill-discrete": Q[300],
    "fill-discrete2": Q[200],
    "fill-discrete3": Q[150],
    "fill-neutral": Q[500],
    "fill-neutral-hover": Q[700],
    "fill-neutral-alt-hover": Q[400],
    "fill-primary-discrete": ne[300],
    "fill-primary-discrete2": ne[200],
    "fill-primary-discrete1": ne[100],
    transparent: oe.transparent
  },
  text: {
    // adding this to make sure there's always a way to access the default color
    "default-color": ee.charcoal,
    accent: ue[500],
    "accent-disabled": oe["lavender-300-25"],
    inverse: ee.lin,
    "inverse-accent": ue[300],
    "inverse-disabled": ee.lin,
    abovePrimary: ee.lin,
    "abovePrimary-disabled": oe["lin-25"],
    primary: ne[600],
    "primary-disabled": oe["orange-600-25"],
    "primary-discrete": ne[400],
    discrete: Q[600],
    discrete2: Q[500],
    discrete3: Q[400],
    disabled: oe["neutral-800-25"],
    success: dt[700],
    error: ft[600],
    caution: ht[800],
    link: ne[600],
    "link-inverse": ne[450]
  },
  border: {
    default: ee.charcoal,
    // adding this to make sure there's always a way to access the default color
    "default-color": ee.charcoal,
    inverse: ee.lin,
    accent: ue[500],
    "accent-disabled": oe["lavender-300-25"],
    "inverse-accent": ue[300],
    primary: ne[600],
    "primary-disabled": oe["orange-600-25"],
    error: ft[500],
    success: dt[700],
    tip: Ve[500],
    caution: ht[500],
    discrete: Q[500],
    discrete2: Q[400],
    discrete3: Q[300],
    disabled: oe["neutral-800-25"],
    brand: ne[400],
    transparent: oe.transparent
  },
  icon: {
    icon: ee.charcoal,
    // default
    "icon-accent": ue[500],
    "icon-accent-disabled": oe["lavender-300-25"],
    "icon-inverse-accent": ue[300],
    "icon-inverse": ee.lin,
    "icon-primary": ne[600],
    "icon-brand": ne[500],
    "icon-abovePrimary": ee.lin,
    "icon-abovePrimary-disabled": ee.lin,
    "icon-primary-disabled": oe["orange-600-25"],
    "icon-discrete": Q[600],
    "icon-discrete2": Q[500],
    "icon-discrete3": Q[400],
    "icon-disabled": oe["neutral-800-25"],
    "icon-success": dt[700],
    "icon-error": ft[600],
    "icon-tip": Ve[500],
    "icon-caution": ht[500]
  }
}, da = {
  screens: {
    sm: "320px",
    md: "768px",
    lg: "1024px"
  },
  fontFamily: {
    DEFAULT: cn,
    sans: cn,
    title: ua
  },
  fontSize: {
    DEFAULT: "1rem",
    // 16px
    "2xs": "0.75rem",
    // 12px
    xs: "0.8125rem",
    // 13px
    sm: "0.875rem",
    // 14px
    base: "1rem",
    // 16px
    lg: "1.125rem",
    // 18px
    xl: "1.25rem",
    // 20px
    "2xl": "1.5rem",
    // 24px
    "3xl": "1.75rem",
    // 28px
    "4xl": "2.25rem",
    // 36px
    "5xl": "3rem",
    // 48px
    "6xl": "3.75rem"
    // 60px
  },
  lineHeight: {
    DEFAULT: "1.5rem",
    // 24px
    sm: "1.25rem",
    // 20px
    "3xl": "2rem",
    // 32px
    "4xl": "3rem",
    // 40px
    "5xl": "3.5rem",
    // 64px
    "6xl": "4.5rem"
    // 72px
  },
  fontWeight: {
    DEFAULT: "450",
    normal: "450",
    medium: "500",
    bold: "700",
    black: "900"
  },
  spacing: {
    zero: "0px",
    "4xs": "1px",
    "3xs": "2px",
    "2xs": "4px",
    xs: "6px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "20px",
    "2xl": "24px",
    "3xl": "32px",
    "4xl": "40px",
    "5xl": "48px",
    "6xl": "64px",
    "7xl": "80px",
    "8xl": "120px",
    "9xl": "150px",
    "10xl": "256px"
  },
  borderRadius: {
    DEFAULT: "4px",
    none: "0",
    xs: "2px",
    sm: "4px",
    md: "6px",
    lg: "8px",
    xl: "12px",
    "2xl": "16px",
    "3xl": "24px",
    "4xl": "40px",
    full: "9999px"
  },
  boxShadow: {
    DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
    base: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
    sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    md: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
    lg: "0 10px 15px -3px rgb(0 0 0 / 0.1)",
    xl: "0 20px 25px -5px rgb(0 0 0 / 0.1)",
    "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
    reverse: "0 -10px 15px -3 rgb(0 0 0 / 0.05)"
  },
  color: {
    transparent: "transparent",
    black: ee.black,
    white: ee.white
  },
  borderColor: {
    ...mt.border
  },
  outlineColor: () => Kt,
  ringColor: () => Kt,
  ringOffsetColor: () => Kt,
  backgroundColor: {
    ...mt.background
  },
  textColor: {
    ...mt.text,
    ...mt.icon
  },
  transitionTimingFunction: {
    "slow-down": "cubic-bezier(0, 0.35, 0, 1)",
    smooth: "cubic-bezier(0.35, 0.1, 0, 1)"
  }
}, fa = {
  theme: {
    ...da
  }
}, C0 = ca(
  function({ addBase: e, addComponents: t, theme: n }) {
    const o = {
      fontSize: n("fontSize.6xl"),
      fontFamily: n("fontFamily.title"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.6xl"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.5xl"),
        lineHeight: n("lineHeight.5xl")
      }
    }, i = {
      fontSize: n("fontSize.5xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.5xl"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.4xl"),
        lineHeight: n("lineHeight.4xl")
      }
    }, a = {
      fontSize: n("fontSize.4xl"),
      fontWeight: n("fontWeight.black"),
      fontFamily: n("fontFamily.title"),
      lineHeight: n("lineHeight.4xl"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.3xl"),
        lineHeight: n("lineHeight.3xl")
      }
    }, r = {
      fontSize: n("fontSize.3xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.3xl"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.2xl"),
        lineHeight: n("lineHeight.2xl")
      }
    }, l = {
      fontSize: n("fontSize.2xl"),
      lineHeight: n("lineHeight.3xl"),
      fontWeight: n("fontWeight.black"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.xl"),
        lineHeight: n("lineHeight.xl")
      }
    }, s = {
      fontSize: n("fontSize.xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.DEFAULT"),
      fontFamily: n("fontFamily.title")
    };
    t({
      ".text-h1": o,
      ".text-h2": i,
      ".text-h3": a,
      ".text-h4": r,
      ".text-h5": l,
      ".text-h6": s,
      ".text-body": {
        fontSize: n("fontSize.DEFAULT"),
        lineHeight: n("lineHeight.DEFAULT")
      },
      ".text-body-lg": {
        fontSize: n("fontSize.lg"),
        lineHeight: n("lineHeight.DEFAULT")
      },
      ".text-body-sm": {
        fontSize: n("fontSize.sm"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-body-xs": {
        fontSize: n("fontSize.xs"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-form-error": {
        color: n("textColor.error"),
        fontSize: n("fontSize.sm"),
        fontWeight: n("fontWeight.medium"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-heading-uppercase": {
        fontSize: n("fontSize.2xs"),
        fontWeight: n("fontWeight.medium"),
        lineHeight: n("lineHeight.sm"),
        textTransform: "uppercase"
      }
    });
  },
  {
    theme: {
      ...fa.theme
    }
  }
), ha = ["icon", "aria-label"], ma = {}, B = /* @__PURE__ */ U({
  ...ma,
  __name: "UIIcon",
  props: {
    name: {},
    size: { default: "base" }
  },
  setup(e) {
    let t;
    ((i) => {
      i.sm = "16", i.base = "20", i.lg = "24", i.xl = "32", i["2xl"] = "40";
    })(t || (t = {}));
    const n = e, o = q({
      height: `${t[n.size]}px`,
      width: `${t[n.size]}px`,
      style: {
        height: `${t[n.size]}px`,
        width: `${t[n.size]}px`
      },
      class: "tw-inline-block",
      role: "img",
      "data-allow-mismatch": !0
    });
    return (i, a) => (g(), I("iconify-icon", me({ icon: i.name }, o.value, { "aria-label": i.name }), null, 16, ha));
  }
}), pa = ["disabled", "checked"], ti = /* @__PURE__ */ U({
  __name: "BaseChip",
  props: /* @__PURE__ */ ie({
    color: { default: "default" },
    component: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    iconLeftName: { default: "" },
    iconRightName: { default: "" },
    size: { default: "base" },
    text: { default: "" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ie(["click"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = t, o = fe(e, "modelValue"), i = k(() => ({
      "tw-flex tw-w-fit tw-items-center tw-gap-2xs tw-rounded-full tw-transition-all": !0
    })), a = k(() => ({
      "tw-cursor-not-allowed": e.disabled,
      "tw-bg-fill-discrete3": e.color === "default",
      "hover:tw-bg-fill-discrete2": e.color === "default" && !e.disabled,
      "tw-bg-fill-alt": e.color === "alt",
      "tw-bg-fill-success": e.color === "success",
      "tw-bg-fill-caution": e.color === "warning",
      "tw-bg-fill-error": e.color === "error",
      "tw-bg-surface": e.color === "dashed",
      "hover:tw-bg-surface-hover": e.color === "dashed" && !e.disabled
    })), r = k(() => ({
      "tw-border-dashed tw-border tw-border-discrete3": e.color === "dashed",
      "tw-border-transparent tw-border": e.color !== "dashed",
      "focus-visible:tw-outline": !e.disabled && e.component !== "input",
      "focus-within:tw-outline": !e.disabled && e.component === "input"
    })), l = k(() => ({
      "tw-px-sm tw-py-xs": e.size === "sm",
      "tw-px-md tw-py-sm": e.size === "base"
    })), s = k(() => ({
      // color for disabled chips variants
      "tw-text-discrete3": e.disabled && ["default", "alt"].includes(e.color),
      "tw-text-discrete": !e.disabled && e.color === "default",
      "tw-text-inverse": !e.disabled && e.color === "alt",
      // color for never disabled chips variants
      "tw-text-success": e.color === "success",
      "tw-text-caution": e.color === "warning",
      "tw-text-error": e.color === "error",
      // size
      "tw-text-body-xs": e.size === "sm",
      "tw-text-body-sm": e.size === "base"
    })), c = k(() => ({
      // color for disabled chips variants
      "tw-text-discrete3": e.disabled && ["default", "alt"].includes(e.color),
      "tw-text-discrete": !e.disabled && e.color === "default",
      "tw-text-inverse": !e.disabled && e.color === "alt",
      // color for never disabled chips variants
      "tw-text-icon-success": e.color === "success",
      "tw-text-icon-caution": e.color === "warning",
      "tw-text-icon-error": e.color === "error"
    }));
    return (u, d) => u.component === "input" ? (g(), I("label", {
      key: 0,
      class: F([
        i.value,
        a.value,
        l.value,
        r.value
      ]),
      onClick: d[1] || (d[1] = (f) => n("click")),
      onKeypress: d[2] || (d[2] = gt((f) => n("click"), ["space"]))
    }, [
      R("input", {
        type: "checkbox",
        class: "tw-sr-only",
        disabled: u.disabled,
        checked: o.value,
        onClick: d[0] || (d[0] = Xt(() => {
        }, ["stop"]))
      }, null, 8, pa),
      u.iconLeftName ? (g(), P(B, {
        key: 0,
        name: u.iconLeftName,
        size: "sm",
        class: F(c.value)
      }, null, 8, ["name", "class"])) : E("", !0),
      u.text ? (g(), I("span", {
        key: 1,
        "data-test-id": "chip-text",
        class: F(["tw-px-3xs", [s.value]])
      }, Y(u.text), 3)) : E("", !0),
      u.iconRightName ? (g(), P(B, {
        key: 2,
        name: u.iconRightName,
        size: "sm",
        class: F(c.value)
      }, null, 8, ["name", "class"])) : E("", !0)
    ], 34)) : (g(), P(We(u.component), {
      key: 1,
      class: F([
        i.value,
        a.value,
        l.value,
        r.value
      ]),
      disabled: u.disabled ? !0 : void 0,
      onClick: d[3] || (d[3] = (f) => n("click"))
    }, {
      default: G(() => [
        u.iconLeftName ? (g(), P(B, {
          key: 0,
          name: u.iconLeftName,
          size: "sm",
          class: F(c.value)
        }, null, 8, ["name", "class"])) : E("", !0),
        u.text ? (g(), I("span", {
          key: 1,
          "data-test-id": "chip-text",
          class: F(["tw-px-3xs", [s.value]])
        }, Y(u.text), 3)) : E("", !0),
        u.iconRightName ? (g(), P(B, {
          key: 2,
          name: u.iconRightName,
          size: "sm",
          class: F(c.value)
        }, null, 8, ["name", "class"])) : E("", !0)
      ]),
      _: 1
    }, 8, ["class", "disabled"]));
  }
});
function Ot(e) {
  const t = Ei("NuxtLink"), n = Ft(), o = k(() => t === "NuxtLink" ? "a" : t), i = k(() => W(e) || n.href ? o.value : "button"), a = k(() => {
    const s = W(e) ?? n.href ?? "";
    return i.value === "button" ? {
      type: "button"
    } : { href: r(s) ? s : l(s) };
  });
  function r(s) {
    return s.startsWith("http");
  }
  function l(s) {
    return s;
  }
  return typeof useLocalePath == "function" && (l = useLocalePath()), {
    componentAttrs: a,
    isExternalLink: r,
    linkComponent: o,
    linkOrButtonComponent: i,
    localePath: l
  };
}
function Lt(e) {
  return go() ? (yo(e), !0) : !1;
}
const qt = /* @__PURE__ */ new WeakMap(), va = (...e) => {
  var t;
  const n = e[0], o = (t = yn()) == null ? void 0 : t.proxy;
  if (o == null && !xo())
    throw new Error("injectLocal must be called in setup");
  return o && qt.has(o) && n in qt.get(o) ? qt.get(o)[n] : Fi(...e);
}, En = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const wa = (e) => e != null, ba = Object.prototype.toString, ni = (e) => ba.call(e) === "[object Object]", xe = () => {
}, un = /* @__PURE__ */ ga();
function ga() {
  var e, t;
  return En && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function no(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function ya(e) {
  return yn();
}
function Te(e) {
  return Array.isArray(e) ? e : [e];
}
function xa(...e) {
  if (e.length !== 1)
    return xn(...e);
  const t = e[0];
  return typeof t == "function" ? Ni($i(() => ({ get: t, set: xe }))) : q(t);
}
function Ca(e, t = !0, n) {
  ya() ? gn(e, n) : t ? e() : zi(e);
}
function ka(e = !1, t = {}) {
  const {
    truthyValue: n = !0,
    falsyValue: o = !1
  } = t, i = Mi(e), a = q(e);
  function r(l) {
    if (arguments.length)
      return a.value = l, a.value;
    {
      const s = W(n);
      return a.value = a.value === s ? W(o) : s, a.value;
    }
  }
  return i ? r : [a, r];
}
function oi(e, t, n) {
  return le(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
const Mn = En ? window : void 0;
function ii(e) {
  var t;
  const n = W(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function dn(...e) {
  const t = [], n = () => {
    t.forEach((l) => l()), t.length = 0;
  }, o = (l, s, c, u) => (l.addEventListener(s, c, u), () => l.removeEventListener(s, c, u)), i = k(() => {
    const l = Te(W(e[0])).filter((s) => s != null);
    return l.every((s) => typeof s != "string") ? l : void 0;
  }), a = oi(
    () => {
      var l, s;
      return [
        (s = (l = i.value) == null ? void 0 : l.map((c) => ii(c))) != null ? s : [Mn].filter((c) => c != null),
        Te(W(i.value ? e[1] : e[0])),
        Te(A(i.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        W(i.value ? e[3] : e[2])
      ];
    },
    ([l, s, c, u]) => {
      if (n(), !(l != null && l.length) || !(s != null && s.length) || !(c != null && c.length))
        return;
      const d = ni(u) ? { ...u } : u;
      t.push(
        ...l.flatMap(
          (f) => s.flatMap(
            (h) => c.map((v) => o(f, h, v, d))
          )
        )
      );
    },
    { flush: "post" }
  ), r = () => {
    a(), n();
  };
  return Lt(n), r;
}
function Ta() {
  const e = Ie(!1), t = yn();
  return t && gn(() => {
    e.value = !0;
  }, t), e;
}
function Sa(e) {
  const t = Ta();
  return k(() => (t.value, !!e()));
}
const Ia = Symbol("vueuse-ssr-width");
function Aa() {
  const e = xo() ? va(Ia, null) : null;
  return typeof e == "number" ? e : void 0;
}
function Ea(e, t = {}) {
  const { window: n = Mn, ssrWidth: o = Aa() } = t, i = Sa(() => n && "matchMedia" in n && typeof n.matchMedia == "function"), a = q(typeof o == "number"), r = Ie(), l = Ie(!1), s = (c) => {
    l.value = c.matches;
  };
  return Oi(() => {
    if (a.value) {
      a.value = !i.value;
      const c = W(e).split(",");
      l.value = c.some((u) => {
        const d = u.includes("not all"), f = u.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), h = u.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let v = !!(f || h);
        return f && v && (v = o >= no(f[1])), h && v && (v = o <= no(h[1])), d ? !v : v;
      });
      return;
    }
    i.value && (r.value = n.matchMedia(W(e)), l.value = r.value.matches);
  }), dn(r, "change", s, { passive: !0 }), k(() => l.value);
}
function Ma(e = {}) {
  const {
    window: t = Mn,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: o = Number.POSITIVE_INFINITY,
    listenOrientation: i = !0,
    includeScrollbar: a = !0,
    type: r = "inner"
  } = e, l = q(n), s = q(o), c = () => {
    if (t)
      if (r === "outer")
        l.value = t.outerWidth, s.value = t.outerHeight;
      else if (r === "visual" && t.visualViewport) {
        const { width: d, height: f, scale: h } = t.visualViewport;
        l.value = Math.round(d * h), s.value = Math.round(f * h);
      } else a ? (l.value = t.innerWidth, s.value = t.innerHeight) : (l.value = t.document.documentElement.clientWidth, s.value = t.document.documentElement.clientHeight);
  };
  c(), Ca(c);
  const u = { passive: !0 };
  if (dn("resize", c, u), t && r === "visual" && t.visualViewport && dn(t.visualViewport, "resize", c, u), i) {
    const d = Ea("(orientation: portrait)");
    le(d, () => c());
  }
  return { width: l, height: s };
}
var Ye = /* @__PURE__ */ ((e) => (e[e.sm = 320] = "sm", e[e.md = 768] = "md", e[e.lg = 1024] = "lg", e))(Ye || {});
function za() {
  const { width: e } = Ma(), t = k(() => e.value < Ye.md), n = k(
    () => e.value >= Ye.md && e.value < Ye.lg
  ), o = k(() => e.value >= Ye.lg);
  return {
    isSm: t,
    isMd: n,
    isLg: o
  };
}
function ri(e) {
  const { isSm: t } = za(), n = k(() => {
    const i = W(e);
    return i === "large" && t.value ? "medium" : i === "medium" && t.value ? "small" : i;
  }), o = k(
    () => n.value === "large" ? "lg" : "base"
  );
  return {
    scaledButtonSize: n,
    scaledIconSize: o
  };
}
function te(e, t = {}) {
  return !Fa(e, t);
}
function Fa(e, t = {}) {
  return Na(e == null ? void 0 : e(t));
}
function Na(e) {
  return !e || $a(e).every(
    (t) => {
      var n, o;
      return t.type === Li || t.type === Di && !((n = t.children) != null && n.length) || t.type === tt && !((o = t.children) != null && o.length);
    }
  );
}
function $a(e) {
  return Array.isArray(e) ? e : e !== null ? [e] : [];
}
const Oa = { class: "tw-flex tw-items-center tw-justify-center tw-gap-x-2xs" }, La = {
  key: 2,
  class: "tw-whitespace-nowrap"
}, Da = {}, oo = /* @__PURE__ */ U({
  ...Da,
  __name: "UIButton",
  props: {
    color: { default: "default" },
    iconLeftName: { default: null },
    iconRightName: { default: null },
    size: { default: "medium" },
    text: { default: null },
    to: { default: void 0 },
    variant: { default: "primary" }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = Fe(), { linkOrButtonComponent: a, componentAttrs: r } = Ot(
      () => n.to
    ), { scaledButtonSize: l, scaledIconSize: s } = ri(
      xn(() => n.size)
    ), c = Ft(), u = "tw-p-3xs tw-text-sm tw-leading-sm tw-h-2xl", d = "tw-p-sm tw-text-sm tw-leading-sm tw-h-[36px]", f = "tw-p-md tw-text-base tw-leading tw-h-5xl", h = "tw-p-lg tw-text-lg tw-leading tw-h-[56px]", v = "tw-text-abovePrimary tw-bg-fill-primary tw-border-primary disabled:tw-bg-fill-primary-disabled hover:tw-bg-fill-primary-hover hover:tw-shadow-md", y = "tw-bg-fill-alt tw-text-inverse disabled:tw-bg-fill-alt-disabled hover:tw-bg-fill-alt-hover hover:tw-shadow-md", b = "tw-text-default-color tw-bg-fill-accent disabled:tw-bg-fill-accent-disabled hover:tw-bg-fill-accent-hover hover:tw-shadow-md disabled:tw-text-disabled", m = "tw-border tw-border-primary tw-text-primary disabled:tw-border-primary-disabled disabled:tw-text-primary-disabled hover:tw-bg-fill-hover-primary hover:tw-shadow-md", C = "tw-border tw-text disabled:tw-border-disabled disabled:tw-text-disabled hover:tw-bg-fill-hover hover:tw-shadow-md", x = "tw-border tw-border-accent tw-text-accent disabled:tw-border-inverse-accent disabled:tw-text-inverse-accent hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md", T = "tw-border tw-border-inverse-accent tw-text-inverse-accent disabled:tw-border-accent-disabled disabled:tw-text-accent-disabled hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md hover:tw-text-accent focus-visible:tw-bg-fill focus-visible:tw-text-accent", L = "tw-text-primary disabled:tw-text-primary-disabled hover:tw-bg-fill-hover-primary hover:tw-shadow-md", M = "tw-text tw-text-defaut-color disabled:tw-text-disabled hover:tw-bg-fill-hover hover:tw-shadow-md", z = "tw-text-accent disabled:tw-border-inverse-accent disabled:tw-text-inverse-accent hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md", j = "tw-text-inverse-accent disabled:tw-border-accent-disabled disabled:tw-text-accent-disabled hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md hover:tw-text-accent focus-visible:tw-bg-fill focus-visible:tw-text-accent", X = k(() => [
      n.variant === "primary" && n.color === "default" && v,
      n.variant === "primary" && n.color === "neutral" && y,
      n.variant === "primary" && n.color === "accent" && b,
      n.variant === "outlined" && n.color === "default" && m,
      n.variant === "outlined" && n.color === "neutral" && C,
      n.variant === "outlined" && n.color === "accent" && x,
      n.variant === "outlined" && n.color === "alt-accent" && T,
      n.variant === "transparent" && n.color === "default" && L,
      n.variant === "transparent" && n.color === "neutral" && M,
      n.variant === "transparent" && n.color === "accent" && z,
      n.variant === "transparent" && n.color === "alt-accent" && j
    ].join(" ").replaceAll("false", "")), K = k(() => [
      l.value === "xsmall" && u,
      l.value === "small" && d,
      l.value === "medium" && f,
      l.value === "large" && h
    ].join(" ").replaceAll("false", ""));
    return (Z, D) => (g(), P(We(A(a)), me({
      class: ["tw-font-base tw-ease-linear tw-inline-block tw-rounded-sm tw-transition-all tw-duration-100 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus disabled:tw-pointer-events-none", [X.value, K.value]],
      "data-allow-mismatch": "class"
    }, { ...A(r), ...A(c) }, {
      onClick: D[0] || (D[0] = (p) => o("click"))
    }), {
      default: G(() => [
        R("span", Oa, [
          Z.iconLeftName ? (g(), P(B, {
            key: 0,
            name: Z.iconLeftName,
            size: A(s)
          }, null, 8, ["name", "size"])) : E("", !0),
          A(te)(i.default) ? H(Z.$slots, "default", { key: 1 }) : Z.text ? (g(), I("span", La, Y(Z.text), 1)) : E("", !0),
          Z.iconRightName ? (g(), P(B, {
            key: 3,
            name: Z.iconRightName,
            size: A(s)
          }, null, 8, ["name", "size"])) : E("", !0)
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), Ra = { class: "tw-flex tw-flex-grow tw-flex-col tw-gap-3xs" }, Pa = {
  key: 1,
  class: "tw-flex-grow tw-gap-3xs"
}, Va = {
  key: 2,
  class: "tw-flex tw-h-xl"
}, Ha = /* @__PURE__ */ U({
  __name: "UIBanner",
  props: {
    state: { default: "brand" },
    customIconName: { default: "" },
    isDismissible: { type: Boolean, default: !1 },
    isSplitInTwoLines: { type: Boolean, default: !0 },
    link: { default: "" },
    target: { default: "_blank" },
    ctaText: { default: "" },
    ctaHref: { default: "" },
    ctaTarget: { default: "_blank" }
  },
  emits: ["dismiss", "previous", "next", "click", "ctaClick"],
  setup(e, { emit: t }) {
    const n = t, o = Fe(), i = k(() => te(o.paginationText)), a = k(() => {
      if (e.customIconName) return e.customIconName;
      const d = {
        success: "mdi:check-circle",
        caution: "mdi:information-slab-circle",
        error: "mdi:alert-circle",
        brand: "groover:logo",
        tip: "mdi:lightbulb-on",
        accent: "groover:groover-plus-logo"
      };
      return d[e.state] || d.brand;
    }), r = k(() => {
      const d = {
        success: "tw-text-icon-success",
        caution: "tw-text-icon-caution",
        error: "tw-text-icon-error",
        brand: "tw-text-icon-brand",
        tip: "tw-text-icon-tip",
        accent: "tw-text-icon-accent"
      };
      return d[e.state] || d.brand;
    }), l = k(() => {
      const d = {
        success: "tw-bg-fill-success tw-border-success",
        caution: "tw-bg-fill-caution tw-border-caution",
        error: "tw-bg-fill-error tw-border-error",
        brand: "tw-bg-fill-brand tw-border-brand",
        tip: "tw-bg-fill-tip tw-border-tip",
        accent: "tw-bg-fill-accent-discrete2 tw-border-inverse-accent"
      };
      return d[e.state] || d.brand;
    }), s = k(() => {
      const d = {
        success: "tw-text-success",
        caution: "tw-text-caution",
        error: "tw-text-error",
        brand: "tw-text-primary",
        tip: "tw-text-black",
        accent: "tw-text-accent"
      };
      return "tw-font-bold " + (d[e.state] || d.brand);
    }), c = k(
      () => e.link ? {
        href: e.link,
        target: e.target,
        rel: "noopener"
      } : {}
    ), u = k(() => {
      const d = {
        success: "neutral",
        caution: "neutral",
        error: "neutral",
        brand: "default",
        tip: "neutral",
        accent: "accent"
      }, f = {
        success: "outlined",
        caution: "outlined",
        error: "outlined",
        brand: "outlined",
        tip: "outlined",
        accent: "primary"
      };
      return {
        color: d[e.state] || d.brand,
        variant: f[e.state] || f.brand,
        text: e.ctaText,
        to: e.ctaHref,
        target: e.ctaHref && e.ctaTarget ? e.ctaTarget : void 0
      };
    });
    return (d, f) => (g(), P(We(d.link ? "a" : "div"), me(c.value, {
      onClick: f[5] || (f[5] = (h) => n("click", h))
    }), {
      default: G(() => [
        R("div", {
          role: "note",
          class: F(["tw-text-body-sm tw-flex tw-gap-sm tw-rounded-sm tw-border-2 tw-p-md tw-text-sm tw-leading-sm", l.value])
        }, [
          re(B, {
            name: a.value,
            class: F(r.value)
          }, null, 8, ["name", "class"]),
          d.isSplitInTwoLines ? (g(), I("div", {
            key: 0,
            class: F(["tw-flex tw-flex-grow tw-flex-col tw-gap-xs", [
              i.value ? "lg:tw-flex-col" : "lg:tw-flex-row lg:tw-items-center"
            ]])
          }, [
            R("div", Ra, [
              A(te)(o.title) ? (g(), I("p", {
                key: 0,
                class: F(s.value)
              }, [
                H(d.$slots, "title")
              ], 2)) : E("", !0),
              R("p", null, [
                H(d.$slots, "content")
              ])
            ]),
            d.ctaText ? (g(), P(oo, me({ key: 0 }, u.value, {
              class: "tw-w-fit",
              size: "small",
              onClick: f[0] || (f[0] = (h) => n("ctaClick"))
            }), null, 16)) : E("", !0)
          ], 2)) : (g(), I("div", Pa, [
            R("p", null, [
              A(te)(o.title) ? (g(), I(tt, { key: 0 }, [
                R("span", {
                  class: F(s.value)
                }, [
                  H(d.$slots, "title")
                ], 2),
                f[6] || (f[6] = Co(" "))
              ], 64)) : E("", !0),
              H(d.$slots, "content")
            ]),
            d.ctaText ? (g(), P(oo, me({ key: 0 }, u.value, {
              class: "tw-mt-xs tw-w-fit",
              size: "small",
              onClick: f[1] || (f[1] = (h) => n("ctaClick"))
            }), null, 16)) : E("", !0)
          ])),
          i.value ? (g(), I("div", Va, [
            R("button", {
              type: "button",
              "aria-label": "previous-arrow",
              class: "tw-text-icon-discrete",
              onClick: f[2] || (f[2] = Xt((h) => n("previous"), ["stop"]))
            }, [
              re(B, { name: "mdi:chevron-left" })
            ]),
            H(d.$slots, "paginationText"),
            R("button", {
              type: "button",
              class: "tw-text-icon-discrete",
              "aria-label": "next-arrow",
              onClick: f[3] || (f[3] = Xt((h) => n("next"), ["stop"]))
            }, [
              re(B, { name: "mdi:chevron-right" })
            ])
          ])) : E("", !0),
          d.isDismissible ? (g(), I("button", {
            key: 3,
            type: "button",
            class: "tw-font-semibold tw-mb-auto tw-ml-auto tw-h-xl tw-cursor-pointer tw-text-sm tw-text-icon-discrete",
            onClick: f[4] || (f[4] = (h) => n("dismiss"))
          }, [
            re(B, { name: "mdi:close" })
          ])) : E("", !0)
        ], 2)
      ]),
      _: 3
    }, 16));
  }
}), k0 = /* @__PURE__ */ U({
  __name: "UIBannerMulti",
  props: {
    config: {},
    pageSeparatorText: { default: "-" },
    isDismissible: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = Fe(), n = q(0), o = k(() => e.config[n.value]);
    function i() {
      n.value === e.config.length - 1 ? n.value = 0 : n.value++;
    }
    function a() {
      n.value === 0 ? n.value = e.config.length - 1 : n.value--;
    }
    return e.config.length < 1 && console.error("UIBannerMulti requires at least one UIBanner component"), e.config.length !== Object.keys(t).filter((r) => r.startsWith("content")).length && console.error(
      "UIBannerMulti requires the same number of content slots and single UIBanner configs"
    ), (r, l) => (g(), P(Ha, me(o.value, {
      "is-dismissible": r.isDismissible,
      onNext: i,
      onPrevious: a
    }), {
      paginationText: G(() => [
        Co(Y(n.value + 1) + " " + Y(r.pageSeparatorText) + " " + Y(r.config.length), 1)
      ]),
      title: G(() => [
        H(r.$slots, `title${n.value + 1}`)
      ]),
      content: G(() => [
        H(r.$slots, `content${n.value + 1}`)
      ]),
      _: 3
    }, 16, ["is-dismissible"]));
  }
}), Ba = { class: "tw-relative" }, ja = { class: "link-text tw-inline-block tw-w-full tw-transform tw-transition-transform tw-duration-[650ms] tw-ease-smooth" }, Ua = {}, Wa = /* @__PURE__ */ U({
  ...Ua,
  __name: "UIButtonLink",
  props: {
    color: { default: "default" },
    theme: { default: "light" },
    iconLeftName: { default: null },
    iconRightName: { default: null },
    to: {},
    size: { default: "medium" },
    isExternal: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, { linkComponent: n, localePath: o, isExternalLink: i } = Ot(
      () => t.to
    ), a = Ft(), { scaledButtonSize: r, scaledIconSize: l } = ri(
      xn(() => t.size)
    ), s = "tw-text-sm tw-leading-sm", c = "tw-text-base tw-leading", u = "tw-text-base tw-leading", d = "tw-text-primary tw-bg-gradient-to-r tw-from-bg-primary tw-to-bg-primary", f = t.theme === "light" ? "tw-bg-gradient-to-r tw-from-bg-fill-alt" : "tw-text-inverse tw-bg-gradient-to-r tw-from-bg-fill", h = t.theme === "light" ? "tw-text-accent tw-bg-gradient-to-r tw-from-bg-fill-accent" : "tw-text-inverse-accent tw-bg-gradient-to-r tw-from-bg-fill-accent", v = "tw-text-primary-disabled tw-pointer-events-none", y = t.theme === "light" ? "tw-text-disabled tw-pointer-events-none" : "tw-text-inverse-disabled tw-pointer-events-none", b = "tw-text-accent-disabled tw-pointer-events-none", m = k(() => [
      t.color === "default" && d,
      t.color === "neutral" && f,
      t.color === "accent" && h,
      a.disabled !== void 0 && t.color === "default" && v,
      a.disabled !== void 0 && t.color === "neutral" && y,
      a.disabled !== void 0 && t.color === "accent" && b
    ].join(" ").replaceAll("false", "")), C = k(() => [
      r.value === "small" && s,
      r.value === "medium" && c,
      r.value === "large" && u
    ].join(" ").replaceAll("false", ""));
    return (x, T) => (g(), P(We(A(n)), {
      class: F(["link tw-ease-linear tw-flex tw-w-fit tw-items-center tw-gap-x-2xs tw-rounded-sm tw-transition-all tw-duration-100 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus", [m.value, C.value]]),
      href: x.isExternal || A(i)(x.to) ? x.to : A(o)(x.to),
      external: x.isExternal === !0 ? !0 : void 0,
      "data-allow-mismatch": "class"
    }, {
      default: G(() => [
        x.iconLeftName ? (g(), P(B, {
          key: 0,
          name: x.iconLeftName,
          size: A(l)
        }, null, 8, ["name", "size"])) : E("", !0),
        R("span", Ba, [
          R("span", ja, [
            H(x.$slots, "default", {}, void 0, !0)
          ]),
          T[0] || (T[0] = R("span", { class: "link-underline tw-absolute tw-bottom-zero tw-left-zero tw-h-4xs tw-w-full tw-ease-slow-down motion-safe:tw-transform motion-safe:tw-transition-transform motion-safe:tw-duration-[650ms]" }, null, -1))
        ]),
        x.iconRightName ? (g(), P(B, {
          key: 1,
          name: x.iconRightName,
          size: A(l)
        }, null, 8, ["name", "size"])) : E("", !0)
      ]),
      _: 3
    }, 8, ["class", "href", "external"]));
  }
}), ai = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, i] of t)
    n[o] = i;
  return n;
}, T0 = /* @__PURE__ */ ai(Wa, [["__scopeId", "data-v-1fffe0e7"]]), Ka = {}, S0 = /* @__PURE__ */ U({
  ...Ka,
  __name: "UIChipButton",
  props: {
    text: {},
    iconLeftName: {},
    iconRightName: {},
    disabled: { type: Boolean },
    to: { default: () => {
    } }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t, { linkOrButtonComponent: o, componentAttrs: i } = Ot(() => e.to);
    return (a, r) => (g(), P(ti, me({ component: A(o) }, A(i), {
      text: a.text,
      "icon-left-name": a.iconLeftName,
      "icon-right-name": a.iconRightName,
      disabled: a.disabled,
      onClick: r[0] || (r[0] = (l) => n("click"))
    }), null, 16, ["component", "text", "icon-left-name", "icon-right-name", "disabled"]));
  }
}), qa = {}, I0 = /* @__PURE__ */ U({
  ...qa,
  __name: "UIChipSelection",
  props: /* @__PURE__ */ ie({
    text: {},
    disabled: { type: Boolean },
    size: {},
    iconLeftName: {}
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ie(["click"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = t, o = fe(e, "modelValue");
    function i() {
      e.disabled || (o.value = !o.value, n("click"));
    }
    return (a, r) => (g(), P(ti, {
      modelValue: o.value,
      "onUpdate:modelValue": r[0] || (r[0] = (l) => o.value = l),
      component: "input",
      text: a.text,
      "icon-left-name": a.iconLeftName,
      "icon-right-name": o.value ? "mdi:check" : "mdi:plus",
      disabled: a.disabled,
      size: a.size,
      color: o.value ? "alt" : "dashed",
      onClick: i
    }, null, 8, ["modelValue", "text", "icon-left-name", "icon-right-name", "disabled", "size", "color"]));
  }
}), _a = ["top", "right", "bottom", "left"], Be = Math.min, Se = Math.max, kt = Math.round, pt = Math.floor, be = (e) => ({
  x: e,
  y: e
}), Ga = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Qa = {
  start: "end",
  end: "start"
};
function fn(e, t, n) {
  return Se(e, Be(t, n));
}
function Ke(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ee(e) {
  return e.split("-")[0];
}
function st(e) {
  return e.split("-")[1];
}
function li(e) {
  return e === "x" ? "y" : "x";
}
function zn(e) {
  return e === "y" ? "height" : "width";
}
function je(e) {
  return ["top", "bottom"].includes(Ee(e)) ? "y" : "x";
}
function Fn(e) {
  return li(je(e));
}
function Ya(e, t, n) {
  n === void 0 && (n = !1);
  const o = st(e), i = Fn(e), a = zn(i);
  let r = i === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (r = Tt(r)), [r, Tt(r)];
}
function Xa(e) {
  const t = Tt(e);
  return [hn(e), t, hn(t)];
}
function hn(e) {
  return e.replace(/start|end/g, (t) => Qa[t]);
}
function Za(e, t, n) {
  const o = ["left", "right"], i = ["right", "left"], a = ["top", "bottom"], r = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : o : t ? o : i;
    case "left":
    case "right":
      return t ? a : r;
    default:
      return [];
  }
}
function Ja(e, t, n, o) {
  const i = st(e);
  let a = Za(Ee(e), n === "start", o);
  return i && (a = a.map((r) => r + "-" + i), t && (a = a.concat(a.map(hn)))), a;
}
function Tt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Ga[t]);
}
function el(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function si(e) {
  return typeof e != "number" ? el(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function St(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: i
  } = e;
  return {
    width: o,
    height: i,
    top: n,
    left: t,
    right: t + o,
    bottom: n + i,
    x: t,
    y: n
  };
}
function io(e, t, n) {
  let {
    reference: o,
    floating: i
  } = e;
  const a = je(t), r = Fn(t), l = zn(r), s = Ee(t), c = a === "y", u = o.x + o.width / 2 - i.width / 2, d = o.y + o.height / 2 - i.height / 2, f = o[l] / 2 - i[l] / 2;
  let h;
  switch (s) {
    case "top":
      h = {
        x: u,
        y: o.y - i.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      h = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: o.x - i.width,
        y: d
      };
      break;
    default:
      h = {
        x: o.x,
        y: o.y
      };
  }
  switch (st(t)) {
    case "start":
      h[r] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      h[r] += f * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const tl = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: r
  } = n, l = a.filter(Boolean), s = await (r.isRTL == null ? void 0 : r.isRTL(t));
  let c = await r.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: u,
    y: d
  } = io(c, o, s), f = o, h = {}, v = 0;
  for (let y = 0; y < l.length; y++) {
    const {
      name: b,
      fn: m
    } = l[y], {
      x: C,
      y: x,
      data: T,
      reset: L
    } = await m({
      x: u,
      y: d,
      initialPlacement: o,
      placement: f,
      strategy: i,
      middlewareData: h,
      rects: c,
      platform: r,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = C ?? u, d = x ?? d, h = {
      ...h,
      [b]: {
        ...h[b],
        ...T
      }
    }, L && v <= 50 && (v++, typeof L == "object" && (L.placement && (f = L.placement), L.rects && (c = L.rects === !0 ? await r.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : L.rects), {
      x: u,
      y: d
    } = io(c, f, s)), y = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: i,
    middlewareData: h
  };
};
async function It(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: i,
    platform: a,
    rects: r,
    elements: l,
    strategy: s
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = Ke(t, e), v = si(h), b = l[f ? d === "floating" ? "reference" : "floating" : d], m = St(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(b))) == null || n ? b : b.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(l.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: s
  })), C = d === "floating" ? {
    x: o,
    y: i,
    width: r.floating.width,
    height: r.floating.height
  } : r.reference, x = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l.floating)), T = await (a.isElement == null ? void 0 : a.isElement(x)) ? await (a.getScale == null ? void 0 : a.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, L = St(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: C,
    offsetParent: x,
    strategy: s
  }) : C);
  return {
    top: (m.top - L.top + v.top) / T.y,
    bottom: (L.bottom - m.bottom + v.bottom) / T.y,
    left: (m.left - L.left + v.left) / T.x,
    right: (L.right - m.right + v.right) / T.x
  };
}
const nl = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: i,
      rects: a,
      platform: r,
      elements: l,
      middlewareData: s
    } = t, {
      element: c,
      padding: u = 0
    } = Ke(e, t) || {};
    if (c == null)
      return {};
    const d = si(u), f = {
      x: n,
      y: o
    }, h = Fn(i), v = zn(h), y = await r.getDimensions(c), b = h === "y", m = b ? "top" : "left", C = b ? "bottom" : "right", x = b ? "clientHeight" : "clientWidth", T = a.reference[v] + a.reference[h] - f[h] - a.floating[v], L = f[h] - a.reference[h], M = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(c));
    let z = M ? M[x] : 0;
    (!z || !await (r.isElement == null ? void 0 : r.isElement(M))) && (z = l.floating[x] || a.floating[v]);
    const j = T / 2 - L / 2, X = z / 2 - y[v] / 2 - 1, K = Be(d[m], X), Z = Be(d[C], X), D = K, p = z - y[v] - Z, w = z / 2 - y[v] / 2 + j, S = fn(D, w, p), $ = !s.arrow && st(i) != null && w !== S && a.reference[v] / 2 - (w < D ? K : Z) - y[v] / 2 < 0, O = $ ? w < D ? w - D : w - p : 0;
    return {
      [h]: f[h] + O,
      data: {
        [h]: S,
        centerOffset: w - S - O,
        ...$ && {
          alignmentOffset: O
        }
      },
      reset: $
    };
  }
}), ol = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: i,
        middlewareData: a,
        rects: r,
        initialPlacement: l,
        platform: s,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: y = !0,
        ...b
      } = Ke(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const m = Ee(i), C = je(l), x = Ee(l) === l, T = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), L = f || (x || !y ? [Tt(l)] : Xa(l)), M = v !== "none";
      !f && M && L.push(...Ja(l, y, v, T));
      const z = [l, ...L], j = await It(t, b), X = [];
      let K = ((o = a.flip) == null ? void 0 : o.overflows) || [];
      if (u && X.push(j[m]), d) {
        const w = Ya(i, r, T);
        X.push(j[w[0]], j[w[1]]);
      }
      if (K = [...K, {
        placement: i,
        overflows: X
      }], !X.every((w) => w <= 0)) {
        var Z, D;
        const w = (((Z = a.flip) == null ? void 0 : Z.index) || 0) + 1, S = z[w];
        if (S)
          return {
            data: {
              index: w,
              overflows: K
            },
            reset: {
              placement: S
            }
          };
        let $ = (D = K.filter((O) => O.overflows[0] <= 0).sort((O, V) => O.overflows[1] - V.overflows[1])[0]) == null ? void 0 : D.placement;
        if (!$)
          switch (h) {
            case "bestFit": {
              var p;
              const O = (p = K.filter((V) => {
                if (M) {
                  const N = je(V.placement);
                  return N === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  N === "y";
                }
                return !0;
              }).map((V) => [V.placement, V.overflows.filter((N) => N > 0).reduce((N, _) => N + _, 0)]).sort((V, N) => V[1] - N[1])[0]) == null ? void 0 : p[0];
              O && ($ = O);
              break;
            }
            case "initialPlacement":
              $ = l;
              break;
          }
        if (i !== $)
          return {
            reset: {
              placement: $
            }
          };
      }
      return {};
    }
  };
};
function ro(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function ao(e) {
  return _a.some((t) => e[t] >= 0);
}
const il = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: o = "referenceHidden",
        ...i
      } = Ke(e, t);
      switch (o) {
        case "referenceHidden": {
          const a = await It(t, {
            ...i,
            elementContext: "reference"
          }), r = ro(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: r,
              referenceHidden: ao(r)
            }
          };
        }
        case "escaped": {
          const a = await It(t, {
            ...i,
            altBoundary: !0
          }), r = ro(a, n.floating);
          return {
            data: {
              escapedOffsets: r,
              escaped: ao(r)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function rl(e, t) {
  const {
    placement: n,
    platform: o,
    elements: i
  } = e, a = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), r = Ee(n), l = st(n), s = je(n) === "y", c = ["left", "top"].includes(r) ? -1 : 1, u = a && s ? -1 : 1, d = Ke(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: v
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return l && typeof v == "number" && (h = l === "end" ? v * -1 : v), s ? {
    x: h * u,
    y: f * c
  } : {
    x: f * c,
    y: h * u
  };
}
const al = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: i,
        y: a,
        placement: r,
        middlewareData: l
      } = t, s = await rl(t, e);
      return r === ((n = l.offset) == null ? void 0 : n.placement) && (o = l.arrow) != null && o.alignmentOffset ? {} : {
        x: i + s.x,
        y: a + s.y,
        data: {
          ...s,
          placement: r
        }
      };
    }
  };
}, ll = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: i
      } = t, {
        mainAxis: a = !0,
        crossAxis: r = !1,
        limiter: l = {
          fn: (b) => {
            let {
              x: m,
              y: C
            } = b;
            return {
              x: m,
              y: C
            };
          }
        },
        ...s
      } = Ke(e, t), c = {
        x: n,
        y: o
      }, u = await It(t, s), d = je(Ee(i)), f = li(d);
      let h = c[f], v = c[d];
      if (a) {
        const b = f === "y" ? "top" : "left", m = f === "y" ? "bottom" : "right", C = h + u[b], x = h - u[m];
        h = fn(C, h, x);
      }
      if (r) {
        const b = d === "y" ? "top" : "left", m = d === "y" ? "bottom" : "right", C = v + u[b], x = v - u[m];
        v = fn(C, v, x);
      }
      const y = l.fn({
        ...t,
        [f]: h,
        [d]: v
      });
      return {
        ...y,
        data: {
          x: y.x - n,
          y: y.y - o,
          enabled: {
            [f]: a,
            [d]: r
          }
        }
      };
    }
  };
};
function Dt() {
  return typeof window < "u";
}
function $e(e) {
  return Nn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ae(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function he(e) {
  var t;
  return (t = (Nn(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Nn(e) {
  return Dt() ? e instanceof Node || e instanceof ae(e).Node : !1;
}
function se(e) {
  return Dt() ? e instanceof Element || e instanceof ae(e).Element : !1;
}
function de(e) {
  return Dt() ? e instanceof HTMLElement || e instanceof ae(e).HTMLElement : !1;
}
function lo(e) {
  return !Dt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ae(e).ShadowRoot;
}
function ct(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: i
  } = ce(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(i);
}
function sl(e) {
  return ["table", "td", "th"].includes($e(e));
}
function Rt(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function $n(e) {
  const t = On(), n = se(e) ? ce(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function cl(e) {
  let t = ge(e);
  for (; de(t) && !Ue(t); ) {
    if ($n(t))
      return t;
    if (Rt(t))
      return null;
    t = ge(t);
  }
  return null;
}
function On() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ue(e) {
  return ["html", "body", "#document"].includes($e(e));
}
function ce(e) {
  return ae(e).getComputedStyle(e);
}
function Pt(e) {
  return se(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ge(e) {
  if ($e(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    lo(e) && e.host || // Fallback.
    he(e)
  );
  return lo(t) ? t.host : t;
}
function ci(e) {
  const t = ge(e);
  return Ue(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : de(t) && ct(t) ? t : ci(t);
}
function rt(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = ci(e), a = i === ((o = e.ownerDocument) == null ? void 0 : o.body), r = ae(i);
  if (a) {
    const l = mn(r);
    return t.concat(r, r.visualViewport || [], ct(i) ? i : [], l && n ? rt(l) : []);
  }
  return t.concat(i, rt(i, [], n));
}
function mn(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ui(e) {
  const t = ce(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const i = de(e), a = i ? e.offsetWidth : n, r = i ? e.offsetHeight : o, l = kt(n) !== a || kt(o) !== r;
  return l && (n = a, o = r), {
    width: n,
    height: o,
    $: l
  };
}
function Ln(e) {
  return se(e) ? e : e.contextElement;
}
function He(e) {
  const t = Ln(e);
  if (!de(t))
    return be(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: i,
    $: a
  } = ui(t);
  let r = (a ? kt(n.width) : n.width) / o, l = (a ? kt(n.height) : n.height) / i;
  return (!r || !Number.isFinite(r)) && (r = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: r,
    y: l
  };
}
const ul = /* @__PURE__ */ be(0);
function di(e) {
  const t = ae(e);
  return !On() || !t.visualViewport ? ul : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function dl(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== ae(e) ? !1 : t;
}
function Me(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), a = Ln(e);
  let r = be(1);
  t && (o ? se(o) && (r = He(o)) : r = He(e));
  const l = dl(a, n, o) ? di(a) : be(0);
  let s = (i.left + l.x) / r.x, c = (i.top + l.y) / r.y, u = i.width / r.x, d = i.height / r.y;
  if (a) {
    const f = ae(a), h = o && se(o) ? ae(o) : o;
    let v = f, y = mn(v);
    for (; y && o && h !== v; ) {
      const b = He(y), m = y.getBoundingClientRect(), C = ce(y), x = m.left + (y.clientLeft + parseFloat(C.paddingLeft)) * b.x, T = m.top + (y.clientTop + parseFloat(C.paddingTop)) * b.y;
      s *= b.x, c *= b.y, u *= b.x, d *= b.y, s += x, c += T, v = ae(y), y = mn(v);
    }
  }
  return St({
    width: u,
    height: d,
    x: s,
    y: c
  });
}
function fl(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: i
  } = e;
  const a = i === "fixed", r = he(o), l = t ? Rt(t.floating) : !1;
  if (o === r || l && a)
    return n;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = be(1);
  const u = be(0), d = de(o);
  if ((d || !d && !a) && (($e(o) !== "body" || ct(r)) && (s = Pt(o)), de(o))) {
    const f = Me(o);
    c = He(o), u.x = f.x + o.clientLeft, u.y = f.y + o.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - s.scrollLeft * c.x + u.x,
    y: n.y * c.y - s.scrollTop * c.y + u.y
  };
}
function hl(e) {
  return Array.from(e.getClientRects());
}
function pn(e, t) {
  const n = Pt(e).scrollLeft;
  return t ? t.left + n : Me(he(e)).left + n;
}
function ml(e) {
  const t = he(e), n = Pt(e), o = e.ownerDocument.body, i = Se(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), a = Se(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let r = -n.scrollLeft + pn(e);
  const l = -n.scrollTop;
  return ce(o).direction === "rtl" && (r += Se(t.clientWidth, o.clientWidth) - i), {
    width: i,
    height: a,
    x: r,
    y: l
  };
}
function pl(e, t) {
  const n = ae(e), o = he(e), i = n.visualViewport;
  let a = o.clientWidth, r = o.clientHeight, l = 0, s = 0;
  if (i) {
    a = i.width, r = i.height;
    const c = On();
    (!c || c && t === "fixed") && (l = i.offsetLeft, s = i.offsetTop);
  }
  return {
    width: a,
    height: r,
    x: l,
    y: s
  };
}
function vl(e, t) {
  const n = Me(e, !0, t === "fixed"), o = n.top + e.clientTop, i = n.left + e.clientLeft, a = de(e) ? He(e) : be(1), r = e.clientWidth * a.x, l = e.clientHeight * a.y, s = i * a.x, c = o * a.y;
  return {
    width: r,
    height: l,
    x: s,
    y: c
  };
}
function so(e, t, n) {
  let o;
  if (t === "viewport")
    o = pl(e, n);
  else if (t === "document")
    o = ml(he(e));
  else if (se(t))
    o = vl(t, n);
  else {
    const i = di(e);
    o = {
      ...t,
      x: t.x - i.x,
      y: t.y - i.y
    };
  }
  return St(o);
}
function fi(e, t) {
  const n = ge(e);
  return n === t || !se(n) || Ue(n) ? !1 : ce(n).position === "fixed" || fi(n, t);
}
function wl(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = rt(e, [], !1).filter((l) => se(l) && $e(l) !== "body"), i = null;
  const a = ce(e).position === "fixed";
  let r = a ? ge(e) : e;
  for (; se(r) && !Ue(r); ) {
    const l = ce(r), s = $n(r);
    !s && l.position === "fixed" && (i = null), (a ? !s && !i : !s && l.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || ct(r) && !s && fi(e, r)) ? o = o.filter((u) => u !== r) : i = l, r = ge(r);
  }
  return t.set(e, o), o;
}
function bl(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: i
  } = e;
  const r = [...n === "clippingAncestors" ? Rt(t) ? [] : wl(t, this._c) : [].concat(n), o], l = r[0], s = r.reduce((c, u) => {
    const d = so(t, u, i);
    return c.top = Se(d.top, c.top), c.right = Be(d.right, c.right), c.bottom = Be(d.bottom, c.bottom), c.left = Se(d.left, c.left), c;
  }, so(t, l, i));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function gl(e) {
  const {
    width: t,
    height: n
  } = ui(e);
  return {
    width: t,
    height: n
  };
}
function yl(e, t, n) {
  const o = de(t), i = he(t), a = n === "fixed", r = Me(e, !0, a, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = be(0);
  if (o || !o && !a)
    if (($e(t) !== "body" || ct(i)) && (l = Pt(t)), o) {
      const h = Me(t, !0, a, t);
      s.x = h.x + t.clientLeft, s.y = h.y + t.clientTop;
    } else i && (s.x = pn(i));
  let c = 0, u = 0;
  if (i && !o && !a) {
    const h = i.getBoundingClientRect();
    u = h.top + l.scrollTop, c = h.left + l.scrollLeft - // RTL <body> scrollbar.
    pn(i, h);
  }
  const d = r.left + l.scrollLeft - s.x - c, f = r.top + l.scrollTop - s.y - u;
  return {
    x: d,
    y: f,
    width: r.width,
    height: r.height
  };
}
function _t(e) {
  return ce(e).position === "static";
}
function co(e, t) {
  if (!de(e) || ce(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return he(e) === n && (n = n.ownerDocument.body), n;
}
function hi(e, t) {
  const n = ae(e);
  if (Rt(e))
    return n;
  if (!de(e)) {
    let i = ge(e);
    for (; i && !Ue(i); ) {
      if (se(i) && !_t(i))
        return i;
      i = ge(i);
    }
    return n;
  }
  let o = co(e, t);
  for (; o && sl(o) && _t(o); )
    o = co(o, t);
  return o && Ue(o) && _t(o) && !$n(o) ? n : o || cl(e) || n;
}
const xl = async function(e) {
  const t = this.getOffsetParent || hi, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: yl(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Cl(e) {
  return ce(e).direction === "rtl";
}
const kl = {
  convertOffsetParentRelativeRectToViewportRelativeRect: fl,
  getDocumentElement: he,
  getClippingRect: bl,
  getOffsetParent: hi,
  getElementRects: xl,
  getClientRects: hl,
  getDimensions: gl,
  getScale: He,
  isElement: se,
  isRTL: Cl
};
function Tl(e, t) {
  let n = null, o;
  const i = he(e);
  function a() {
    var l;
    clearTimeout(o), (l = n) == null || l.disconnect(), n = null;
  }
  function r(l, s) {
    l === void 0 && (l = !1), s === void 0 && (s = 1), a();
    const {
      left: c,
      top: u,
      width: d,
      height: f
    } = e.getBoundingClientRect();
    if (l || t(), !d || !f)
      return;
    const h = pt(u), v = pt(i.clientWidth - (c + d)), y = pt(i.clientHeight - (u + f)), b = pt(c), C = {
      rootMargin: -h + "px " + -v + "px " + -y + "px " + -b + "px",
      threshold: Se(0, Be(1, s)) || 1
    };
    let x = !0;
    function T(L) {
      const M = L[0].intersectionRatio;
      if (M !== s) {
        if (!x)
          return r();
        M ? r(!1, M) : o = setTimeout(() => {
          r(!1, 1e-7);
        }, 1e3);
      }
      x = !1;
    }
    try {
      n = new IntersectionObserver(T, {
        ...C,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(T, C);
    }
    n.observe(e);
  }
  return r(!0), a;
}
function Sl(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: r = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: s = !1
  } = o, c = Ln(e), u = i || a ? [...c ? rt(c) : [], ...rt(t)] : [];
  u.forEach((m) => {
    i && m.addEventListener("scroll", n, {
      passive: !0
    }), a && m.addEventListener("resize", n);
  });
  const d = c && l ? Tl(c, n) : null;
  let f = -1, h = null;
  r && (h = new ResizeObserver((m) => {
    let [C] = m;
    C && C.target === c && h && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var x;
      (x = h) == null || x.observe(t);
    })), n();
  }), c && !s && h.observe(c), h.observe(t));
  let v, y = s ? Me(e) : null;
  s && b();
  function b() {
    const m = Me(e);
    y && (m.x !== y.x || m.y !== y.y || m.width !== y.width || m.height !== y.height) && n(), y = m, v = requestAnimationFrame(b);
  }
  return n(), () => {
    var m;
    u.forEach((C) => {
      i && C.removeEventListener("scroll", n), a && C.removeEventListener("resize", n);
    }), d == null || d(), (m = h) == null || m.disconnect(), h = null, s && cancelAnimationFrame(v);
  };
}
const Il = al, Al = ll, El = ol, Ml = il, zl = nl, Fl = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), i = {
    platform: kl,
    ...n
  }, a = {
    ...i.platform,
    _c: o
  };
  return tl(e, t, {
    ...i,
    platform: a
  });
};
function Nl(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function vn(e) {
  if (Nl(e)) {
    const t = e.$el;
    return Nn(t) && $e(t) === "#comment" ? null : t;
  }
  return e;
}
function De(e) {
  return typeof e == "function" ? e() : A(e);
}
function $l(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const n = vn(De(e.element));
      return n == null ? {} : zl({
        element: n,
        padding: e.padding
      }).fn(t);
    }
  };
}
function mi(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function uo(e, t) {
  const n = mi(e);
  return Math.round(t * n) / n;
}
function Ol(e, t, n) {
  n === void 0 && (n = {});
  const o = n.whileElementsMounted, i = k(() => {
    var z;
    return (z = De(n.open)) != null ? z : !0;
  }), a = k(() => De(n.middleware)), r = k(() => {
    var z;
    return (z = De(n.placement)) != null ? z : "bottom";
  }), l = k(() => {
    var z;
    return (z = De(n.strategy)) != null ? z : "absolute";
  }), s = k(() => {
    var z;
    return (z = De(n.transform)) != null ? z : !0;
  }), c = k(() => vn(e.value)), u = k(() => vn(t.value)), d = q(0), f = q(0), h = q(l.value), v = q(r.value), y = Ie({}), b = q(!1), m = k(() => {
    const z = {
      position: h.value,
      left: "0",
      top: "0"
    };
    if (!u.value)
      return z;
    const j = uo(u.value, d.value), X = uo(u.value, f.value);
    return s.value ? {
      ...z,
      transform: "translate(" + j + "px, " + X + "px)",
      ...mi(u.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: h.value,
      left: j + "px",
      top: X + "px"
    };
  });
  let C;
  function x() {
    if (c.value == null || u.value == null)
      return;
    const z = i.value;
    Fl(c.value, u.value, {
      middleware: a.value,
      placement: r.value,
      strategy: l.value
    }).then((j) => {
      d.value = j.x, f.value = j.y, h.value = j.strategy, v.value = j.placement, y.value = j.middlewareData, b.value = z !== !1;
    });
  }
  function T() {
    typeof C == "function" && (C(), C = void 0);
  }
  function L() {
    if (T(), o === void 0) {
      x();
      return;
    }
    if (c.value != null && u.value != null) {
      C = o(c.value, u.value, x);
      return;
    }
  }
  function M() {
    i.value || (b.value = !1);
  }
  return le([a, r, l, i], x, {
    flush: "sync"
  }), le([c, u], L, {
    flush: "sync"
  }), le(i, M, {
    flush: "sync"
  }), go() && yo(T), {
    x: Oe(d),
    y: Oe(f),
    strategy: Oe(h),
    placement: Oe(v),
    middlewareData: Oe(y),
    isPositioned: Oe(b),
    floatingStyles: m,
    update: x
  };
}
const pi = En ? window : void 0;
function Xe(e) {
  var t;
  const n = W(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function Re(...e) {
  const t = [], n = () => {
    t.forEach((l) => l()), t.length = 0;
  }, o = (l, s, c, u) => (l.addEventListener(s, c, u), () => l.removeEventListener(s, c, u)), i = k(() => {
    const l = Te(W(e[0])).filter((s) => s != null);
    return l.every((s) => typeof s != "string") ? l : void 0;
  }), a = oi(
    () => {
      var l, s;
      return [
        (s = (l = i.value) == null ? void 0 : l.map((c) => Xe(c))) != null ? s : [pi].filter((c) => c != null),
        Te(W(i.value ? e[1] : e[0])),
        Te(A(i.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        W(i.value ? e[3] : e[2])
      ];
    },
    ([l, s, c, u]) => {
      if (n(), !(l != null && l.length) || !(s != null && s.length) || !(c != null && c.length))
        return;
      const d = ni(u) ? { ...u } : u;
      t.push(
        ...l.flatMap(
          (f) => s.flatMap(
            (h) => c.map((v) => o(f, h, v, d))
          )
        )
      );
    },
    { flush: "post" }
  ), r = () => {
    a(), n();
  };
  return Lt(n), r;
}
let fo = !1;
function ho(e, t, n = {}) {
  const { window: o = pi, ignore: i = [], capture: a = !0, detectIframe: r = !1, controls: l = !1 } = n;
  if (!o)
    return l ? { stop: xe, cancel: xe, trigger: xe } : xe;
  if (un && !fo) {
    fo = !0;
    const b = { passive: !0 };
    Array.from(o.document.body.children).forEach((m) => Re(m, "click", xe, b)), Re(o.document.documentElement, "click", xe, b);
  }
  let s = !0;
  const c = (b) => W(i).some((m) => {
    if (typeof m == "string")
      return Array.from(o.document.querySelectorAll(m)).some((C) => C === b.target || b.composedPath().includes(C));
    {
      const C = Xe(m);
      return C && (b.target === C || b.composedPath().includes(C));
    }
  });
  function u(b) {
    const m = W(b);
    return m && m.$.subTree.shapeFlag === 16;
  }
  function d(b, m) {
    const C = W(b), x = C.$.subTree && C.$.subTree.children;
    return x == null || !Array.isArray(x) ? !1 : x.some((T) => T.el === m.target || m.composedPath().includes(T.el));
  }
  const f = (b) => {
    const m = Xe(e);
    if (b.target != null && !(!(m instanceof Element) && u(e) && d(e, b)) && !(!m || m === b.target || b.composedPath().includes(m))) {
      if ("detail" in b && b.detail === 0 && (s = !c(b)), !s) {
        s = !0;
        return;
      }
      t(b);
    }
  };
  let h = !1;
  const v = [
    Re(o, "click", (b) => {
      h || (h = !0, setTimeout(() => {
        h = !1;
      }, 0), f(b));
    }, { passive: !0, capture: a }),
    Re(o, "pointerdown", (b) => {
      const m = Xe(e);
      s = !c(b) && !!(m && !b.composedPath().includes(m));
    }, { passive: !0 }),
    r && Re(o, "blur", (b) => {
      setTimeout(() => {
        var m;
        const C = Xe(e);
        ((m = o.document.activeElement) == null ? void 0 : m.tagName) === "IFRAME" && !(C != null && C.contains(o.document.activeElement)) && t(b);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), y = () => v.forEach((b) => b());
  return l ? {
    stop: y,
    cancel: () => {
      s = !1;
    },
    trigger: (b) => {
      s = !0, f(b), s = !1;
    }
  } : y;
}
const Ll = {
  mounted(e, t) {
    const n = !t.modifiers.bubble;
    if (typeof t.value == "function")
      e.__onClickOutside_stop = ho(e, t.value, { capture: n });
    else {
      const [o, i] = t.value;
      e.__onClickOutside_stop = ho(e, o, Object.assign({ capture: n }, i));
    }
  },
  unmounted(e) {
    e.__onClickOutside_stop();
  }
};
function Gt(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function vi(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const n = e.parentNode;
    return !n || n.tagName === "BODY" ? !1 : vi(n);
  }
}
function Dl(e) {
  const t = e || window.event, n = t.target;
  return vi(n) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}
const Qt = /* @__PURE__ */ new WeakMap();
function Rl(e, t = !1) {
  const n = q(t);
  let o = null, i = "";
  le(xa(e), (l) => {
    const s = Gt(W(l));
    if (s) {
      const c = s;
      if (Qt.get(c) || Qt.set(c, c.style.overflow), c.style.overflow !== "hidden" && (i = c.style.overflow), c.style.overflow === "hidden")
        return n.value = !0;
      if (n.value)
        return c.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const a = () => {
    const l = Gt(W(e));
    !l || n.value || (un && (o = Re(
      l,
      "touchmove",
      (s) => {
        Dl(s);
      },
      { passive: !1 }
    )), l.style.overflow = "hidden", n.value = !0);
  }, r = () => {
    const l = Gt(W(e));
    !l || !n.value || (un && (o == null || o()), l.style.overflow = i, Qt.delete(l), n.value = !1);
  };
  return Lt(r), k({
    get() {
      return n.value;
    },
    set(l) {
      l ? a() : r();
    }
  });
}
function Pl() {
  let e = !1;
  const t = Ie(!1);
  return (n, o) => {
    if (t.value = o.value, e)
      return;
    e = !0;
    const i = Rl(n, o.value);
    le(t, (a) => i.value = a);
  };
}
Pl();
const Vl = { class: "tw-w-fit" }, Hl = {
  ref: "referenceEl",
  class: "tw-w-fit"
}, Bl = {}, wi = /* @__PURE__ */ U({
  ...Bl,
  __name: "BaseFloating",
  props: {
    forceShowFloatingEl: { type: Boolean, default: void 0 },
    hasArrow: { type: Boolean, default: !1 },
    isStatic: { type: Boolean, default: !1 },
    offset: { default: 8 },
    placement: { default: "bottom-start" }
  },
  emits: ["click-outside", "show-floating", "hide-floating"],
  setup(e, { emit: t }) {
    const n = e, o = t, [i, a] = ka(!1), r = Pe("referenceEl"), l = Pe("floatingEl"), s = Pe("floatingArrowEl"), c = 8, u = n.isStatic ? [] : [
      El({ padding: c }),
      Al({ padding: c })
    ], d = [
      Il(n.offset),
      ...u,
      $l({
        element: s,
        // the distance in px the arrow can show up against the side of the floating element itself.
        // Use to avoid overlapping rounded corners
        padding: 8
      }),
      Ml()
    ], {
      floatingStyles: f,
      middlewareData: h,
      placement: v
    } = Ol(r, l, {
      middleware: d,
      /**
       * Update the floating element's position when the reference element's size or scroll position changes.
       *
       * @param referenceEl - The reference element.
       * @param floatingEl - The floating element.
       * @param update - The update function.
       * @returns - The cleanup function.
       */
      whileElementsMounted(m, C, x) {
        return Sl(m, C, x, {
          ancestorScroll: !0,
          elementResize: !0
        });
      },
      placement: n.placement,
      strategy: "fixed"
    }), y = k(() => {
      var M;
      const { x: m, y: C } = ((M = h.value) == null ? void 0 : M.arrow) ?? {}, x = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[v.value.split("-")[0]], L = typeof n.offset == "number" ? n.offset : 8;
      return {
        left: m != null ? `${m}px` : "",
        top: C != null ? `${C}px` : "",
        right: "",
        bottom: "",
        [x]: `-${L / 2}px`
      };
    });
    le(i, (m) => {
      o(m ? "show-floating" : "hide-floating");
    }), le(
      () => n.forceShowFloatingEl,
      (m) => {
        m !== void 0 && a(m);
      },
      { immediate: !0 }
    );
    function b() {
      o("click-outside"), n.forceShowFloatingEl !== !0 && a(!1);
    }
    return (m, C) => Ae((g(), I("div", Vl, [
      R("div", Hl, [
        H(m.$slots, "reference", {
          isFloatingElDisplayed: A(i),
          toggleContentDisplay: A(a)
        })
      ], 512),
      re(ko, {
        name: "fade",
        mode: "out-in",
        appear: ""
      }, {
        default: G(() => {
          var x;
          return [
            A(i) ? (g(), I("div", {
              key: 0,
              ref: "floatingEl",
              style: Rn({
                ...A(f),
                visibility: (x = A(h).hide) != null && x.referenceHidden ? "hidden" : "visible"
              }),
              class: "tw-z-[999999]"
            }, [
              m.hasArrow ? (g(), I("span", {
                key: 0,
                ref: "floatingArrowEl",
                "data-testid": "floating-arrow",
                class: "tw-absolute tw-size-sm tw-rotate-45 tw-transform tw-bg-fill-alt",
                style: Rn(y.value)
              }, null, 4)) : E("", !0),
              H(m.$slots, "floating", { toggleContentDisplay: A(a) })
            ], 4)) : E("", !0)
          ];
        }),
        _: 3
      })
    ])), [
      [A(Ll), b]
    ]);
  }
}), jl = ["aria-controlledby", "onMouseleave", "onClick"], Ul = {}, A0 = /* @__PURE__ */ U({
  ...Ul,
  __name: "UIDropdownMenu",
  props: {
    displayMenuOnHover: { type: Boolean, default: !1 },
    hideDelay: { default: 500 },
    referenceComponent: {},
    referenceComponentAttrs: { default: () => ({}) }
  },
  setup(e) {
    const t = e, n = Fe(), o = q(), i = Ne();
    function a(s) {
      t.displayMenuOnHover && (clearTimeout(o.value), o.value = setTimeout(() => s(!1), t.hideDelay));
    }
    function r() {
      clearTimeout(o.value);
    }
    function l(s) {
      t.displayMenuOnHover && (clearTimeout(o.value), s(!0));
    }
    return te(n.menuLists) || console.error('UIDropdownMenu requires a slot named "menuLists"'), (s, c) => (g(), P(wi, null, {
      reference: G(({ toggleContentDisplay: u, isFloatingElDisplayed: d }) => [
        s.referenceComponent ? (g(), P(We(s.referenceComponent), me({ key: 0 }, s.referenceComponentAttrs, {
          id: A(i),
          "aria-expanded": d,
          onClick: (f) => u(),
          onMouseover: (f) => l(u),
          onMouseleave: (f) => a(u)
        }), {
          default: G(() => [
            H(s.$slots, "referenceText")
          ]),
          _: 2
        }, 1040, ["id", "aria-expanded", "onClick", "onMouseover", "onMouseleave"])) : E("", !0)
      ]),
      floating: G(({ toggleContentDisplay: u }) => [
        A(te)(n.menuLists) ? (g(), I("div", {
          key: 0,
          class: "tw-flex tw-min-w-[160px] tw-flex-col tw-gap-y-3xs tw-rounded-lg tw-bg-surface tw-p-2xs tw-shadow-lg",
          "aria-controlledby": A(i),
          onMouseover: r,
          onMouseleave: (d) => a(u),
          onClick: (d) => u(!1)
        }, [
          H(s.$slots, "menuLists")
        ], 40, jl)) : E("", !0)
      ]),
      _: 3
    }));
  }
}), Wl = {
  key: 0,
  class: "tw-text-body tw-rounded tw-px-md tw-py-sm tw-text-discrete"
}, Kl = {}, E0 = /* @__PURE__ */ U({
  ...Kl,
  __name: "UIDropdownMenuList",
  props: {
    title: { default: "" }
  },
  setup(e) {
    return (t, n) => (g(), I("ul", null, [
      t.title ? (g(), I("li", Wl, Y(t.title), 1)) : E("", !0),
      H(t.$slots, "default")
    ]));
  }
}), ql = { class: "tw-flex tw-flex-1 tw-flex-col tw-items-start tw-gap-y-3xs" }, _l = { class: "tw-text-body" }, Gl = {
  key: 0,
  class: "tw-text-body-xs tw-text-discrete"
}, Ql = {
  key: 1,
  class: "tw-text-body tw-text-discrete"
}, Yl = {}, M0 = /* @__PURE__ */ U({
  ...Yl,
  inheritAttrs: !1,
  __name: "UIDropdownMenuListItem",
  props: {
    href: { default: "" },
    isActive: { type: Boolean, default: !1 },
    leftIconName: { default: "" },
    rightIconName: { default: "" },
    rightSideText: { default: "" },
    size: { default: "base" },
    subText: { default: "" },
    text: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = Ft(), { linkOrButtonComponent: a } = Ot(
      () => n.href || i.to
    ), r = k(() => n.href || i.to ? {
      href: n.href || i.to,
      "aria-current": n.isActive ? "page" : void 0,
      ...i
    } : {
      type: "button",
      "aria-checked": n.isActive ? n.isActive : void 0,
      ...i
    });
    return (l, s) => (g(), I("li", null, [
      (g(), P(We(A(a)), me(r.value, {
        class: ["tw-flex tw-w-full tw-min-w-[160px] tw-items-center tw-gap-x-md tw-rounded tw-px-md hover:tw-bg-surface-hover", [
          {
            "tw-bg-fill-discrete3": l.isActive
          },
          l.size === "lg" ? "tw-py-md" : "tw-py-sm"
        ]],
        onClick: s[0] || (s[0] = (c) => o("click"))
      }), {
        default: G(() => [
          l.leftIconName ? (g(), P(B, {
            key: 0,
            name: l.leftIconName,
            class: "tw-text-icon-discrete2"
          }, null, 8, ["name"])) : E("", !0),
          R("span", ql, [
            R("span", _l, Y(l.text), 1),
            l.subText ? (g(), I("span", Gl, Y(l.subText), 1)) : E("", !0)
          ]),
          l.rightSideText ? (g(), I("span", Ql, Y(l.rightSideText), 1)) : E("", !0),
          l.rightIconName && l.isActive ? (g(), P(B, {
            key: 2,
            name: l.rightIconName,
            class: "tw-text-icon"
          }, null, 8, ["name"])) : E("", !0)
        ]),
        _: 1
      }, 16, ["class"]))
    ]));
  }
}), Xl = ["id", "name", "checked", "disabled", "valid", "readonly"], Zl = ["for"], Jl = {}, es = /* @__PURE__ */ U({
  ...Jl,
  __name: "UIInputCheckbox",
  props: /* @__PURE__ */ ie({
    isDisabled: { type: Boolean, default: !1 },
    isIndeterminate: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ne(), n = fe(e, "modelValue");
    return (o, i) => (g(), I("span", {
      class: F(["tw-flex tw-h-full tw-items-center tw-justify-center tw-gap-md", {
        "tw-pointer-events-none": o.isDisabled
      }])
    }, [
      R("span", {
        class: F(["tw-relative tw-flex tw-h-xl tw-w-xl tw-flex-col tw-items-center tw-justify-center tw-rounded tw-border tw-border-discrete2 tw-bg-surface hover:tw-border-default-color disabled:tw-pointer-events-none", {
          "!tw-border-default-color !tw-bg-fill-alt": n.value && !o.isDisabled,
          "tw-border-2 !tw-border-error": o.hasError && !o.isDisabled,
          "!tw-bg-fill-error": o.hasError && !n.value && !o.isDisabled,
          "!tw-border-disabled !tw-bg-fill-alt-disabled": o.isDisabled
        }])
      }, [
        Ae(R("input", {
          id: A(t),
          "onUpdate:modelValue": i[0] || (i[0] = (a) => n.value = a),
          type: "checkbox",
          name: A(t),
          checked: n.value,
          disabled: o.isDisabled,
          valid: o.hasError ? !1 : void 0,
          readonly: o.isDisabled,
          class: "tw-absolute tw-flex tw-h-full tw-w-full tw-appearance-none tw-rounded focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus"
        }, null, 8, Xl), [
          [To, n.value]
        ]),
        n.value ? (g(), P(B, {
          key: 0,
          name: o.isIndeterminate ? "material-symbols:remove" : "material-symbols:check",
          size: "sm",
          class: F(["tw-text-inverse", {
            "!tw-text-disabled": o.isDisabled
          }])
        }, null, 8, ["name", "class"])) : E("", !0)
      ], 2),
      A(te)(o.$slots.label) ? (g(), I("label", {
        key: 0,
        for: A(t),
        class: "tw-flex-1 tw-items-center tw-justify-center"
      }, [
        H(o.$slots, "label")
      ], 8, Zl)) : E("", !0)
    ], 2));
  }
}), ts = ["for"], ns = {
  key: 0,
  class: "tw-ml-sm tw-font-normal tw-text-discrete2"
}, os = {}, bi = /* @__PURE__ */ U({
  ...os,
  __name: "UIInputLabel",
  props: {
    htmlFor: {},
    optionalText: { default: "" }
  },
  setup(e) {
    return (t, n) => (g(), I("label", {
      for: t.htmlFor,
      class: "tw-block tw-text-base tw-font-bold"
    }, [
      H(t.$slots, "default"),
      t.optionalText ? (g(), I("span", ns, Y(t.optionalText), 1)) : E("", !0)
    ], 8, ts));
  }
}), is = ["id", "type", "placeholder", "name", "disabled"], rs = {
  key: 1,
  class: "tw-text-form-error tw-mt-2xs tw-inline-block"
}, as = {}, gi = /* @__PURE__ */ U({
  ...as,
  __name: "BaseInput",
  props: /* @__PURE__ */ ie({
    errorText: { default: "" },
    helperText: { default: "" },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    name: {},
    placeholder: { default: "" },
    iconLeftName: { default: null },
    type: { default: "text" },
    optionalLabelText: { default: "" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ie(["focus", "blur"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, o = t, i = Ne(), a = fe(e, "modelValue"), r = k(() => [
      n.errorText && "tw-border-2 tw-border-error tw-bg-fill-error",
      n.isDisabled && "tw-pointer-events-none tw-bg-fill-alt-disabled tw-border-disabled",
      n.inputSize === "large" ? "tw-h-5xl tw-py-md" : "tw-h-4xl tw-py-sm"
    ].join(" ").replaceAll("false", "")), l = k(() => a.value && n.type === "password" ? "tw-text-success" : "tw-text-discrete2");
    return (s, c) => (g(), I("div", null, [
      A(te)(s.$slots.label) ? (g(), P(bi, {
        key: 0,
        "optional-text": s.optionalLabelText,
        "html-for": A(i),
        class: "tw-mb-2xs"
      }, {
        default: G(() => [
          H(s.$slots, "label")
        ]),
        _: 3
      }, 8, ["optional-text", "html-for"])) : E("", !0),
      R("div", {
        class: F(["tw-bg tw-relative tw-flex tw-w-full tw-items-center tw-gap-sm tw-rounded tw-border tw-border-discrete2 tw-px-md focus-within:tw-bg-surface focus-within:tw-outline focus-within:tw-outline-2 focus-within:tw-outline-focus hover:tw-border-default-color", r.value])
      }, [
        s.iconLeftName ? (g(), P(B, {
          key: 0,
          name: s.iconLeftName,
          size: "lg",
          class: "tw-text-icon-discrete2"
        }, null, 8, ["name"])) : E("", !0),
        Ae(R("input", {
          id: A(i),
          "onUpdate:modelValue": c[0] || (c[0] = (u) => a.value = u),
          type: s.type,
          placeholder: s.placeholder,
          name: s.name,
          disabled: s.isDisabled,
          class: "tw-h-2xl tw-w-full tw-rounded tw-bg-transparent tw-outline-none placeholder:tw-text-discrete2",
          onFocus: c[1] || (c[1] = (u) => o("focus")),
          onBlur: c[2] || (c[2] = (u) => o("blur"))
        }, null, 40, is), [
          [So, a.value]
        ]),
        H(s.$slots, "icon-button-right")
      ], 2),
      s.errorText ? (g(), I("span", rs, Y(s.errorText), 1)) : s.helperText ? (g(), I("span", {
        key: 2,
        class: F(["tw-mt-2xs tw-inline-block tw-text-sm", l.value])
      }, Y(s.helperText), 3)) : E("", !0)
    ]));
  }
}), ls = ["aria-label"], ss = {}, z0 = /* @__PURE__ */ U({
  ...ss,
  __name: "UIInputPassword",
  props: /* @__PURE__ */ ie({
    errorText: { default: "" },
    helperText: { default: "" },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    name: { default: "password" },
    placeholder: { default: "" },
    toggleVisibilityAriaText: { default: "" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = fe(e, "modelValue"), n = q("material-symbols:visibility-outline"), o = q("password");
    function i() {
      o.value === "password" ? (n.value = "material-symbols:visibility-off-outline", o.value = "text") : (n.value = "material-symbols:visibility-outline", o.value = "password");
    }
    return (a, r) => (g(), P(gi, {
      modelValue: t.value,
      "onUpdate:modelValue": r[0] || (r[0] = (l) => t.value = l),
      "icon-left-name": "material-symbols:lock-outline",
      type: o.value,
      placeholder: a.placeholder,
      name: a.name,
      "helper-text": a.helperText,
      "error-text": a.errorText,
      "input-size": a.inputSize,
      "is-disabled": a.isDisabled
    }, Io({
      "icon-button-right": G(() => [
        R("button", {
          class: "tw-h-xl",
          type: "button",
          "aria-label": a.toggleVisibilityAriaText,
          onClick: i
        }, [
          re(B, {
            name: n.value,
            class: "tw-text-icon-discrete2"
          }, null, 8, ["name"])
        ], 8, ls)
      ]),
      _: 2
    }, [
      A(te)(a.$slots.label) ? {
        name: "label",
        fn: G(() => [
          H(a.$slots, "label")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["modelValue", "type", "placeholder", "name", "helper-text", "error-text", "input-size", "is-disabled"]));
  }
}), cs = ["aria-label"], us = {}, F0 = /* @__PURE__ */ U({
  ...us,
  __name: "UIInputText",
  props: /* @__PURE__ */ ie({
    clearInputAriaText: { default: "" },
    errorText: { default: "" },
    helperText: { default: "" },
    iconLeftName: { default: null },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    isIconRightVisible: { type: Boolean, default: !0 },
    isValidating: { type: Boolean, default: !1 },
    name: {},
    optionalLabelText: { default: "" },
    placeholder: { default: "" },
    type: { default: "text" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = fe(e, "modelValue"), o = q(!1), i = q(!1), a = k(() => o.value || i.value), r = k(() => !!(t.isIconRightVisible && a.value && n.value && l.value !== "eos-icons:loading" || t.errorText && !t.isValidating)), l = k(() => t.isValidating ? "eos-icons:loading" : t.errorText || r.value ? "mdi:close" : n.value && !t.errorText ? "material-symbols:check" : ""), s = k(() => n.value && !t.errorText && !r.value && !t.isValidating ? "tw-text-icon-success" : "tw-text-icon-discrete2"), c = k(() => t.isIconRightVisible && !r.value && l.value);
    le(l, () => {
    });
    function u() {
      n.value = "";
    }
    function d() {
      setTimeout(() => {
        o.value = !1;
      }, 10);
    }
    return (f, h) => (g(), P(gi, {
      ref: "input",
      modelValue: n.value,
      "onUpdate:modelValue": h[2] || (h[2] = (v) => n.value = v),
      "icon-left-name": f.iconLeftName,
      type: f.type,
      placeholder: f.placeholder,
      name: f.name,
      "helper-text": f.helperText,
      "error-text": f.errorText,
      "input-size": f.inputSize,
      "optional-label-text": f.optionalLabelText,
      "is-disabled": f.isDisabled,
      onFocus: h[3] || (h[3] = (v) => o.value = !0),
      onBlur: d
    }, Io({
      "icon-button-right": G(() => [
        r.value && !f.isDisabled ? (g(), I("button", {
          key: 0,
          type: "button",
          class: "tw-h-xl",
          "aria-label": f.clearInputAriaText,
          onClick: u,
          onFocus: h[0] || (h[0] = (v) => i.value = !0),
          onBlur: h[1] || (h[1] = (v) => i.value = !1)
        }, [
          re(B, {
            name: l.value,
            class: F(s.value)
          }, null, 8, ["name", "class"])
        ], 40, cs)) : c.value && !f.isDisabled ? (g(), P(B, {
          key: 1,
          name: l.value,
          class: F(s.value)
        }, null, 8, ["name", "class"])) : E("", !0)
      ]),
      _: 2
    }, [
      A(te)(f.$slots.label) ? {
        name: "label",
        fn: G(() => [
          H(f.$slots, "label")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["modelValue", "icon-left-name", "type", "placeholder", "name", "helper-text", "error-text", "input-size", "optional-label-text", "is-disabled"]));
  }
}), ds = {
  key: 0,
  class: "tw-mb-2xl tw-mt-sm"
}, fs = ["id", "placeholder", "name", "disabled"], hs = {
  key: 1,
  class: "tw-text-form-error tw-mt-2xs tw-inline-block"
}, ms = {
  key: 2,
  class: "tw-mt-2xs tw-inline-block tw-text-sm tw-text-discrete2"
}, N0 = /* @__PURE__ */ U({
  __name: "UIInputTextarea",
  props: /* @__PURE__ */ ie({
    errorText: { default: "" },
    helperText: { default: "" },
    isDisabled: { type: Boolean, default: !1 },
    name: {},
    placeholder: { default: "" },
    optionalLabelText: { default: "" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = Ne(), o = fe(e, "modelValue"), i = k(() => [
      t.errorText && "tw-border-2 tw-border-error tw-bg-fill-error",
      t.isDisabled && "tw-pointer-events-none tw-bg-fill-alt-disabled tw-border-disabled"
    ].join(" ").replaceAll("false", ""));
    return (a, r) => (g(), I("div", null, [
      re(bi, {
        "optional-text": a.optionalLabelText,
        "html-for": A(n)
      }, {
        default: G(() => [
          H(a.$slots, "label")
        ]),
        _: 3
      }, 8, ["optional-text", "html-for"]),
      A(te)(a.$slots.tip) ? (g(), I("div", ds, [
        H(a.$slots, "tip")
      ])) : E("", !0),
      Ae(R("textarea", {
        id: A(n),
        "onUpdate:modelValue": r[0] || (r[0] = (l) => o.value = l),
        class: F(["tw-text-body tw-relative tw-flex tw-max-h-[50vh] tw-min-h-[88px] tw-w-full tw-items-center tw-gap-sm tw-rounded tw-border tw-border-discrete2 tw-bg-transparent tw-p-md placeholder:tw-text-discrete2 focus-within:tw-bg-surface focus-within:tw-outline focus-within:tw-outline-2 focus-within:tw-outline-focus hover:tw-border-default-color", i.value]),
        placeholder: a.placeholder,
        name: a.name,
        disabled: a.isDisabled
      }, null, 10, fs), [
        [So, o.value]
      ]),
      a.errorText ? (g(), I("span", hs, Y(a.errorText), 1)) : a.helperText ? (g(), I("span", ms, Y(a.helperText), 1)) : E("", !0)
    ]));
  }
}), ps = ["id", "name", "checked", "disabled", "readonly", "valid"], vs = {}, $0 = /* @__PURE__ */ U({
  ...vs,
  __name: "UIInputToggleCheckbox",
  props: /* @__PURE__ */ ie({
    disabled: { type: Boolean, default: !1 },
    size: { default: "base" },
    iconName: { default: "mdi:check" },
    theme: { default: "light" },
    hasError: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = fe(e, "modelValue"), n = Ne(), o = k(
      () => e.size === "sm" ? "tw-rounded-2xl" : e.size === "lg" ? "tw-rounded-4xl" : "tw-rounded-3xl"
    ), i = k(
      () => e.size === "sm" ? "tw-px-2xs tw-py-3xs" : e.size === "lg" ? "tw-p-sm" : "tw-p-xs"
    ), a = k(
      () => e.size === "sm" ? "tw-h-2xl tw-min-w-2xl" : e.size === "lg" ? "tw-h-4xl tw-min-w-4xl" : "tw-h-3xl tw-min-w-3xl"
    ), r = k(() => e.disabled ? "tw-bg-fill-discrete" : e.theme === "light" ? t.value ? "tw-bg-fill-alt hover:tw-bg-fill-alt-hover" : "tw-bg-fill-neutral hover:tw-bg-fill-neutral-hover" : t.value ? "tw-bg-surface hover:tw-bg-surface-hover" : "tw-bg-fill-neutral hover:tw-bg-fill-neutral-alt-hover"), l = k(() => e.theme === "light" ? e.disabled ? "tw-bg-fill-alt-disabled" : "tw-bg-surface" : e.disabled ? "tw-bg-fill-alt-disabled" : "tw-bg-fill-alt"), s = k(() => e.disabled ? "tw-text-icon-disabled" : e.theme === "light" ? "tw-text-icon" : "tw-text-icon-inverse");
    return (c, u) => (g(), I("label", {
      class: F(["tw-relative tw-inline-flex tw-items-center", [
        c.disabled ? "tw-pointer-events-none tw-cursor-not-allowed" : "tw-cursor-pointer"
      ]])
    }, [
      Ae(R("input", {
        id: A(n),
        "onUpdate:modelValue": u[0] || (u[0] = (d) => t.value = d),
        type: "checkbox",
        name: A(n),
        class: "tw-sr-only tw-appearance-none",
        checked: t.value,
        disabled: c.disabled,
        readonly: c.disabled,
        valid: c.hasError ? !1 : void 0
      }, null, 8, ps), [
        [To, t.value]
      ]),
      R("div", {
        class: F(["tw-flex tw-p-3xs tw-transition-all tw-duration-200", {
          [r.value]: !0,
          [o.value]: !0,
          "tw-border-2 tw-border-error": c.hasError && !c.disabled
        }])
      }, [
        R("div", {
          class: F(["tw-rounded-full tw-transition-all tw-duration-200", {
            [l.value]: !t.value,
            [a.value]: !0
          }])
        }, null, 2),
        R("div", {
          class: F(["tw-items-center tw-rounded-full tw-transition-all tw-duration-200", {
            [l.value]: t.value,
            [i.value]: !0,
            [a.value]: !0
          }])
        }, [
          Ae(re(B, {
            name: c.iconName,
            size: c.size,
            class: F(s.value)
          }, null, 8, ["name", "size", "class"]), [
            [Ao, t.value]
          ])
        ], 2)
      ], 2)
    ], 2));
  }
}), ws = { class: "tw-inline-flex tw-items-center" }, bs = ["aria-invalid"], gs = ["for", "aria-label"], ys = ["id", "readonly", "checked", "value", "disabled", "valid", "onClick"], O0 = /* @__PURE__ */ U({
  __name: "UIInputToggleRadio",
  props: /* @__PURE__ */ ie({
    disabled: { type: Boolean, default: !1 },
    size: { default: "base" },
    theme: { default: "light" },
    hasError: { type: Boolean, default: !1 },
    options: {}
  }, {
    modelValue: void 0,
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ie(["update:modelValue"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = t, o = fe(
      e,
      "modelValue",
      void 0
    ), i = Ne(), a = k(
      () => e.size === "sm" ? "tw-rounded-2xl" : e.size === "lg" ? "tw-rounded-4xl" : "tw-rounded-3xl"
    ), r = k(
      () => e.size === "sm" ? "tw-px-2xs tw-py-3xs" : e.size === "lg" ? "tw-p-sm" : "tw-p-xs"
    ), l = k(
      () => e.size === "sm" ? "tw-h-2xl tw-min-w-2xl" : e.size === "lg" ? "tw-h-4xl tw-min-w-4xl" : "tw-h-3xl tw-min-w-3xl"
    ), s = k(
      () => e.disabled ? "tw-bg-fill-discrete" : e.theme === "light" ? "tw-bg-fill-alt hover:tw-bg-fill-alt-hover" : "tw-bg-surface hover:tw-bg-surface-hover"
    ), c = k(
      () => e.size === "sm" ? "tw-text-body-sm tw-px-2xs tw-gap-x-2xs" : e.size === "lg" ? "tw-text-body-lg tw-px-sm tw-gap-x-sm" : "tw-text-body tw-px-xs tw-gap-x-xs"
    ), u = k(
      () => e.disabled ? "tw-bg-fill-alt-disabled" : e.theme === "light" ? "tw-bg-surface tw-text-icon" : "tw-bg-fill-alt tw-text-icon-inverse"
    ), d = k(
      () => e.disabled ? "tw-bg-fill-discrete" : e.theme === "dark" ? "tw-text-icon" : "tw-text-icon-inverse"
    ), f = k(
      () => e.theme === "light" ? "tw-text-icon-discrete2" : "tw-text-icon-disabled"
    );
    function h(y) {
      return o.value === y;
    }
    function v(y, b) {
      e.disabled || b || h(y) || (o.value = y, n("update:modelValue", y));
    }
    return (y, b) => (g(), I("div", ws, [
      R("div", {
        class: F(["tw-flex tw-p-3xs tw-transition-all tw-duration-200", {
          [s.value]: !0,
          [a.value]: !0,
          "tw-border-2 tw-border-error": y.hasError && !y.disabled
        }]),
        role: "radiogroup",
        "aria-invalid": y.hasError
      }, [
        (g(!0), I(tt, null, Zt(y.options, ({
          value: m,
          label: C,
          iconName: x,
          disabled: T = !1
        }) => (g(), I("label", {
          key: `${A(i)}-${m}`,
          class: F(["tw-flex tw-items-center tw-rounded-full tw-transition-all tw-duration-200", {
            "tw-cursor-pointer": !y.disabled && !T,
            "tw-cursor-not-allowed": y.disabled || T,
            [a.value]: !0,
            [l.value]: !0,
            [r.value]: !0,
            [u.value]: h(m),
            [d.value]: !h(m) && !T,
            [f.value]: T || y.disabled
          }]),
          for: `${A(i)}-${m}`,
          "aria-label": C
        }, [
          R("input", {
            id: `${A(i)}-${m}`,
            readonly: y.disabled || T,
            type: "radio",
            class: "tw-sr-only tw-appearance-none",
            checked: h(m),
            value: m,
            disabled: y.disabled || T,
            valid: y.hasError ? !1 : void 0,
            onClick: (L) => v(m, T)
          }, null, 8, ys),
          R("div", {
            class: F(["tw-flex tw-items-center", [c.value]])
          }, [
            x ? (g(), P(B, {
              key: 0,
              name: x,
              size: y.size
            }, null, 8, ["name", "size"])) : E("", !0),
            R("span", null, Y(C), 1)
          ], 2)
        ], 10, gs))), 128))
      ], 10, bs)
    ]));
  }
});
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var yi = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], At = /* @__PURE__ */ yi.join(","), xi = typeof Element > "u", ze = xi ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Et = !xi && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, Mt = function e(t, n) {
  var o;
  n === void 0 && (n = !0);
  var i = t == null || (o = t.getAttribute) === null || o === void 0 ? void 0 : o.call(t, "inert"), a = i === "" || i === "true", r = a || n && t && e(t.parentNode);
  return r;
}, xs = function(t) {
  var n, o = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return o === "" || o === "true";
}, Ci = function(t, n, o) {
  if (Mt(t))
    return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(At));
  return n && ze.call(t, At) && i.unshift(t), i = i.filter(o), i;
}, ki = function e(t, n, o) {
  for (var i = [], a = Array.from(t); a.length; ) {
    var r = a.shift();
    if (!Mt(r, !1))
      if (r.tagName === "SLOT") {
        var l = r.assignedElements(), s = l.length ? l : r.children, c = e(s, !0, o);
        o.flatten ? i.push.apply(i, c) : i.push({
          scopeParent: r,
          candidates: c
        });
      } else {
        var u = ze.call(r, At);
        u && o.filter(r) && (n || !t.includes(r)) && i.push(r);
        var d = r.shadowRoot || // check for an undisclosed shadow
        typeof o.getShadowRoot == "function" && o.getShadowRoot(r), f = !Mt(d, !1) && (!o.shadowRootFilter || o.shadowRootFilter(r));
        if (d && f) {
          var h = e(d === !0 ? r.children : d.children, !0, o);
          o.flatten ? i.push.apply(i, h) : i.push({
            scopeParent: r,
            candidates: h
          });
        } else
          a.unshift.apply(a, r.children);
      }
  }
  return i;
}, Ti = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, Ce = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || xs(t)) && !Ti(t) ? 0 : t.tabIndex;
}, Cs = function(t, n) {
  var o = Ce(t);
  return o < 0 && n && !Ti(t) ? 0 : o;
}, ks = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, Si = function(t) {
  return t.tagName === "INPUT";
}, Ts = function(t) {
  return Si(t) && t.type === "hidden";
}, Ss = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(o) {
    return o.tagName === "SUMMARY";
  });
  return n;
}, Is = function(t, n) {
  for (var o = 0; o < t.length; o++)
    if (t[o].checked && t[o].form === n)
      return t[o];
}, As = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Et(t), o = function(l) {
    return n.querySelectorAll('input[type="radio"][name="' + l + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = o(window.CSS.escape(t.name));
  else
    try {
      i = o(t.name);
    } catch (r) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", r.message), !1;
    }
  var a = Is(i, t.form);
  return !a || a === t;
}, Es = function(t) {
  return Si(t) && t.type === "radio";
}, Ms = function(t) {
  return Es(t) && !As(t);
}, zs = function(t) {
  var n, o = t && Et(t), i = (n = o) === null || n === void 0 ? void 0 : n.host, a = !1;
  if (o && o !== t) {
    var r, l, s;
    for (a = !!((r = i) !== null && r !== void 0 && (l = r.ownerDocument) !== null && l !== void 0 && l.contains(i) || t != null && (s = t.ownerDocument) !== null && s !== void 0 && s.contains(t)); !a && i; ) {
      var c, u, d;
      o = Et(i), i = (c = o) === null || c === void 0 ? void 0 : c.host, a = !!((u = i) !== null && u !== void 0 && (d = u.ownerDocument) !== null && d !== void 0 && d.contains(i));
    }
  }
  return a;
}, mo = function(t) {
  var n = t.getBoundingClientRect(), o = n.width, i = n.height;
  return o === 0 && i === 0;
}, Fs = function(t, n) {
  var o = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var a = ze.call(t, "details>summary:first-of-type"), r = a ? t.parentElement : t;
  if (ze.call(r, "details:not([open]) *"))
    return !0;
  if (!o || o === "full" || o === "legacy-full") {
    if (typeof i == "function") {
      for (var l = t; t; ) {
        var s = t.parentElement, c = Et(t);
        if (s && !s.shadowRoot && i(s) === !0)
          return mo(t);
        t.assignedSlot ? t = t.assignedSlot : !s && c !== t.ownerDocument ? t = c.host : t = s;
      }
      t = l;
    }
    if (zs(t))
      return !t.getClientRects().length;
    if (o !== "legacy-full")
      return !0;
  } else if (o === "non-zero-area")
    return mo(t);
  return !1;
}, Ns = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var o = 0; o < n.children.length; o++) {
          var i = n.children.item(o);
          if (i.tagName === "LEGEND")
            return ze.call(n, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, zt = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Mt(n) || Ts(n) || Fs(n, t) || // For a details element with a summary, the summary element gets the focus
  Ss(n) || Ns(n));
}, wn = function(t, n) {
  return !(Ms(n) || Ce(n) < 0 || !zt(t, n));
}, $s = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Os = function e(t) {
  var n = [], o = [];
  return t.forEach(function(i, a) {
    var r = !!i.scopeParent, l = r ? i.scopeParent : i, s = Cs(l, r), c = r ? e(i.candidates) : l;
    s === 0 ? r ? n.push.apply(n, c) : n.push(l) : o.push({
      documentOrder: a,
      tabIndex: s,
      item: i,
      isScope: r,
      content: c
    });
  }), o.sort(ks).reduce(function(i, a) {
    return a.isScope ? i.push.apply(i, a.content) : i.push(a.content), i;
  }, []).concat(n);
}, Ls = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = ki([t], n.includeContainer, {
    filter: wn.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: $s
  }) : o = Ci(t, n.includeContainer, wn.bind(null, n)), Os(o);
}, Ds = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = ki([t], n.includeContainer, {
    filter: zt.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : o = Ci(t, n.includeContainer, zt.bind(null, n)), o;
}, Le = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return ze.call(t, At) === !1 ? !1 : wn(n, t);
}, Rs = /* @__PURE__ */ yi.concat("iframe").join(","), Yt = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return ze.call(t, Rs) === !1 ? !1 : zt(n, t);
};
/*!
* focus-trap 7.6.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function bn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function Ps(e) {
  if (Array.isArray(e)) return bn(e);
}
function Vs(e, t, n) {
  return (t = Ws(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Hs(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Bs() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function po(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function vo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? po(Object(n), !0).forEach(function(o) {
      Vs(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : po(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function js(e) {
  return Ps(e) || Hs(e) || Ks(e) || Bs();
}
function Us(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ws(e) {
  var t = Us(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Ks(e, t) {
  if (e) {
    if (typeof e == "string") return bn(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? bn(e, t) : void 0;
  }
}
var wo = {
  activateTrap: function(t, n) {
    if (t.length > 0) {
      var o = t[t.length - 1];
      o !== n && o._setPausedState(!0);
    }
    var i = t.indexOf(n);
    i === -1 || t.splice(i, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var o = t.indexOf(n);
    o !== -1 && t.splice(o, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, qs = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, _s = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, et = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, Gs = function(t) {
  return et(t) && !t.shiftKey;
}, Qs = function(t) {
  return et(t) && t.shiftKey;
}, bo = function(t) {
  return setTimeout(t, 0);
}, Qe = function(t) {
  for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    o[i - 1] = arguments[i];
  return typeof t == "function" ? t.apply(void 0, o) : t;
}, vt = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, Ys = [], Xs = function(t, n) {
  var o = (n == null ? void 0 : n.document) || document, i = (n == null ? void 0 : n.trapStack) || Ys, a = vo({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: Gs,
    isKeyBackward: Qs
  }, n), r = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, l, s = function(p, w, S) {
    return p && p[w] !== void 0 ? p[w] : a[S || w];
  }, c = function(p, w) {
    var S = typeof (w == null ? void 0 : w.composedPath) == "function" ? w.composedPath() : void 0;
    return r.containerGroups.findIndex(function($) {
      var O = $.container, V = $.tabbableNodes;
      return O.contains(p) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (S == null ? void 0 : S.includes(O)) || V.find(function(N) {
        return N === p;
      });
    });
  }, u = function(p) {
    var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, S = w.hasFallback, $ = S === void 0 ? !1 : S, O = w.params, V = O === void 0 ? [] : O, N = a[p];
    if (typeof N == "function" && (N = N.apply(void 0, js(V))), N === !0 && (N = void 0), !N) {
      if (N === void 0 || N === !1)
        return N;
      throw new Error("`".concat(p, "` was specified but was not a node, or did not return a node"));
    }
    var _ = N;
    if (typeof N == "string") {
      try {
        _ = o.querySelector(N);
      } catch (J) {
        throw new Error("`".concat(p, '` appears to be an invalid selector; error="').concat(J.message, '"'));
      }
      if (!_ && !$)
        throw new Error("`".concat(p, "` as selector refers to no known node"));
    }
    return _;
  }, d = function() {
    var p = u("initialFocus", {
      hasFallback: !0
    });
    if (p === !1)
      return !1;
    if (p === void 0 || p && !Yt(p, a.tabbableOptions))
      if (c(o.activeElement) >= 0)
        p = o.activeElement;
      else {
        var w = r.tabbableGroups[0], S = w && w.firstTabbableNode;
        p = S || u("fallbackFocus");
      }
    else p === null && (p = u("fallbackFocus"));
    if (!p)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return p;
  }, f = function() {
    if (r.containerGroups = r.containers.map(function(p) {
      var w = Ls(p, a.tabbableOptions), S = Ds(p, a.tabbableOptions), $ = w.length > 0 ? w[0] : void 0, O = w.length > 0 ? w[w.length - 1] : void 0, V = S.find(function(J) {
        return Le(J);
      }), N = S.slice().reverse().find(function(J) {
        return Le(J);
      }), _ = !!w.find(function(J) {
        return Ce(J) > 0;
      });
      return {
        container: p,
        tabbableNodes: w,
        focusableNodes: S,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: _,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: $,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: O,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: V,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: N,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(ye) {
          var qe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, pe = w.indexOf(ye);
          return pe < 0 ? qe ? S.slice(S.indexOf(ye) + 1).find(function(_e) {
            return Le(_e);
          }) : S.slice(0, S.indexOf(ye)).reverse().find(function(_e) {
            return Le(_e);
          }) : w[pe + (qe ? 1 : -1)];
        }
      };
    }), r.tabbableGroups = r.containerGroups.filter(function(p) {
      return p.tabbableNodes.length > 0;
    }), r.tabbableGroups.length <= 0 && !u("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (r.containerGroups.find(function(p) {
      return p.posTabIndexesFound;
    }) && r.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, h = function(p) {
    var w = p.activeElement;
    if (w)
      return w.shadowRoot && w.shadowRoot.activeElement !== null ? h(w.shadowRoot) : w;
  }, v = function(p) {
    if (p !== !1 && p !== h(document)) {
      if (!p || !p.focus) {
        v(d());
        return;
      }
      p.focus({
        preventScroll: !!a.preventScroll
      }), r.mostRecentlyFocusedNode = p, qs(p) && p.select();
    }
  }, y = function(p) {
    var w = u("setReturnFocus", {
      params: [p]
    });
    return w || (w === !1 ? !1 : p);
  }, b = function(p) {
    var w = p.target, S = p.event, $ = p.isBackward, O = $ === void 0 ? !1 : $;
    w = w || vt(S), f();
    var V = null;
    if (r.tabbableGroups.length > 0) {
      var N = c(w, S), _ = N >= 0 ? r.containerGroups[N] : void 0;
      if (N < 0)
        O ? V = r.tabbableGroups[r.tabbableGroups.length - 1].lastTabbableNode : V = r.tabbableGroups[0].firstTabbableNode;
      else if (O) {
        var J = r.tabbableGroups.findIndex(function(Vt) {
          var Ht = Vt.firstTabbableNode;
          return w === Ht;
        });
        if (J < 0 && (_.container === w || Yt(w, a.tabbableOptions) && !Le(w, a.tabbableOptions) && !_.nextTabbableNode(w, !1)) && (J = N), J >= 0) {
          var ye = J === 0 ? r.tabbableGroups.length - 1 : J - 1, qe = r.tabbableGroups[ye];
          V = Ce(w) >= 0 ? qe.lastTabbableNode : qe.lastDomTabbableNode;
        } else et(S) || (V = _.nextTabbableNode(w, !1));
      } else {
        var pe = r.tabbableGroups.findIndex(function(Vt) {
          var Ht = Vt.lastTabbableNode;
          return w === Ht;
        });
        if (pe < 0 && (_.container === w || Yt(w, a.tabbableOptions) && !Le(w, a.tabbableOptions) && !_.nextTabbableNode(w)) && (pe = N), pe >= 0) {
          var _e = pe === r.tabbableGroups.length - 1 ? 0 : pe + 1, Dn = r.tabbableGroups[_e];
          V = Ce(w) >= 0 ? Dn.firstTabbableNode : Dn.firstDomTabbableNode;
        } else et(S) || (V = _.nextTabbableNode(w));
      }
    } else
      V = u("fallbackFocus");
    return V;
  }, m = function(p) {
    var w = vt(p);
    if (!(c(w, p) >= 0)) {
      if (Qe(a.clickOutsideDeactivates, p)) {
        l.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: a.returnFocusOnDeactivate
        });
        return;
      }
      Qe(a.allowOutsideClick, p) || p.preventDefault();
    }
  }, C = function(p) {
    var w = vt(p), S = c(w, p) >= 0;
    if (S || w instanceof Document)
      S && (r.mostRecentlyFocusedNode = w);
    else {
      p.stopImmediatePropagation();
      var $, O = !0;
      if (r.mostRecentlyFocusedNode)
        if (Ce(r.mostRecentlyFocusedNode) > 0) {
          var V = c(r.mostRecentlyFocusedNode), N = r.containerGroups[V].tabbableNodes;
          if (N.length > 0) {
            var _ = N.findIndex(function(J) {
              return J === r.mostRecentlyFocusedNode;
            });
            _ >= 0 && (a.isKeyForward(r.recentNavEvent) ? _ + 1 < N.length && ($ = N[_ + 1], O = !1) : _ - 1 >= 0 && ($ = N[_ - 1], O = !1));
          }
        } else
          r.containerGroups.some(function(J) {
            return J.tabbableNodes.some(function(ye) {
              return Ce(ye) > 0;
            });
          }) || (O = !1);
      else
        O = !1;
      O && ($ = b({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: r.mostRecentlyFocusedNode,
        isBackward: a.isKeyBackward(r.recentNavEvent)
      })), v($ || r.mostRecentlyFocusedNode || d());
    }
    r.recentNavEvent = void 0;
  }, x = function(p) {
    var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    r.recentNavEvent = p;
    var S = b({
      event: p,
      isBackward: w
    });
    S && (et(p) && p.preventDefault(), v(S));
  }, T = function(p) {
    (a.isKeyForward(p) || a.isKeyBackward(p)) && x(p, a.isKeyBackward(p));
  }, L = function(p) {
    _s(p) && Qe(a.escapeDeactivates, p) !== !1 && (p.preventDefault(), l.deactivate());
  }, M = function(p) {
    var w = vt(p);
    c(w, p) >= 0 || Qe(a.clickOutsideDeactivates, p) || Qe(a.allowOutsideClick, p) || (p.preventDefault(), p.stopImmediatePropagation());
  }, z = function() {
    if (r.active)
      return wo.activateTrap(i, l), r.delayInitialFocusTimer = a.delayInitialFocus ? bo(function() {
        v(d());
      }) : v(d()), o.addEventListener("focusin", C, !0), o.addEventListener("mousedown", m, {
        capture: !0,
        passive: !1
      }), o.addEventListener("touchstart", m, {
        capture: !0,
        passive: !1
      }), o.addEventListener("click", M, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", T, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", L), l;
  }, j = function() {
    if (r.active)
      return o.removeEventListener("focusin", C, !0), o.removeEventListener("mousedown", m, !0), o.removeEventListener("touchstart", m, !0), o.removeEventListener("click", M, !0), o.removeEventListener("keydown", T, !0), o.removeEventListener("keydown", L), l;
  }, X = function(p) {
    var w = p.some(function(S) {
      var $ = Array.from(S.removedNodes);
      return $.some(function(O) {
        return O === r.mostRecentlyFocusedNode;
      });
    });
    w && v(d());
  }, K = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(X) : void 0, Z = function() {
    K && (K.disconnect(), r.active && !r.paused && r.containers.map(function(p) {
      K.observe(p, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return l = {
    get active() {
      return r.active;
    },
    get paused() {
      return r.paused;
    },
    activate: function(p) {
      if (r.active)
        return this;
      var w = s(p, "onActivate"), S = s(p, "onPostActivate"), $ = s(p, "checkCanFocusTrap");
      $ || f(), r.active = !0, r.paused = !1, r.nodeFocusedBeforeActivation = o.activeElement, w == null || w();
      var O = function() {
        $ && f(), z(), Z(), S == null || S();
      };
      return $ ? ($(r.containers.concat()).then(O, O), this) : (O(), this);
    },
    deactivate: function(p) {
      if (!r.active)
        return this;
      var w = vo({
        onDeactivate: a.onDeactivate,
        onPostDeactivate: a.onPostDeactivate,
        checkCanReturnFocus: a.checkCanReturnFocus
      }, p);
      clearTimeout(r.delayInitialFocusTimer), r.delayInitialFocusTimer = void 0, j(), r.active = !1, r.paused = !1, Z(), wo.deactivateTrap(i, l);
      var S = s(w, "onDeactivate"), $ = s(w, "onPostDeactivate"), O = s(w, "checkCanReturnFocus"), V = s(w, "returnFocus", "returnFocusOnDeactivate");
      S == null || S();
      var N = function() {
        bo(function() {
          V && v(y(r.nodeFocusedBeforeActivation)), $ == null || $();
        });
      };
      return V && O ? (O(y(r.nodeFocusedBeforeActivation)).then(N, N), this) : (N(), this);
    },
    pause: function(p) {
      return r.active ? (r.manuallyPaused = !0, this._setPausedState(!0, p)) : this;
    },
    unpause: function(p) {
      return r.active ? (r.manuallyPaused = !1, i[i.length - 1] !== this ? this : this._setPausedState(!1, p)) : this;
    },
    updateContainerElements: function(p) {
      var w = [].concat(p).filter(Boolean);
      return r.containers = w.map(function(S) {
        return typeof S == "string" ? o.querySelector(S) : S;
      }), r.active && f(), Z(), this;
    }
  }, Object.defineProperties(l, {
    _isManuallyPaused: {
      value: function() {
        return r.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(p, w) {
        if (r.paused === p)
          return this;
        if (r.paused = p, p) {
          var S = s(w, "onPause"), $ = s(w, "onPostPause");
          S == null || S(), j(), Z(), $ == null || $();
        } else {
          var O = s(w, "onUnpause"), V = s(w, "onPostUnpause");
          O == null || O(), f(), z(), Z(), V == null || V();
        }
        return this;
      }
    }
  }), l.updateContainerElements(t), l;
};
function Zs(e, t = {}) {
  let n;
  const { immediate: o, ...i } = t, a = Ie(!1), r = Ie(!1), l = (f) => n && n.activate(f), s = (f) => n && n.deactivate(f), c = () => {
    n && (n.pause(), r.value = !0);
  }, u = () => {
    n && (n.unpause(), r.value = !1);
  }, d = k(() => {
    const f = W(e);
    return Te(f).map((h) => {
      const v = W(h);
      return typeof v == "string" ? v : ii(v);
    }).filter(wa);
  });
  return le(
    d,
    (f) => {
      f.length && (n = Xs(f, {
        ...i,
        onActivate() {
          a.value = !0, t.onActivate && t.onActivate();
        },
        onDeactivate() {
          a.value = !1, t.onDeactivate && t.onDeactivate();
        }
      }), o && l());
    },
    { flush: "post" }
  ), Lt(() => s()), {
    hasFocus: a,
    isPaused: r,
    activate: l,
    deactivate: s,
    pause: c,
    unpause: u
  };
}
const Js = {
  key: 0,
  class: "tw-fixed tw-bottom-zero tw-left-zero tw-right-zero tw-top-zero tw-z-[999999] tw-flex tw-h-full tw-items-end tw-bg-fill-alt tw-bg-opacity-70 md:tw-items-center md:tw-justify-center"
}, e0 = {
  key: 1,
  class: "tw-flex-1"
}, t0 = { key: 3 }, n0 = {
  key: 0,
  id: "modalContent",
  class: "tw-overflow-y-auto tw-p-lg"
}, o0 = {
  key: 1,
  class: "tw-w-full tw-p-lg"
}, i0 = {}, L0 = /* @__PURE__ */ U({
  ...i0,
  __name: "UIModal",
  props: {
    hasBackButton: { type: Boolean, default: !1 },
    isDismissable: { type: Boolean, default: !0 },
    size: { default: "base" }
  },
  emits: ["close", "previous"],
  setup(e, { emit: t }) {
    const n = t, o = Fe(), i = Pe("modal"), { activate: a, deactivate: r } = Zs(i, { immediate: !0 }), l = q(!1);
    gn(() => {
      l.value = !0, a(), s();
    }), Ri(() => {
      l.value = !1, r(), c();
    });
    function s() {
      document && document.body && (document.body.style.overflow = "hidden");
    }
    function c() {
      document && document.body && (document.body.style.overflow = "auto");
    }
    return (u, d) => (g(), P(Pi, { to: "body" }, [
      re(ko, {
        name: "fade",
        mode: "out-in"
      }, {
        default: G(() => [
          l.value ? (g(), I("div", Js, [
            R("article", {
              ref: "modal",
              "aria-modal": "",
              role: "dialog",
              "aria-labelledby": "modalTitle",
              "aria-describedby": "modalContent",
              class: F(["tw-flex tw-max-h-[90%] tw-w-full tw-flex-col tw-rounded-t-xl tw-bg-surface tw-p-sm md:tw-rounded-md", {
                "md:tw-w-[400px]": u.size === "sm",
                "md:tw-w-[640px]": u.size === "base",
                "md:tw-w-[800px]": u.size === "lg",
                "md:tw-w-[1024px]": u.size === "xl"
              }]),
              onKeydown: d[2] || (d[2] = gt((f) => u.isDismissable && n("close"), ["escape"]))
            }, [
              R("header", {
                class: F(["tw-p-lg tw-text-center", {
                  "tw-flex tw-items-center": u.hasBackButton || u.isDismissable,
                  "md:tw-text-left": !u.hasBackButton && !u.isDismissable
                }])
              }, [
                u.hasBackButton ? (g(), I("button", {
                  key: 0,
                  type: "button",
                  class: "tw-flex tw-size-2xl tw-cursor-pointer tw-items-center tw-justify-center",
                  onClick: d[0] || (d[0] = (f) => n("previous"))
                }, [
                  re(B, {
                    name: "famicons:chevron-back-sharp",
                    size: "lg",
                    class: "tw-text-icon-discrete"
                  })
                ])) : E("", !0),
                A(te)(o.title) ? (g(), I("div", e0, [
                  H(u.$slots, "title")
                ])) : E("", !0),
                u.isDismissable ? (g(), I("button", {
                  key: 2,
                  type: "button",
                  class: "tw-flex tw-size-xl tw-cursor-pointer tw-items-center tw-justify-center",
                  onClick: d[1] || (d[1] = (f) => n("close"))
                }, [
                  re(B, {
                    name: "material-symbols:close",
                    size: "lg",
                    class: "tw-text-icon-discrete"
                  })
                ])) : (g(), I("span", t0))
              ], 2),
              A(te)(o.content) ? (g(), I("section", n0, [
                H(u.$slots, "content")
              ])) : E("", !0),
              A(te)(o.cta) ? (g(), I("footer", o0, [
                H(u.$slots, "cta")
              ])) : E("", !0)
            ], 34)
          ])) : E("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), r0 = /* @__PURE__ */ U({
  __name: "UITag",
  props: {
    color: { default: "default" },
    iconLeftName: { default: "" },
    iconRightName: { default: "" },
    size: { default: "base" },
    text: { default: "" },
    variant: { default: "filled" }
  },
  setup(e) {
    const t = e;
    t.variant === "transparent" && t.color === "alt" && console.error("Variant `transparent` cannot be used with color `alt`");
    const n = k(() => t.variant === "transparent" ? { "tw-bg-fill-transparent": t.variant === "transparent" } : {
      "tw-bg-fill-discrete3": t.color === "default" || t.color === "disabled",
      "tw-bg-fill-primary-discrete2": t.color === "primary",
      "tw-bg-fill-alt": t.color === "alt",
      "tw-bg-fill-success": t.color === "success",
      "tw-bg-fill-caution": t.color === "warning",
      "tw-bg-fill-error": t.color === "error",
      "tw-bg-fill-accent-discrete": t.color === "accent"
    }), o = k(() => ({
      "tw-p-2xs": t.size === "base",
      "tw-py-3xs tw-px-2xs": t.size === "sm"
    })), i = k(() => [
      {
        // color
        "tw-text-discrete": t.color === "default",
        "tw-text-discrete3": t.color === "disabled",
        "tw-text-primary": t.color === "primary",
        "tw-text-inverse": t.color === "alt",
        "tw-text-success": t.color === "success",
        "tw-text-caution": t.color === "warning",
        "tw-text-error": t.color === "error",
        "tw-text-accent": t.color === "accent",
        // size
        "tw-text-body-xs": t.size === "sm",
        "tw-text-body-sm": t.size === "base"
      }
    ]), a = k(() => ({
      "tw-text-icon-discrete": t.color === "default",
      "tw-text-icon-discrete3": t.color === "disabled",
      "tw-text-icon-primary": t.color === "primary",
      "tw-text-icon-inverse": t.color === "alt",
      "tw-text-icon-success": t.color === "success",
      "tw-text-icon-caution": t.color === "warning",
      "tw-text-icon-error": t.color === "error",
      "tw-text-icon-accent": t.color === "accent"
    }));
    return (r, l) => (g(), I("span", {
      class: F(["tw-flex tw-w-fit tw-items-center tw-rounded-lg", [n.value, o.value]])
    }, [
      r.iconLeftName ? (g(), P(B, {
        key: 0,
        name: r.iconLeftName,
        size: "sm",
        class: F(a.value)
      }, null, 8, ["name", "class"])) : E("", !0),
      r.text ? (g(), I("span", {
        key: 1,
        class: F(["tw-px-3xs", i.value])
      }, Y(r.text), 3)) : E("", !0),
      r.iconRightName ? (g(), P(B, {
        key: 2,
        name: r.iconRightName,
        size: "sm",
        class: F(a.value)
      }, null, 8, ["name", "class"])) : E("", !0)
    ], 2));
  }
}), a0 = { class: "tw-flex tw-w-full tw-items-center tw-gap-x-md" }, l0 = { class: "tw-flex tw-flex-1 tw-items-center tw-gap-x-2xs" }, s0 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-y-3xs" }, c0 = {
  key: 0,
  class: "tw-text-body tw-font-medium"
}, u0 = {}, D0 = /* @__PURE__ */ U({
  ...u0,
  __name: "UISelectionCard",
  props: /* @__PURE__ */ ie({
    displayCheckbox: { type: Boolean, default: !0 },
    isDisabled: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 },
    iconName: { default: "" },
    size: { default: "base" },
    subText: { default: "" },
    tagText: { default: "" },
    text: { default: "" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = fe(e, "modelValue");
    return (n, o) => (g(), I("label", {
      class: F(["tw-flex tw-w-full tw-min-w-[176px] tw-cursor-pointer tw-items-center tw-justify-between tw-gap-x-md tw-rounded-lg tw-border tw-border-discrete2 tw-bg-surface focus-within:tw-outline hover:tw-bg-fill-hover", [
        {
          "!tw-border-default tw-shadow-[inset_0px_0px_0px_1px] tw-shadow-text-default-color": t.value && !n.isDisabled,
          "tw-pointer-events-none tw-text-discrete3": n.isDisabled,
          "!tw-border-error": n.hasError
        },
        n.size === "sm" ? "tw-p-sm tw-pl-md" : "tw-p-lg"
      ]])
    }, [
      R("span", a0, [
        re(es, {
          modelValue: t.value,
          "onUpdate:modelValue": o[0] || (o[0] = (i) => t.value = i),
          "has-error": n.hasError,
          "is-disabled": n.isDisabled,
          class: F(["tw-pointer-events-none", {
            "tw-sr-only": !n.displayCheckbox
          }])
        }, null, 8, ["modelValue", "has-error", "is-disabled", "class"]),
        R("span", l0, [
          R("span", s0, [
            n.text ? (g(), I("span", c0, Y(n.text), 1)) : E("", !0),
            n.subText ? (g(), I("span", {
              key: 1,
              class: F(n.text ? "tw-text-body-sm" : "tw-text-body")
            }, Y(n.subText), 3)) : E("", !0)
          ]),
          n.tagText ? (g(), P(r0, {
            key: 0,
            text: n.tagText,
            color: n.isDisabled ? "disabled" : "default",
            class: F({
              "!tw-bg-fill-discrete2": t.value
            })
          }, null, 8, ["text", "color", "class"])) : E("", !0)
        ]),
        n.iconName ? (g(), P(B, {
          key: 0,
          name: n.iconName,
          size: n.size === "sm" ? "xl" : "2xl",
          class: "tw-text-icon"
        }, null, 8, ["name", "size"])) : E("", !0)
      ])
    ], 2));
  }
}), d0 = { class: "tabs" }, f0 = {
  role: "tablist",
  class: "tw-flex tw-gap-x-2xl"
}, h0 = ["aria-selected", "aria-controls", "disabled", "tabindex", "onClick", "onKeydown"], m0 = ["id", "aria-labelledby"], p0 = {}, R0 = /* @__PURE__ */ U({
  ...p0,
  __name: "UITab",
  props: {
    tabsTitles: {},
    disabledTabsTitles: { default: () => [] },
    isTextColorInverse: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = Fe(), i = t, a = q(0), r = Pe("tabRefs"), l = Object.keys(o), s = k(() => n.tabsTitles.map((d, f) => l.includes(`tab-${f}`) ? f : null).filter((d) => d !== null));
    function c(d) {
      n.disabledTabsTitles.includes(n.tabsTitles[d]) || (a.value = d, i("click"));
    }
    function u(d, f) {
      var h, v;
      if (r.value) {
        if (f.key === "ArrowRight") {
          const y = d === n.tabsTitles.length - 1 ? d : d + 1;
          (h = r.value[y]) == null || h.focus();
        } else if (f.key === "ArrowLeft") {
          const y = d === 0 ? d : d - 1;
          (v = r.value[y]) == null || v.focus();
        }
      }
    }
    return (d, f) => (g(), I("div", d0, [
      R("div", f0, [
        (g(!0), I(tt, null, Zt(d.tabsTitles, (h, v) => (g(), I("button", {
          key: h,
          ref_for: !0,
          ref_key: "tabRefs",
          ref: r,
          role: "tab",
          "aria-selected": a.value === v,
          "aria-controls": `tab-${v}`,
          disabled: d.disabledTabsTitles.includes(h),
          tabindex: a.value === v ? 0 : -1,
          class: F(["tw-border-b-4 tw-border-b-transparent tw-pb-sm tw-font-bold", {
            "!tw-border-b-primary": a.value === v,
            "tw-text-inverse": d.isTextColorInverse,
            "!tw-text-discrete3": d.disabledTabsTitles.includes(h),
            "hover:!tw-border-b-discrete3": !d.disabledTabsTitles.includes(h)
          }]),
          onClick: (y) => c(v),
          onKeydown: (y) => u(v, y)
        }, Y(h), 43, h0))), 128))
      ]),
      (g(!0), I(tt, null, Zt(s.value, (h) => Ae((g(), I("section", {
        id: `tab-${h}`,
        key: h,
        role: "tabpanel",
        "aria-labelledby": d.tabsTitles[h]
      }, [
        H(d.$slots, `tab-${h}`)
      ], 8, m0)), [
        [Ao, a.value === h]
      ])), 128))
    ]));
  }
}), v0 = ["aria-controlledby", "onMouseleave", "onKeydown"], w0 = {}, b0 = /* @__PURE__ */ U({
  ...w0,
  __name: "UITooltip",
  props: {
    forceHidden: { type: Boolean, default: !1 },
    forceShown: { type: Boolean, default: !1 },
    hideArrow: { type: Boolean, default: !1 },
    hideDelay: { default: 0 },
    placement: { default: "bottom" },
    showWhenClicked: { type: Boolean, default: !1 }
  },
  emits: ["show", "hide"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = Fe(), a = q(), r = Ne(), l = `${r}-tooltip-content`, s = Pe("tooltipContentRef"), c = q(!1), u = k(() => c.value ? "" : n.placement.includes("top") ? "emptyHoverAreaBottom" : n.placement.includes("bottom") ? "emptyHoverAreaTop" : n.placement.includes("left") ? "emptyHoverAreaRight" : n.placement.includes("right") ? "emptyHoverAreaLeft" : "");
    function d(m, C = !0) {
      !C || c.value || n.forceShown || (clearTimeout(a.value), a.value = setTimeout(() => m(!1), n.hideDelay));
    }
    function f() {
      clearTimeout(a.value);
    }
    function h(m) {
      var C;
      n.forceHidden || n.forceShown || (clearTimeout(a.value), m(!0), (C = s.value) == null || C.focus());
    }
    function v(m, C) {
      var x;
      if (!(!n.showWhenClicked || n.forceHidden || n.forceShown)) {
        if (!c.value) {
          c.value = !0, m(!0), (x = s.value) == null || x.focus();
          return;
        }
        c.value = !c.value, C && m(!1);
      }
    }
    function y(m) {
      m(!1), c.value = !1;
    }
    function b() {
      c.value = !1;
    }
    return (m, C) => (g(), P(wi, {
      placement: m.placement,
      "has-arrow": !m.hideArrow,
      "force-show-floating-el": m.forceShown,
      onClickOutside: b,
      onHideFloating: C[0] || (C[0] = (x) => o("hide")),
      onShowFloating: C[1] || (C[1] = (x) => o("show"))
    }, {
      reference: G(({ toggleContentDisplay: x, isFloatingElDisplayed: T }) => [
        A(te)(i.referenceEl) ? H(m.$slots, "referenceEl", {
          key: 0,
          id: A(r),
          ariaDescribedby: l,
          ariaExpanded: T,
          onClick: (L) => v(x, T),
          onMouseenter: (L) => h(x),
          onMouseleave: (L) => d(x, T),
          onKeydown: gt((L) => y(x), ["escape"])
        }, void 0, !0) : E("", !0)
      ]),
      floating: G(({ toggleContentDisplay: x }) => [
        A(te)(i.tooltipContent) ? (g(), I("div", {
          key: 0,
          id: l,
          ref: "tooltipContentRef",
          class: F(["tw-text-body-xs tw-relative tw-z-[999999] tw-flex tw-max-w-[224px] tw-flex-col tw-gap-y-sm tw-rounded-sm tw-bg-fill-alt tw-p-sm tw-text-inverse focus:tw-outline-none", u.value]),
          "aria-controlledby": A(r),
          tabindex: "-1",
          role: "tooltip",
          onMouseenter: f,
          onMouseleave: (T) => d(x),
          onKeydown: gt((T) => y(x), ["escape"])
        }, [
          H(m.$slots, "tooltipContent", {}, void 0, !0)
        ], 42, v0)) : E("", !0)
      ]),
      _: 3
    }, 8, ["placement", "has-arrow", "force-show-floating-el"]));
  }
}), P0 = /* @__PURE__ */ ai(b0, [["__scopeId", "data-v-5ddfca42"]]);
Zo(Wi);
export {
  x0 as Iconify,
  Ha as UIBanner,
  k0 as UIBannerMulti,
  oo as UIButton,
  T0 as UIButtonLink,
  ti as UIChip,
  S0 as UIChipButton,
  I0 as UIChipSelection,
  A0 as UIDropdownMenu,
  E0 as UIDropdownMenuList,
  M0 as UIDropdownMenuListItem,
  B as UIIcon,
  es as UIInputCheckbox,
  z0 as UIInputPassword,
  F0 as UIInputText,
  N0 as UIInputTextarea,
  $0 as UIInputToggleCheckbox,
  O0 as UIInputToggleRadio,
  L0 as UIModal,
  D0 as UISelectionCard,
  R0 as UITab,
  r0 as UITag,
  P0 as UITooltip,
  C0 as grooverUITailwindPlugin
};
